(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],2:[function(require,module,exports){
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var postfix = _interopDefault(require('@tannin/postfix'));
var evaluate = _interopDefault(require('@tannin/evaluate'));

/**
 * Given a C expression, returns a function which can be called to evaluate its
 * result.
 *
 * @example
 *
 * ```js
 * import compile from '@tannin/compile';
 *
 * const evaluate = compile( 'n > 1' );
 *
 * evaluate( { n: 2 } );
 * // ⇒ true
 * ```
 *
 * @param {string} expression C expression.
 *
 * @return {(variables?:{[variable:string]:*})=>*} Compiled evaluator.
 */
function compile( expression ) {
	var terms = postfix( expression );

	return function( variables ) {
		return evaluate( terms, variables );
	};
}

module.exports = compile;

},{"@tannin/evaluate":3,"@tannin/postfix":5}],3:[function(require,module,exports){
'use strict';

/**
 * Operator callback functions.
 *
 * @type {Object}
 */
var OPERATORS = {
	'!': function( a ) {
		return ! a;
	},
	'*': function( a, b ) {
		return a * b;
	},
	'/': function( a, b ) {
		return a / b;
	},
	'%': function( a, b ) {
		return a % b;
	},
	'+': function( a, b ) {
		return a + b;
	},
	'-': function( a, b ) {
		return a - b;
	},
	'<': function( a, b ) {
		return a < b;
	},
	'<=': function( a, b ) {
		return a <= b;
	},
	'>': function( a, b ) {
		return a > b;
	},
	'>=': function( a, b ) {
		return a >= b;
	},
	'==': function( a, b ) {
		return a === b;
	},
	'!=': function( a, b ) {
		return a !== b;
	},
	'&&': function( a, b ) {
		return a && b;
	},
	'||': function( a, b ) {
		return a || b;
	},
	'?:': function( a, b, c ) {
		if ( a ) {
			throw b;
		}

		return c;
	},
};

/**
 * Given an array of postfix terms and operand variables, returns the result of
 * the postfix evaluation.
 *
 * @example
 *
 * ```js
 * import evaluate from '@tannin/evaluate';
 *
 * // 3 + 4 * 5 / 6 ⇒ '3 4 5 * 6 / +'
 * const terms = [ '3', '4', '5', '*', '6', '/', '+' ];
 *
 * evaluate( terms, {} );
 * // ⇒ 6.333333333333334
 * ```
 *
 * @param {string[]} postfix   Postfix terms.
 * @param {Object}   variables Operand variables.
 *
 * @return {*} Result of evaluation.
 */
function evaluate( postfix, variables ) {
	var stack = [],
		i, j, args, getOperatorResult, term, value;

	for ( i = 0; i < postfix.length; i++ ) {
		term = postfix[ i ];

		getOperatorResult = OPERATORS[ term ];
		if ( getOperatorResult ) {
			// Pop from stack by number of function arguments.
			j = getOperatorResult.length;
			args = Array( j );
			while ( j-- ) {
				args[ j ] = stack.pop();
			}

			try {
				value = getOperatorResult.apply( null, args );
			} catch ( earlyReturn ) {
				return earlyReturn;
			}
		} else if ( variables.hasOwnProperty( term ) ) {
			value = variables[ term ];
		} else {
			value = +term;
		}

		stack.push( value );
	}

	return stack[ 0 ];
}

module.exports = evaluate;

},{}],4:[function(require,module,exports){
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var compile = _interopDefault(require('@tannin/compile'));

/**
 * Given a C expression, returns a function which, when called with a value,
 * evaluates the result with the value assumed to be the "n" variable of the
 * expression. The result will be coerced to its numeric equivalent.
 *
 * @param {string} expression C expression.
 *
 * @return {Function} Evaluator function.
 */
function pluralForms( expression ) {
	var evaluate = compile( expression );

	return function( n ) {
		return +evaluate( { n: n } );
	};
}

module.exports = pluralForms;

},{"@tannin/compile":2}],5:[function(require,module,exports){
'use strict';

var PRECEDENCE, OPENERS, TERMINATORS, PATTERN;

/**
 * Operator precedence mapping.
 *
 * @type {Object}
 */
PRECEDENCE = {
	'(': 9,
	'!': 8,
	'*': 7,
	'/': 7,
	'%': 7,
	'+': 6,
	'-': 6,
	'<': 5,
	'<=': 5,
	'>': 5,
	'>=': 5,
	'==': 4,
	'!=': 4,
	'&&': 3,
	'||': 2,
	'?': 1,
	'?:': 1,
};

/**
 * Characters which signal pair opening, to be terminated by terminators.
 *
 * @type {string[]}
 */
OPENERS = [ '(', '?' ];

/**
 * Characters which signal pair termination, the value an array with the
 * opener as its first member. The second member is an optional operator
 * replacement to push to the stack.
 *
 * @type {string[]}
 */
TERMINATORS = {
	')': [ '(' ],
	':': [ '?', '?:' ],
};

/**
 * Pattern matching operators and openers.
 *
 * @type {RegExp}
 */
PATTERN = /<=|>=|==|!=|&&|\|\||\?:|\(|!|\*|\/|%|\+|-|<|>|\?|\)|:/;

/**
 * Given a C expression, returns the equivalent postfix (Reverse Polish)
 * notation terms as an array.
 *
 * If a postfix string is desired, simply `.join( ' ' )` the result.
 *
 * @example
 *
 * ```js
 * import postfix from '@tannin/postfix';
 *
 * postfix( 'n > 1' );
 * // ⇒ [ 'n', '1', '>' ]
 * ```
 *
 * @param {string} expression C expression.
 *
 * @return {string[]} Postfix terms.
 */
function postfix( expression ) {
	var terms = [],
		stack = [],
		match, operator, term, element;

	while ( ( match = expression.match( PATTERN ) ) ) {
		operator = match[ 0 ];

		// Term is the string preceding the operator match. It may contain
		// whitespace, and may be empty (if operator is at beginning).
		term = expression.substr( 0, match.index ).trim();
		if ( term ) {
			terms.push( term );
		}

		while ( ( element = stack.pop() ) ) {
			if ( TERMINATORS[ operator ] ) {
				if ( TERMINATORS[ operator ][ 0 ] === element ) {
					// Substitution works here under assumption that because
					// the assigned operator will no longer be a terminator, it
					// will be pushed to the stack during the condition below.
					operator = TERMINATORS[ operator ][ 1 ] || operator;
					break;
				}
			} else if ( OPENERS.indexOf( element ) >= 0 || PRECEDENCE[ element ] < PRECEDENCE[ operator ] ) {
				// Push to stack if either an opener or when pop reveals an
				// element of lower precedence.
				stack.push( element );
				break;
			}

			// For each popped from stack, push to terms.
			terms.push( element );
		}

		if ( ! TERMINATORS[ operator ] ) {
			stack.push( operator );
		}

		// Slice matched fragment from expression to continue match.
		expression = expression.substr( match.index + operator.length );
	}

	// Push remainder of operand, if exists, to terms.
	expression = expression.trim();
	if ( expression ) {
		terms.push( expression );
	}

	// Pop remaining items from stack into terms.
	return terms.concat( stack.reverse() );
}

module.exports = postfix;

},{}],6:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validateNamespace = _interopRequireDefault(require("./validateNamespace.js"));
var _validateHookName = _interopRequireDefault(require("./validateHookName.js"));
/**
 * Internal dependencies
 */

/**
 * @callback AddHook
 *
 * Adds the hook to the appropriate hooks container.
 *
 * @param {string}               hookName      Name of hook to add
 * @param {string}               namespace     The unique namespace identifying the callback in the form `vendor/plugin/function`.
 * @param {import('.').Callback} callback      Function to call when the hook is run
 * @param {number}               [priority=10] Priority of this hook
 */

/**
 * Returns a function which, when invoked, will add a hook.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {AddHook} Function that adds a new hook.
 */
function createAddHook(hooks, storeKey) {
  return function addHook(hookName, namespace, callback, priority = 10) {
    const hooksStore = hooks[storeKey];
    if (!(0, _validateHookName.default)(hookName)) {
      return;
    }
    if (!(0, _validateNamespace.default)(namespace)) {
      return;
    }
    if ('function' !== typeof callback) {
      // eslint-disable-next-line no-console
      console.error('The hook callback must be a function.');
      return;
    }

    // Validate numeric priority
    if ('number' !== typeof priority) {
      // eslint-disable-next-line no-console
      console.error('If specified, the hook priority must be a number.');
      return;
    }
    const handler = {
      callback,
      priority,
      namespace
    };
    if (hooksStore[hookName]) {
      // Find the correct insert index of the new hook.
      const handlers = hooksStore[hookName].handlers;

      /** @type {number} */
      let i;
      for (i = handlers.length; i > 0; i--) {
        if (priority >= handlers[i - 1].priority) {
          break;
        }
      }
      if (i === handlers.length) {
        // If append, operate via direct assignment.
        handlers[i] = handler;
      } else {
        // Otherwise, insert before index via splice.
        handlers.splice(i, 0, handler);
      }

      // We may also be currently executing this hook.  If the callback
      // we're adding would come after the current callback, there's no
      // problem; otherwise we need to increase the execution index of
      // any other runs by 1 to account for the added element.
      hooksStore.__current.forEach(hookInfo => {
        if (hookInfo.name === hookName && hookInfo.currentIndex >= i) {
          hookInfo.currentIndex++;
        }
      });
    } else {
      // This is the first hook of its type.
      hooksStore[hookName] = {
        handlers: [handler],
        runs: 0
      };
    }
    if (hookName !== 'hookAdded') {
      hooks.doAction('hookAdded', hookName, namespace, callback, priority);
    }
  };
}
var _default = exports.default = createAddHook;

},{"./validateHookName.js":15,"./validateNamespace.js":16,"@babel/runtime/helpers/interopRequireDefault":1}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Returns a function which, when invoked, will return the name of the
 * currently running hook, or `null` if no hook of the given type is currently
 * running.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {() => string | null} Function that returns the current hook name or null.
 */
function createCurrentHook(hooks, storeKey) {
  return function currentHook() {
    var _currentArray$at$name;
    const hooksStore = hooks[storeKey];
    const currentArray = Array.from(hooksStore.__current);
    return (_currentArray$at$name = currentArray.at(-1)?.name) !== null && _currentArray$at$name !== void 0 ? _currentArray$at$name : null;
  };
}
var _default = exports.default = createCurrentHook;

},{}],8:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validateHookName = _interopRequireDefault(require("./validateHookName.js"));
/**
 * Internal dependencies
 */

/**
 * @callback DidHook
 *
 * Returns the number of times an action has been fired.
 *
 * @param {string} hookName The hook name to check.
 *
 * @return {number | undefined} The number of times the hook has run.
 */

/**
 * Returns a function which, when invoked, will return the number of times a
 * hook has been called.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {DidHook} Function that returns a hook's call count.
 */
function createDidHook(hooks, storeKey) {
  return function didHook(hookName) {
    const hooksStore = hooks[storeKey];
    if (!(0, _validateHookName.default)(hookName)) {
      return;
    }
    return hooksStore[hookName] && hooksStore[hookName].runs ? hooksStore[hookName].runs : 0;
  };
}
var _default = exports.default = createDidHook;

},{"./validateHookName.js":15,"@babel/runtime/helpers/interopRequireDefault":1}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @callback DoingHook
 * Returns whether a hook is currently being executed.
 *
 * @param {string} [hookName] The name of the hook to check for.  If
 *                            omitted, will check for any hook being executed.
 *
 * @return {boolean} Whether the hook is being executed.
 */

/**
 * Returns a function which, when invoked, will return whether a hook is
 * currently being executed.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {DoingHook} Function that returns whether a hook is currently
 *                     being executed.
 */
function createDoingHook(hooks, storeKey) {
  return function doingHook(hookName) {
    const hooksStore = hooks[storeKey];

    // If the hookName was not passed, check for any current hook.
    if ('undefined' === typeof hookName) {
      return hooksStore.__current.size > 0;
    }

    // Find if the `hookName` hook is in `__current`.
    return Array.from(hooksStore.__current).some(hook => hook.name === hookName);
  };
}
var _default = exports.default = createDoingHook;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @callback HasHook
 *
 * Returns whether any handlers are attached for the given hookName and optional namespace.
 *
 * @param {string} hookName    The name of the hook to check for.
 * @param {string} [namespace] Optional. The unique namespace identifying the callback
 *                             in the form `vendor/plugin/function`.
 *
 * @return {boolean} Whether there are handlers that are attached to the given hook.
 */
/**
 * Returns a function which, when invoked, will return whether any handlers are
 * attached to a particular hook.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {HasHook} Function that returns whether any handlers are
 *                   attached to a particular hook and optional namespace.
 */
function createHasHook(hooks, storeKey) {
  return function hasHook(hookName, namespace) {
    const hooksStore = hooks[storeKey];

    // Use the namespace if provided.
    if ('undefined' !== typeof namespace) {
      return hookName in hooksStore && hooksStore[hookName].handlers.some(hook => hook.namespace === namespace);
    }
    return hookName in hooksStore;
  };
}
var _default = exports.default = createHasHook;

},{}],11:[function(require,module,exports){
/* wp:polyfill */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._Hooks = void 0;
var _createAddHook = _interopRequireDefault(require("./createAddHook"));
var _createRemoveHook = _interopRequireDefault(require("./createRemoveHook"));
var _createHasHook = _interopRequireDefault(require("./createHasHook"));
var _createRunHook = _interopRequireDefault(require("./createRunHook"));
var _createCurrentHook = _interopRequireDefault(require("./createCurrentHook"));
var _createDoingHook = _interopRequireDefault(require("./createDoingHook"));
var _createDidHook = _interopRequireDefault(require("./createDidHook"));
/**
 * Internal dependencies
 */

/**
 * Internal class for constructing hooks. Use `createHooks()` function
 *
 * Note, it is necessary to expose this class to make its type public.
 *
 * @private
 */
class _Hooks {
  constructor() {
    /** @type {import('.').Store} actions */
    this.actions = Object.create(null);
    this.actions.__current = new Set();

    /** @type {import('.').Store} filters */
    this.filters = Object.create(null);
    this.filters.__current = new Set();
    this.addAction = (0, _createAddHook.default)(this, 'actions');
    this.addFilter = (0, _createAddHook.default)(this, 'filters');
    this.removeAction = (0, _createRemoveHook.default)(this, 'actions');
    this.removeFilter = (0, _createRemoveHook.default)(this, 'filters');
    this.hasAction = (0, _createHasHook.default)(this, 'actions');
    this.hasFilter = (0, _createHasHook.default)(this, 'filters');
    this.removeAllActions = (0, _createRemoveHook.default)(this, 'actions', true);
    this.removeAllFilters = (0, _createRemoveHook.default)(this, 'filters', true);
    this.doAction = (0, _createRunHook.default)(this, 'actions', false, false);
    this.doActionAsync = (0, _createRunHook.default)(this, 'actions', false, true);
    this.applyFilters = (0, _createRunHook.default)(this, 'filters', true, false);
    this.applyFiltersAsync = (0, _createRunHook.default)(this, 'filters', true, true);
    this.currentAction = (0, _createCurrentHook.default)(this, 'actions');
    this.currentFilter = (0, _createCurrentHook.default)(this, 'filters');
    this.doingAction = (0, _createDoingHook.default)(this, 'actions');
    this.doingFilter = (0, _createDoingHook.default)(this, 'filters');
    this.didAction = (0, _createDidHook.default)(this, 'actions');
    this.didFilter = (0, _createDidHook.default)(this, 'filters');
  }
}

/** @typedef {_Hooks} Hooks */

/**
 * Returns an instance of the hooks object.
 *
 * @return {Hooks} A Hooks instance.
 */
exports._Hooks = _Hooks;
function createHooks() {
  return new _Hooks();
}
var _default = exports.default = createHooks;

},{"./createAddHook":6,"./createCurrentHook":7,"./createDidHook":8,"./createDoingHook":9,"./createHasHook":10,"./createRemoveHook":12,"./createRunHook":13,"@babel/runtime/helpers/interopRequireDefault":1}],12:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validateNamespace = _interopRequireDefault(require("./validateNamespace.js"));
var _validateHookName = _interopRequireDefault(require("./validateHookName.js"));
/**
 * Internal dependencies
 */

/**
 * @callback RemoveHook
 * Removes the specified callback (or all callbacks) from the hook with a given hookName
 * and namespace.
 *
 * @param {string} hookName  The name of the hook to modify.
 * @param {string} namespace The unique namespace identifying the callback in the
 *                           form `vendor/plugin/function`.
 *
 * @return {number | undefined} The number of callbacks removed.
 */

/**
 * Returns a function which, when invoked, will remove a specified hook or all
 * hooks by the given name.
 *
 * @param {import('.').Hooks}    hooks             Hooks instance.
 * @param {import('.').StoreKey} storeKey
 * @param {boolean}              [removeAll=false] Whether to remove all callbacks for a hookName,
 *                                                 without regard to namespace. Used to create
 *                                                 `removeAll*` functions.
 *
 * @return {RemoveHook} Function that removes hooks.
 */
function createRemoveHook(hooks, storeKey, removeAll = false) {
  return function removeHook(hookName, namespace) {
    const hooksStore = hooks[storeKey];
    if (!(0, _validateHookName.default)(hookName)) {
      return;
    }
    if (!removeAll && !(0, _validateNamespace.default)(namespace)) {
      return;
    }

    // Bail if no hooks exist by this name.
    if (!hooksStore[hookName]) {
      return 0;
    }
    let handlersRemoved = 0;
    if (removeAll) {
      handlersRemoved = hooksStore[hookName].handlers.length;
      hooksStore[hookName] = {
        runs: hooksStore[hookName].runs,
        handlers: []
      };
    } else {
      // Try to find the specified callback to remove.
      const handlers = hooksStore[hookName].handlers;
      for (let i = handlers.length - 1; i >= 0; i--) {
        if (handlers[i].namespace === namespace) {
          handlers.splice(i, 1);
          handlersRemoved++;
          // This callback may also be part of a hook that is
          // currently executing.  If the callback we're removing
          // comes after the current callback, there's no problem;
          // otherwise we need to decrease the execution index of any
          // other runs by 1 to account for the removed element.
          hooksStore.__current.forEach(hookInfo => {
            if (hookInfo.name === hookName && hookInfo.currentIndex >= i) {
              hookInfo.currentIndex--;
            }
          });
        }
      }
    }
    if (hookName !== 'hookRemoved') {
      hooks.doAction('hookRemoved', hookName, namespace);
    }
    return handlersRemoved;
  };
}
var _default = exports.default = createRemoveHook;

},{"./validateHookName.js":15,"./validateNamespace.js":16,"@babel/runtime/helpers/interopRequireDefault":1}],13:[function(require,module,exports){
(function (process){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Returns a function which, when invoked, will execute all callbacks
 * registered to a hook of the specified type, optionally returning the final
 * value of the call chain.
 *
 * @param {import('.').Hooks}    hooks          Hooks instance.
 * @param {import('.').StoreKey} storeKey
 * @param {boolean}              returnFirstArg Whether each hook callback is expected to return its first argument.
 * @param {boolean}              async          Whether the hook callback should be run asynchronously
 *
 * @return {(hookName:string, ...args: unknown[]) => undefined|unknown} Function that runs hook callbacks.
 */
function createRunHook(hooks, storeKey, returnFirstArg, async) {
  return function runHook(hookName, ...args) {
    const hooksStore = hooks[storeKey];
    if (!hooksStore[hookName]) {
      hooksStore[hookName] = {
        handlers: [],
        runs: 0
      };
    }
    hooksStore[hookName].runs++;
    const handlers = hooksStore[hookName].handlers;

    // The following code is stripped from production builds.
    if ('production' !== process.env.NODE_ENV) {
      // Handle any 'all' hooks registered.
      if ('hookAdded' !== hookName && hooksStore.all) {
        handlers.push(...hooksStore.all.handlers);
      }
    }
    if (!handlers || !handlers.length) {
      return returnFirstArg ? args[0] : undefined;
    }
    const hookInfo = {
      name: hookName,
      currentIndex: 0
    };
    async function asyncRunner() {
      try {
        hooksStore.__current.add(hookInfo);
        let result = returnFirstArg ? args[0] : undefined;
        while (hookInfo.currentIndex < handlers.length) {
          const handler = handlers[hookInfo.currentIndex];
          result = await handler.callback.apply(null, args);
          if (returnFirstArg) {
            args[0] = result;
          }
          hookInfo.currentIndex++;
        }
        return returnFirstArg ? result : undefined;
      } finally {
        hooksStore.__current.delete(hookInfo);
      }
    }
    function syncRunner() {
      try {
        hooksStore.__current.add(hookInfo);
        let result = returnFirstArg ? args[0] : undefined;
        while (hookInfo.currentIndex < handlers.length) {
          const handler = handlers[hookInfo.currentIndex];
          result = handler.callback.apply(null, args);
          if (returnFirstArg) {
            args[0] = result;
          }
          hookInfo.currentIndex++;
        }
        return returnFirstArg ? result : undefined;
      } finally {
        hooksStore.__current.delete(hookInfo);
      }
    }
    return (async ? asyncRunner : syncRunner)();
  };
}
var _default = exports.default = createRunHook;

}).call(this)}).call(this,require('_process'))
},{"_process":19}],14:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyFiltersAsync = exports.applyFilters = exports.addFilter = exports.addAction = exports.actions = void 0;
Object.defineProperty(exports, "createHooks", {
  enumerable: true,
  get: function () {
    return _createHooks.default;
  }
});
exports.removeFilter = exports.removeAllFilters = exports.removeAllActions = exports.removeAction = exports.hasFilter = exports.hasAction = exports.filters = exports.doingFilter = exports.doingAction = exports.doActionAsync = exports.doAction = exports.didFilter = exports.didAction = exports.defaultHooks = exports.currentFilter = exports.currentAction = void 0;
var _createHooks = _interopRequireDefault(require("./createHooks"));
/**
 * Internal dependencies
 */

/** @typedef {(...args: any[])=>any} Callback */

/**
 * @typedef Handler
 * @property {Callback} callback  The callback
 * @property {string}   namespace The namespace
 * @property {number}   priority  The namespace
 */

/**
 * @typedef Hook
 * @property {Handler[]} handlers Array of handlers
 * @property {number}    runs     Run counter
 */

/**
 * @typedef Current
 * @property {string} name         Hook name
 * @property {number} currentIndex The index
 */

/**
 * @typedef {Record<string, Hook> & {__current: Set<Current>}} Store
 */

/**
 * @typedef {'actions' | 'filters'} StoreKey
 */

/**
 * @typedef {import('./createHooks').Hooks} Hooks
 */

const defaultHooks = exports.defaultHooks = (0, _createHooks.default)();
const {
  addAction,
  addFilter,
  removeAction,
  removeFilter,
  hasAction,
  hasFilter,
  removeAllActions,
  removeAllFilters,
  doAction,
  doActionAsync,
  applyFilters,
  applyFiltersAsync,
  currentAction,
  currentFilter,
  doingAction,
  doingFilter,
  didAction,
  didFilter,
  actions,
  filters
} = defaultHooks;
exports.filters = filters;
exports.actions = actions;
exports.didFilter = didFilter;
exports.didAction = didAction;
exports.doingFilter = doingFilter;
exports.doingAction = doingAction;
exports.currentFilter = currentFilter;
exports.currentAction = currentAction;
exports.applyFiltersAsync = applyFiltersAsync;
exports.applyFilters = applyFilters;
exports.doActionAsync = doActionAsync;
exports.doAction = doAction;
exports.removeAllFilters = removeAllFilters;
exports.removeAllActions = removeAllActions;
exports.hasFilter = hasFilter;
exports.hasAction = hasAction;
exports.removeFilter = removeFilter;
exports.removeAction = removeAction;
exports.addFilter = addFilter;
exports.addAction = addAction;

},{"./createHooks":11,"@babel/runtime/helpers/interopRequireDefault":1}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Validate a hookName string.
 *
 * @param {string} hookName The hook name to validate. Should be a non empty string containing
 *                          only numbers, letters, dashes, periods and underscores. Also,
 *                          the hook name cannot begin with `__`.
 *
 * @return {boolean} Whether the hook name is valid.
 */
function validateHookName(hookName) {
  if ('string' !== typeof hookName || '' === hookName) {
    // eslint-disable-next-line no-console
    console.error('The hook name must be a non-empty string.');
    return false;
  }
  if (/^__/.test(hookName)) {
    // eslint-disable-next-line no-console
    console.error('The hook name cannot begin with `__`.');
    return false;
  }
  if (!/^[a-zA-Z][a-zA-Z0-9_.-]*$/.test(hookName)) {
    // eslint-disable-next-line no-console
    console.error('The hook name can only contain numbers, letters, dashes, periods and underscores.');
    return false;
  }
  return true;
}
var _default = exports.default = validateHookName;

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Validate a namespace string.
 *
 * @param {string} namespace The namespace to validate - should take the form
 *                           `vendor/plugin/function`.
 *
 * @return {boolean} Whether the namespace is valid.
 */
function validateNamespace(namespace) {
  if ('string' !== typeof namespace || '' === namespace) {
    // eslint-disable-next-line no-console
    console.error('The namespace must be a non-empty string.');
    return false;
  }
  if (!/^[a-zA-Z][a-zA-Z0-9_.\-\/]*$/.test(namespace)) {
    // eslint-disable-next-line no-console
    console.error('The namespace can only contain numbers, letters, dashes, periods, underscores and slashes.');
    return false;
  }
  return true;
}
var _default = exports.default = validateNamespace;

},{}],17:[function(require,module,exports){
/* wp:polyfill */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createI18n = void 0;
var _tannin = _interopRequireDefault(require("tannin"));
/**
 * External dependencies
 */

/**
 * @typedef {Record<string,any>} LocaleData
 */

/**
 * Default locale data to use for Tannin domain when not otherwise provided.
 * Assumes an English plural forms expression.
 *
 * @type {LocaleData}
 */
const DEFAULT_LOCALE_DATA = {
  '': {
    /** @param {number} n */
    plural_forms(n) {
      return n === 1 ? 0 : 1;
    }
  }
};

/*
 * Regular expression that matches i18n hooks like `i18n.gettext`, `i18n.ngettext`,
 * `i18n.gettext_domain` or `i18n.ngettext_with_context` or `i18n.has_translation`.
 */
const I18N_HOOK_REGEXP = /^i18n\.(n?gettext|has_translation)(_|$)/;

/**
 * @typedef {(domain?: string) => LocaleData} GetLocaleData
 *
 * Returns locale data by domain in a
 * Jed-formatted JSON object shape.
 *
 * @see http://messageformat.github.io/Jed/
 */
/**
 * @typedef {(data?: LocaleData, domain?: string) => void} SetLocaleData
 *
 * Merges locale data into the Tannin instance by domain. Note that this
 * function will overwrite the domain configuration. Accepts data in a
 * Jed-formatted JSON object shape.
 *
 * @see http://messageformat.github.io/Jed/
 */
/**
 * @typedef {(data?: LocaleData, domain?: string) => void} AddLocaleData
 *
 * Merges locale data into the Tannin instance by domain. Note that this
 * function will also merge the domain configuration. Accepts data in a
 * Jed-formatted JSON object shape.
 *
 * @see http://messageformat.github.io/Jed/
 */
/**
 * @typedef {(data?: LocaleData, domain?: string) => void} ResetLocaleData
 *
 * Resets all current Tannin instance locale data and sets the specified
 * locale data for the domain. Accepts data in a Jed-formatted JSON object shape.
 *
 * @see http://messageformat.github.io/Jed/
 */
/** @typedef {() => void} SubscribeCallback */
/** @typedef {() => void} UnsubscribeCallback */
/**
 * @typedef {(callback: SubscribeCallback) => UnsubscribeCallback} Subscribe
 *
 * Subscribes to changes of locale data
 */
/**
 * @typedef {(domain?: string) => string} GetFilterDomain
 * Retrieve the domain to use when calling domain-specific filters.
 */
/**
 * @typedef {(text: string, domain?: string) => string} __
 *
 * Retrieve the translation of text.
 *
 * @see https://developer.wordpress.org/reference/functions/__/
 */
/**
 * @typedef {(text: string, context: string, domain?: string) => string} _x
 *
 * Retrieve translated string with gettext context.
 *
 * @see https://developer.wordpress.org/reference/functions/_x/
 */
/**
 * @typedef {(single: string, plural: string, number: number, domain?: string) => string} _n
 *
 * Translates and retrieves the singular or plural form based on the supplied
 * number.
 *
 * @see https://developer.wordpress.org/reference/functions/_n/
 */
/**
 * @typedef {(single: string, plural: string, number: number, context: string, domain?: string) => string} _nx
 *
 * Translates and retrieves the singular or plural form based on the supplied
 * number, with gettext context.
 *
 * @see https://developer.wordpress.org/reference/functions/_nx/
 */
/**
 * @typedef {() => boolean} IsRtl
 *
 * Check if current locale is RTL.
 *
 * **RTL (Right To Left)** is a locale property indicating that text is written from right to left.
 * For example, the `he` locale (for Hebrew) specifies right-to-left. Arabic (ar) is another common
 * language written RTL. The opposite of RTL, LTR (Left To Right) is used in other languages,
 * including English (`en`, `en-US`, `en-GB`, etc.), Spanish (`es`), and French (`fr`).
 */
/**
 * @typedef {(single: string, context?: string, domain?: string) => boolean} HasTranslation
 *
 * Check if there is a translation for a given string in singular form.
 */
/** @typedef {import('@wordpress/hooks').Hooks} Hooks */

/**
 * An i18n instance
 *
 * @typedef I18n
 * @property {GetLocaleData}   getLocaleData   Returns locale data by domain in a Jed-formatted JSON object shape.
 * @property {SetLocaleData}   setLocaleData   Merges locale data into the Tannin instance by domain. Note that this
 *                                             function will overwrite the domain configuration. Accepts data in a
 *                                             Jed-formatted JSON object shape.
 * @property {AddLocaleData}   addLocaleData   Merges locale data into the Tannin instance by domain. Note that this
 *                                             function will also merge the domain configuration. Accepts data in a
 *                                             Jed-formatted JSON object shape.
 * @property {ResetLocaleData} resetLocaleData Resets all current Tannin instance locale data and sets the specified
 *                                             locale data for the domain. Accepts data in a Jed-formatted JSON object shape.
 * @property {Subscribe}       subscribe       Subscribes to changes of Tannin locale data.
 * @property {__}              __              Retrieve the translation of text.
 * @property {_x}              _x              Retrieve translated string with gettext context.
 * @property {_n}              _n              Translates and retrieves the singular or plural form based on the supplied
 *                                             number.
 * @property {_nx}             _nx             Translates and retrieves the singular or plural form based on the supplied
 *                                             number, with gettext context.
 * @property {IsRtl}           isRTL           Check if current locale is RTL.
 * @property {HasTranslation}  hasTranslation  Check if there is a translation for a given string.
 */

/**
 * Create an i18n instance
 *
 * @param {LocaleData} [initialData]   Locale data configuration.
 * @param {string}     [initialDomain] Domain for which configuration applies.
 * @param {Hooks}      [hooks]         Hooks implementation.
 *
 * @return {I18n} I18n instance.
 */
const createI18n = (initialData, initialDomain, hooks) => {
  /**
   * The underlying instance of Tannin to which exported functions interface.
   *
   * @type {Tannin}
   */
  const tannin = new _tannin.default({});
  const listeners = new Set();
  const notifyListeners = () => {
    listeners.forEach(listener => listener());
  };

  /**
   * Subscribe to changes of locale data.
   *
   * @param {SubscribeCallback} callback Subscription callback.
   * @return {UnsubscribeCallback} Unsubscribe callback.
   */
  const subscribe = callback => {
    listeners.add(callback);
    return () => listeners.delete(callback);
  };

  /** @type {GetLocaleData} */
  const getLocaleData = (domain = 'default') => tannin.data[domain];

  /**
   * @param {LocaleData} [data]
   * @param {string}     [domain]
   */
  const doSetLocaleData = (data, domain = 'default') => {
    tannin.data[domain] = {
      ...tannin.data[domain],
      ...data
    };

    // Populate default domain configuration (supported locale date which omits
    // a plural forms expression).
    tannin.data[domain][''] = {
      ...DEFAULT_LOCALE_DATA[''],
      ...tannin.data[domain]?.['']
    };

    // Clean up cached plural forms functions cache as it might be updated.
    delete tannin.pluralForms[domain];
  };

  /** @type {SetLocaleData} */
  const setLocaleData = (data, domain) => {
    doSetLocaleData(data, domain);
    notifyListeners();
  };

  /** @type {AddLocaleData} */
  const addLocaleData = (data, domain = 'default') => {
    tannin.data[domain] = {
      ...tannin.data[domain],
      ...data,
      // Populate default domain configuration (supported locale date which omits
      // a plural forms expression).
      '': {
        ...DEFAULT_LOCALE_DATA[''],
        ...tannin.data[domain]?.[''],
        ...data?.['']
      }
    };

    // Clean up cached plural forms functions cache as it might be updated.
    delete tannin.pluralForms[domain];
    notifyListeners();
  };

  /** @type {ResetLocaleData} */
  const resetLocaleData = (data, domain) => {
    // Reset all current Tannin locale data.
    tannin.data = {};

    // Reset cached plural forms functions cache.
    tannin.pluralForms = {};
    setLocaleData(data, domain);
  };

  /**
   * Wrapper for Tannin's `dcnpgettext`. Populates default locale data if not
   * otherwise previously assigned.
   *
   * @param {string|undefined} domain   Domain to retrieve the translated text.
   * @param {string|undefined} context  Context information for the translators.
   * @param {string}           single   Text to translate if non-plural. Used as
   *                                    fallback return value on a caught error.
   * @param {string}           [plural] The text to be used if the number is
   *                                    plural.
   * @param {number}           [number] The number to compare against to use
   *                                    either the singular or plural form.
   *
   * @return {string} The translated string.
   */
  const dcnpgettext = (domain = 'default', context, single, plural, number) => {
    if (!tannin.data[domain]) {
      // Use `doSetLocaleData` to set silently, without notifying listeners.
      doSetLocaleData(undefined, domain);
    }
    return tannin.dcnpgettext(domain, context, single, plural, number);
  };

  /** @type {GetFilterDomain} */
  const getFilterDomain = (domain = 'default') => domain;

  /** @type {__} */
  const __ = (text, domain) => {
    let translation = dcnpgettext(domain, undefined, text);
    if (!hooks) {
      return translation;
    }

    /**
     * Filters text with its translation.
     *
     * @param {string} translation Translated text.
     * @param {string} text        Text to translate.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */
    translation = /** @type {string} */
    /** @type {*} */hooks.applyFilters('i18n.gettext', translation, text, domain);
    return /** @type {string} */ /** @type {*} */hooks.applyFilters('i18n.gettext_' + getFilterDomain(domain), translation, text, domain);
  };

  /** @type {_x} */
  const _x = (text, context, domain) => {
    let translation = dcnpgettext(domain, context, text);
    if (!hooks) {
      return translation;
    }

    /**
     * Filters text with its translation based on context information.
     *
     * @param {string} translation Translated text.
     * @param {string} text        Text to translate.
     * @param {string} context     Context information for the translators.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */
    translation = /** @type {string} */
    /** @type {*} */hooks.applyFilters('i18n.gettext_with_context', translation, text, context, domain);
    return /** @type {string} */ /** @type {*} */hooks.applyFilters('i18n.gettext_with_context_' + getFilterDomain(domain), translation, text, context, domain);
  };

  /** @type {_n} */
  const _n = (single, plural, number, domain) => {
    let translation = dcnpgettext(domain, undefined, single, plural, number);
    if (!hooks) {
      return translation;
    }

    /**
     * Filters the singular or plural form of a string.
     *
     * @param {string} translation Translated text.
     * @param {string} single      The text to be used if the number is singular.
     * @param {string} plural      The text to be used if the number is plural.
     * @param {string} number      The number to compare against to use either the singular or plural form.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */
    translation = /** @type {string} */
    /** @type {*} */hooks.applyFilters('i18n.ngettext', translation, single, plural, number, domain);
    return /** @type {string} */ /** @type {*} */hooks.applyFilters('i18n.ngettext_' + getFilterDomain(domain), translation, single, plural, number, domain);
  };

  /** @type {_nx} */
  const _nx = (single, plural, number, context, domain) => {
    let translation = dcnpgettext(domain, context, single, plural, number);
    if (!hooks) {
      return translation;
    }

    /**
     * Filters the singular or plural form of a string with gettext context.
     *
     * @param {string} translation Translated text.
     * @param {string} single      The text to be used if the number is singular.
     * @param {string} plural      The text to be used if the number is plural.
     * @param {string} number      The number to compare against to use either the singular or plural form.
     * @param {string} context     Context information for the translators.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */
    translation = /** @type {string} */
    /** @type {*} */hooks.applyFilters('i18n.ngettext_with_context', translation, single, plural, number, context, domain);
    return /** @type {string} */ /** @type {*} */hooks.applyFilters('i18n.ngettext_with_context_' + getFilterDomain(domain), translation, single, plural, number, context, domain);
  };

  /** @type {IsRtl} */
  const isRTL = () => {
    return 'rtl' === _x('ltr', 'text direction');
  };

  /** @type {HasTranslation} */
  const hasTranslation = (single, context, domain) => {
    const key = context ? context + '\u0004' + single : single;
    let result = !!tannin.data?.[domain !== null && domain !== void 0 ? domain : 'default']?.[key];
    if (hooks) {
      /**
       * Filters the presence of a translation in the locale data.
       *
       * @param {boolean} hasTranslation Whether the translation is present or not..
       * @param {string}  single         The singular form of the translated text (used as key in locale data)
       * @param {string}  context        Context information for the translators.
       * @param {string}  domain         Text domain. Unique identifier for retrieving translated strings.
       */
      result = /** @type { boolean } */
      /** @type {*} */hooks.applyFilters('i18n.has_translation', result, single, context, domain);
      result = /** @type { boolean } */
      /** @type {*} */hooks.applyFilters('i18n.has_translation_' + getFilterDomain(domain), result, single, context, domain);
    }
    return result;
  };
  if (initialData) {
    setLocaleData(initialData, initialDomain);
  }
  if (hooks) {
    /**
     * @param {string} hookName
     */
    const onHookAddedOrRemoved = hookName => {
      if (I18N_HOOK_REGEXP.test(hookName)) {
        notifyListeners();
      }
    };
    hooks.addAction('hookAdded', 'core/i18n', onHookAddedOrRemoved);
    hooks.addAction('hookRemoved', 'core/i18n', onHookAddedOrRemoved);
  }
  return {
    getLocaleData,
    setLocaleData,
    addLocaleData,
    resetLocaleData,
    subscribe,
    __,
    _x,
    _n,
    _nx,
    isRTL,
    hasTranslation
  };
};
exports.createI18n = createI18n;

},{"@babel/runtime/helpers/interopRequireDefault":1,"tannin":20}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribe = exports.setLocaleData = exports.resetLocaleData = exports.isRTL = exports.hasTranslation = exports.getLocaleData = exports.default = exports._x = exports._nx = exports._n = exports.__ = void 0;
var _createI18n = require("./create-i18n");
var _hooks = require("@wordpress/hooks");
/**
 * Internal dependencies
 */

/**
 * WordPress dependencies
 */

const i18n = (0, _createI18n.createI18n)(undefined, undefined, _hooks.defaultHooks);

/**
 * Default, singleton instance of `I18n`.
 */
var _default = exports.default = i18n;
/*
 * Comments in this file are duplicated from ./i18n due to
 * https://github.com/WordPress/gutenberg/pull/20318#issuecomment-590837722
 */
/**
 * @typedef {import('./create-i18n').LocaleData} LocaleData
 * @typedef {import('./create-i18n').SubscribeCallback} SubscribeCallback
 * @typedef {import('./create-i18n').UnsubscribeCallback} UnsubscribeCallback
 */
/**
 * Returns locale data by domain in a Jed-formatted JSON object shape.
 *
 * @see http://messageformat.github.io/Jed/
 *
 * @param {string} [domain] Domain for which to get the data.
 * @return {LocaleData} Locale data.
 */
const getLocaleData = exports.getLocaleData = i18n.getLocaleData.bind(i18n);

/**
 * Merges locale data into the Tannin instance by domain. Accepts data in a
 * Jed-formatted JSON object shape.
 *
 * @see http://messageformat.github.io/Jed/
 *
 * @param {LocaleData} [data]   Locale data configuration.
 * @param {string}     [domain] Domain for which configuration applies.
 */
const setLocaleData = exports.setLocaleData = i18n.setLocaleData.bind(i18n);

/**
 * Resets all current Tannin instance locale data and sets the specified
 * locale data for the domain. Accepts data in a Jed-formatted JSON object shape.
 *
 * @see http://messageformat.github.io/Jed/
 *
 * @param {LocaleData} [data]   Locale data configuration.
 * @param {string}     [domain] Domain for which configuration applies.
 */
const resetLocaleData = exports.resetLocaleData = i18n.resetLocaleData.bind(i18n);

/**
 * Subscribes to changes of locale data
 *
 * @param {SubscribeCallback} callback Subscription callback
 * @return {UnsubscribeCallback} Unsubscribe callback
 */
const subscribe = exports.subscribe = i18n.subscribe.bind(i18n);

/**
 * Retrieve the translation of text.
 *
 * @see https://developer.wordpress.org/reference/functions/__/
 *
 * @param {string} text     Text to translate.
 * @param {string} [domain] Domain to retrieve the translated text.
 *
 * @return {string} Translated text.
 */
const __ = exports.__ = i18n.__.bind(i18n);

/**
 * Retrieve translated string with gettext context.
 *
 * @see https://developer.wordpress.org/reference/functions/_x/
 *
 * @param {string} text     Text to translate.
 * @param {string} context  Context information for the translators.
 * @param {string} [domain] Domain to retrieve the translated text.
 *
 * @return {string} Translated context string without pipe.
 */
const _x = exports._x = i18n._x.bind(i18n);

/**
 * Translates and retrieves the singular or plural form based on the supplied
 * number.
 *
 * @see https://developer.wordpress.org/reference/functions/_n/
 *
 * @param {string} single   The text to be used if the number is singular.
 * @param {string} plural   The text to be used if the number is plural.
 * @param {number} number   The number to compare against to use either the
 *                          singular or plural form.
 * @param {string} [domain] Domain to retrieve the translated text.
 *
 * @return {string} The translated singular or plural form.
 */
const _n = exports._n = i18n._n.bind(i18n);

/**
 * Translates and retrieves the singular or plural form based on the supplied
 * number, with gettext context.
 *
 * @see https://developer.wordpress.org/reference/functions/_nx/
 *
 * @param {string} single   The text to be used if the number is singular.
 * @param {string} plural   The text to be used if the number is plural.
 * @param {number} number   The number to compare against to use either the
 *                          singular or plural form.
 * @param {string} context  Context information for the translators.
 * @param {string} [domain] Domain to retrieve the translated text.
 *
 * @return {string} The translated singular or plural form.
 */
const _nx = exports._nx = i18n._nx.bind(i18n);

/**
 * Check if current locale is RTL.
 *
 * **RTL (Right To Left)** is a locale property indicating that text is written from right to left.
 * For example, the `he` locale (for Hebrew) specifies right-to-left. Arabic (ar) is another common
 * language written RTL. The opposite of RTL, LTR (Left To Right) is used in other languages,
 * including English (`en`, `en-US`, `en-GB`, etc.), Spanish (`es`), and French (`fr`).
 *
 * @return {boolean} Whether locale is RTL.
 */
const isRTL = exports.isRTL = i18n.isRTL.bind(i18n);

/**
 * Check if there is a translation for a given string (in singular form).
 *
 * @param {string} single    Singular form of the string to look up.
 * @param {string} [context] Context information for the translators.
 * @param {string} [domain]  Domain to retrieve the translated text.
 * @return {boolean} Whether the translation exists or not.
 */
const hasTranslation = exports.hasTranslation = i18n.hasTranslation.bind(i18n);

},{"./create-i18n":17,"@wordpress/hooks":14}],19:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],20:[function(require,module,exports){
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var pluralForms = _interopDefault(require('@tannin/plural-forms'));

/**
 * Tannin constructor options.
 *
 * @typedef {Object} TanninOptions
 *
 * @property {string}   [contextDelimiter] Joiner in string lookup with context.
 * @property {Function} [onMissingKey]     Callback to invoke when key missing.
 */

/**
 * Domain metadata.
 *
 * @typedef {Object} TanninDomainMetadata
 *
 * @property {string}            [domain]       Domain name.
 * @property {string}            [lang]         Language code.
 * @property {(string|Function)} [plural_forms] Plural forms expression or
 *                                              function evaluator.
 */

/**
 * Domain translation pair respectively representing the singular and plural
 * translation.
 *
 * @typedef {[string,string]} TanninTranslation
 */

/**
 * Locale data domain. The key is used as reference for lookup, the value an
 * array of two string entries respectively representing the singular and plural
 * translation.
 *
 * @typedef {{[key:string]:TanninDomainMetadata|TanninTranslation,'':TanninDomainMetadata|TanninTranslation}} TanninLocaleDomain
 */

/**
 * Jed-formatted locale data.
 *
 * @see http://messageformat.github.io/Jed/
 *
 * @typedef {{[domain:string]:TanninLocaleDomain}} TanninLocaleData
 */

/**
 * Default Tannin constructor options.
 *
 * @type {TanninOptions}
 */
var DEFAULT_OPTIONS = {
	contextDelimiter: '\u0004',
	onMissingKey: null,
};

/**
 * Given a specific locale data's config `plural_forms` value, returns the
 * expression.
 *
 * @example
 *
 * ```
 * getPluralExpression( 'nplurals=2; plural=(n != 1);' ) === '(n != 1)'
 * ```
 *
 * @param {string} pf Locale data plural forms.
 *
 * @return {string} Plural forms expression.
 */
function getPluralExpression( pf ) {
	var parts, i, part;

	parts = pf.split( ';' );

	for ( i = 0; i < parts.length; i++ ) {
		part = parts[ i ].trim();
		if ( part.indexOf( 'plural=' ) === 0 ) {
			return part.substr( 7 );
		}
	}
}

/**
 * Tannin constructor.
 *
 * @class
 *
 * @param {TanninLocaleData} data      Jed-formatted locale data.
 * @param {TanninOptions}    [options] Tannin options.
 */
function Tannin( data, options ) {
	var key;

	/**
	 * Jed-formatted locale data.
	 *
	 * @name Tannin#data
	 * @type {TanninLocaleData}
	 */
	this.data = data;

	/**
	 * Plural forms function cache, keyed by plural forms string.
	 *
	 * @name Tannin#pluralForms
	 * @type {Object<string,Function>}
	 */
	this.pluralForms = {};

	/**
	 * Effective options for instance, including defaults.
	 *
	 * @name Tannin#options
	 * @type {TanninOptions}
	 */
	this.options = {};

	for ( key in DEFAULT_OPTIONS ) {
		this.options[ key ] = options !== undefined && key in options
			? options[ key ]
			: DEFAULT_OPTIONS[ key ];
	}
}

/**
 * Returns the plural form index for the given domain and value.
 *
 * @param {string} domain Domain on which to calculate plural form.
 * @param {number} n      Value for which plural form is to be calculated.
 *
 * @return {number} Plural form index.
 */
Tannin.prototype.getPluralForm = function( domain, n ) {
	var getPluralForm = this.pluralForms[ domain ],
		config, plural, pf;

	if ( ! getPluralForm ) {
		config = this.data[ domain ][ '' ];

		pf = (
			config[ 'Plural-Forms' ] ||
			config[ 'plural-forms' ] ||
			// Ignore reason: As known, there's no way to document the empty
			// string property on a key to guarantee this as metadata.
			// @ts-ignore
			config.plural_forms
		);

		if ( typeof pf !== 'function' ) {
			plural = getPluralExpression(
				config[ 'Plural-Forms' ] ||
				config[ 'plural-forms' ] ||
				// Ignore reason: As known, there's no way to document the empty
				// string property on a key to guarantee this as metadata.
				// @ts-ignore
				config.plural_forms
			);

			pf = pluralForms( plural );
		}

		getPluralForm = this.pluralForms[ domain ] = pf;
	}

	return getPluralForm( n );
};

/**
 * Translate a string.
 *
 * @param {string}      domain   Translation domain.
 * @param {string|void} context  Context distinguishing terms of the same name.
 * @param {string}      singular Primary key for translation lookup.
 * @param {string=}     plural   Fallback value used for non-zero plural
 *                               form index.
 * @param {number=}     n        Value to use in calculating plural form.
 *
 * @return {string} Translated string.
 */
Tannin.prototype.dcnpgettext = function( domain, context, singular, plural, n ) {
	var index, key, entry;

	if ( n === undefined ) {
		// Default to singular.
		index = 0;
	} else {
		// Find index by evaluating plural form for value.
		index = this.getPluralForm( domain, n );
	}

	key = singular;

	// If provided, context is prepended to key with delimiter.
	if ( context ) {
		key = context + this.options.contextDelimiter + singular;
	}

	entry = this.data[ domain ][ key ];

	// Verify not only that entry exists, but that the intended index is within
	// range and non-empty.
	if ( entry && entry[ index ] ) {
		return entry[ index ];
	}

	if ( this.options.onMissingKey ) {
		this.options.onMissingKey( singular, domain );
	}

	// If entry not found, fall back to singular vs. plural with zero index
	// representing the singular value.
	return index === 0 ? singular : plural;
};

module.exports = Tannin;

},{"@tannin/plural-forms":4}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.state_image_size = exports.state_data = exports.metro_area_data = void 0;
var state_data;
var state_image_size;
if (window.location.href.indexOf("/es/") == -1) {
  exports.state_data = state_data = d3.json(AIC_GLOBAL_VARS.url + "/mti-state-data.json");
  exports.state_image_size = state_image_size = d3.csv(AIC_GLOBAL_VARS.url + "/mti-state-image-size.csv");
} else {
  exports.state_data = state_data = d3.json(AIC_GLOBAL_VARS.url + "/mti-state-data-es.json");
  exports.state_image_size = state_image_size = d3.csv("/StateImageSize_updateV5.csv");
}
var metro_area_data = exports.metro_area_data = d3.json(AIC_GLOBAL_VARS.url + "/mti-metro-area.json");

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aic_change_letter_spacing = aic_change_letter_spacing;
exports.aic_dont_round_tps_holders = aic_dont_round_tps_holders;
exports.aic_hide_datapoints_no_data = aic_hide_datapoints_no_data;
exports.aic_hide_pie_chart_labels = aic_hide_pie_chart_labels;
exports.aic_hide_underemployed_no_foreign_born = aic_hide_underemployed_no_foreign_born;
exports.aic_hide_undoc_line_if_no_data = aic_hide_undoc_line_if_no_data;
exports.aic_is_element_blank = aic_is_element_blank;
exports.aic_populate_county_names = aic_populate_county_names;
exports.aic_populate_msa_long_name = aic_populate_msa_long_name;
exports.aic_round_to_nearest_hundred = aic_round_to_nearest_hundred;
exports.aic_toggle_dropdowns = aic_toggle_dropdowns;
exports.nae_load_state_section_subnav = nae_load_state_section_subnav;
// Function to round numbers
function aic_round_to_nearest_hundred(str) {
  if (str == undefined) {
    return str;
  }
  // If the string is blank just return the original string
  if (str == "-") {
    return str;
  }
  // If the string is already a number below 1,000 just return the string
  if (typeof str == "number" && str < 1000) {
    return str;
  } else {
    if (typeof str == "number") {
      str = str.toString();
    }
    // Remove commas from the string
    var cleanedStr = str.replace(/,/g, "");

    // Convert the cleaned string to a number
    var num = parseFloat(cleanedStr);

    // Check if the conversion resulted in a valid number
    if (isNaN(num)) {
      throw new Error("Invalid number");
    }

    // Round the number to the nearest 100
    var roundedNum = Math.round(num / 100) * 100;

    // Return the rounded number with commas as a string
    return roundedNum.toLocaleString();
  }
}

// Function to hide underemployed table when foreign-born isn't known
function aic_hide_underemployed_no_foreign_born() {
  var underemployedForeignBorn = document.querySelector("[data-mti-datapoint='workforceForeignUnderemployed']");
  var table = underemployedForeignBorn.parentElement.parentElement.parentElement;
  var label = table.previousElementSibling;
  if (aic_is_element_blank(underemployedForeignBorn) == true) {
    //Hide the line
    table.style.display = "none";
    label.style.display = "none";
  }
}

// Function to hide Undocumented horizontal line if no data is available
function aic_hide_undoc_line_if_no_data() {
  if (document.querySelector("[data-mti-section='undoc1']") == null) {
    return;
  } else {
    var section = document.querySelector("[data-mti-section='undoc1']");
    var foreignBornShare = document.getElementById("undoc_foreignBornShareUndoc");
    var totalPopShare = document.getElementById("undoc_totalPopShareUndocumented");
    var laborForceShare = document.getElementById("undoc_laborForceShareUndocumented");
    var array = [];
    array.push(foreignBornShare, totalPopShare, laborForceShare);
    if (array.every(aic_is_element_blank) == true) {
      //Hide the line
      section.style.display = "none";
    }
  }
}

//Function to hide labels
function aic_hide_pie_chart_labels() {
  var data_labels = document.querySelectorAll("[data-mti-pie-label]");
  data_labels.forEach(function (label) {
    var pie_chart = document.getElementById(label.attributes["data-mti-pie-label"].value);

    // If there is a pie chart associated with this label
    // console.log(pie_chart);
    if (pie_chart.childElementCount == 0) {
      // console.log(pie_chart.id);
      // console.log(pie_chart.childElementCount);
      pie_chart.style.display = "none";
      label.style.display = "none";
    }
  });
}
//Function to populate n/a or dash for datapoints with no data
function aic_hide_datapoints_no_data() {
  var datapoints = document.querySelectorAll("[data-mti-datapoint]");
  datapoints.forEach(function (datapoint) {
    var label = datapoint.attributes["data-mti-datapoint"].value;
    label = document.querySelector('[data-mti-data-label="' + label + '"]');
    if ((datapoint.innerHTML == "-" || datapoint.innerHTML == "$0.0" || datapoint.innerHTML == "" || datapoint.innerHTML == "0.0%" || datapoint.innerHTML == "-%") && datapoint.tagName == "TD") {
      datapoint.innerHTML = "-";
    } else if (datapoint.innerHTML == "-" || datapoint.innerHTML == "$0.0" || datapoint.innerHTML == "" || datapoint.innerHTML == "0.0%" || datapoint.innerHTML == "-%" || datapoint.innerHTML == "0") {
      datapoint.style.display = "none";
      if (label != null) {
        label.style.display = "none";
      }
    }
  });
}

//Function to load sections into subnav
function nae_load_state_section_subnav() {
  var sections = document.querySelectorAll("[data-anchor]");
  var navList = document.querySelector("[data-nav-section-list]");
  sections.forEach(function (section) {
    if (section.attributes["data-anchor-title"] != undefined) {
      var item = document.createElement("li");
      var link = document.createElement("a");
      link.href = "#" + section.id;
      link.innerHTML = section.attributes["data-anchor-title"].value;
      item.append(link);
      navList.append(item);
    }
  });
}

//Fuction to check if element is blank
function aic_is_element_blank(el) {
  return el.innerHTML == "0.0%" || el.innerHTML == "-" || el.innerHTML == "" || el.innerHTML == "$0.0" || el.innerHTML == "-%" || el.innerHTML == "0";
}
function mti_show_copy_link_text() {
  var copyLinkButtons = document.querySelectorAll("[data-copy-link]");
  var copyLinkTextElements = document.querySelectorAll(["data-copy-link-text"]);
  copyLinkButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var section = button.getAttribute("data-copy-link");
      var linkTextElement = document.querySelector("[data-copy-link-text='" + section + "']");
      if (linkTextElement) {
        linkTextElement.style.display = "block"; // Display the element

        // Set timeout to hide the element after 'duration' milliseconds
        setTimeout(function () {
          linkTextElement.style.display = "none"; // Hide the element after duration
        }, 2000);
      } else {
        console.error("Element with id '" + elementId + "' not found.");
      }
    });
  });
}
function aic_change_letter_spacing() {
  var datapoints = document.querySelectorAll("[data-mti-datapoint]");
  datapoints.forEach(function (datapoint) {
    if (datapoint.innerText) {
      if (datapoint.innerText.endsWith("7T")) {
        datapoint.style.letterSpacing = "5px";
      }
    }
  });
}
function aic_dont_round_tps_holders() {
  var states_to_not_round = ["alabama", "alaska", "arizona", "arkansas", "delaware", "district-of-columbia", "hawaii", "idaho", "iowa", "kansas", "kentucky", "louisiana", "maine", "minnesota", "mississippi", "missouri", "montana", "nebraska", "new hampshire", "new mexico", "north dakota", "oklahoma", "oregon", "rhode island", "south carolina", "south dakota", "vermont", "west virginia", "wisconsin", "wyoming"];
  var currentState = document.querySelector("#page-slug").innerText;
  var tps_datapoint = document.querySelector('[data-mti-datapoint="tps-numHolders"]');
  if (states_to_not_round.includes(currentState)) {
    tps_datapoint.innerHTML = tps_datapoint.getAttribute("data-raw-value");
  }
}
function aic_toggle_dropdowns() {
  var dropdowns = document.querySelectorAll(".location_list .placeholder");
  var inner_dropdowns = document.querySelectorAll(".location_list .parent div");
  inner_dropdowns.forEach(function (dropdown) {
    dropdown.addEventListener("click", function (event) {
      // Prevent the click from bubbling up to the document listener
      event.stopPropagation();
      var dropdownList = dropdown.nextElementSibling;
      // Toggle the dropdown open/close
      if (dropdownList.classList.contains("open")) {
        dropdownList.classList.remove("open");
        dropdown.classList.remove("rotate");
      } else {
        dropdownList.classList.add("open");
        dropdown.classList.add("rotate");
      }
    });
  });

  // Attach the dropdown click event listeners
  dropdowns.forEach(function (dropdown) {
    dropdown.addEventListener("click", function (event) {
      // Prevent the click from bubbling up to the document listener
      event.stopPropagation();
      var dropdownList = dropdown.nextElementSibling;
      // Toggle the dropdown open/close
      if (dropdownList.classList.contains("open")) {
        dropdownList.classList.remove("open");
        dropdown.classList.remove("rotate");
      } else {
        dropdownList.classList.add("open");
        dropdown.classList.add("rotate");
      }
    });

    // Add click event to the dropdown list itself to prevent closing
    var dropdownList = dropdown.nextElementSibling;
    if (dropdownList) {
      dropdownList.addEventListener("click", function (event) {
        // Prevent the click from bubbling up to the document listener
        event.stopPropagation();
      });
    }
  });

  // Add a single click listener on the document to close any open dropdowns
  document.addEventListener("click", function (event) {
    dropdowns.forEach(function (dropdown) {
      var dropdownList = dropdown.nextElementSibling;
      // If the click is outside the dropdown, close it
      if (dropdownList && !dropdown.contains(event.target) && !dropdownList.contains(event.target)) {
        dropdownList.classList.remove("open");
        dropdown.classList.remove("rotate");
      }
    });
  });
}
function aic_populate_county_names(counties) {
  if (counties) {
    var list = document.querySelector("#counties-modal ul");
    if (list) {
      var countiesArray = counties.split(";");
      countiesArray.forEach(function (county) {
        var li = document.createElement("li");
        li.innerText = county;
        list.appendChild(li);
      });
    }
  }
}
function aic_populate_msa_long_name(msa_long_name) {
  if (msa_long_name) {
    var el = document.querySelector("[data-mti-cbsa-name]");
    if (el) {
      console.log("Running populate msa long name");
      el.innerText = msa_long_name;
    }
  }
}

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aic_configure_numeralJs = aic_configure_numeralJs;
function aic_configure_numeralJs() {
  // Setup Numeral.js to print uppercase for dollar amounts
  numeral.register("locale", "us", {
    delimiters: {
      thousands: ",",
      decimal: "."
    },
    abbreviations: {
      thousand: "K",
      million: "M",
      billion: "B",
      trillion: "T"
    },
    ordinal: function ordinal(number) {
      return number === 1 ? "er" : "ème";
    },
    currency: {
      symbol: "$"
    }
  });
  numeral.register("locale", "es-es", {
    delimiters: {
      thousands: " ",
      decimal: "."
    },
    abbreviations: {
      thousand: "K",
      million: "MM",
      billion: "B",
      trillion: "T"
    },
    format: function format(number) {
      return number * 1000;
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "$"
    }
  });

  // if (window.location.href.indexOf("/es/") != -1) {
  //     numeral.locale("es-es");
  // } else {
  //     numeral.locale("us");
  // }

  numeral.locale("us");
}

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mti_generate_pdf_en = mti_generate_pdf_en;
exports.mti_generate_pdf_es = mti_generate_pdf_es;
exports.mti_generate_pdf_msa = mti_generate_pdf_msa;
var _config = require("./_config");
var _misc = require("./_misc");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function mti_generate_pdf_en() {
  var name = document.getElementById("page-term-name").textContent;
  if (name == "United States of America") {
    name = "National";
  }
  var nameProper = name;
  var nameProper2 = nameProper + "'s";
  if (nameProper == "National") {
    nameProper2 = "U.S.";
  }
  var ENTRE = 0,
    //Number 3
    CBO = 0,
    //Number 4
    ITEP = 0,
    //Number 5
    STEM = 0,
    //Number 6
    NAFSA = 0,
    //Number 7
    UNDOC1 = 0,
    //Number 8
    UNDOC2 = 0,
    //Number 9
    DACA1 = 0,
    //Number 10
    DACA2 = 0,
    //Number 11
    DACA3 = 0,
    //Number 12
    REFUGEE = 0,
    //Number 13
    REFUGEE2 = 0,
    //Number 14
    TPS = 9; //Number 15

  var endnoteArray = ["A_first", "B_second"];
  var jsPDF = window.jspdf.jsPDF;
  var imgWidth = 100;
  var imgHeight = 73;

  // var usData = d3.json(
  //   "https://immcouncil-data.s3.us-east-2.amazonaws.com/mti-state-2023.json"
  // );

  var usData = _config.state_data;
  var stateSize = _config.state_image_size;

  // var mti_key = d3.csv("https://immcouncil-data.s3.us-east-2.amazonaws.com/state_data_with_key.csv")

  var mti_key = d3.csv(AIC_GLOBAL_VARS.url + "/static/data/map-the-impact/state_data_with_key.csv");
  var dataPDF = [usData, stateSize, mti_key];
  function addComma() {}
  prepareAndStartChange();
  function prepareAndStartChange() {
    Promise.all(dataPDF).then(startChange);
  }
  function startChange(dataPDF) {
    if (window.location.href.indexOf("/es/") == -1) {
      if (name == "National") {
        nameProper = "The United States";
      }
      var stateData = dataPDF[0].filter(function (d) {
        return d["Account Name"] === name;
      });
      var sizeFile = dataPDF[1].filter(function (d) {
        return d["stateName"] === name;
      });
      var mti_keyFile = dataPDF[2].filter(function (d) {
        return d["State"] === name;
      });
    } else {
      if (name == "Estados Unidos") {
        nameProper = "Estados Unidos";
      }
      var stateData = dataPDF[0].filter(function (d) {
        return d["Account Name"] === name;
      });
      var sizeFile = dataPDF[1].filter(function (d) {
        return d["stateName"] === translateToEnglish(name);
      });
      var mti_keyFile = dataPDF[2].filter(function (d) {
        return d["State"] === translateToEnglish(name);
      });
    }
    console.log(dataPDF);
    console.log(name);
    console.log(mti_keyFile);
    console.log(stateData);
    // var stateData = data[0].filter(function(d) { return d["Account Name"] === "District of Columbia"})

    var originCountriesTable = mti_keyFile[0]["originCountriesTable"],
      entrepreneurshipTable = mti_keyFile[0]["entrepreneurshipTable"],
      taxesTable = mti_keyFile[0]["taxesTable"],
      workforceTable = mti_keyFile[0]["workforceTable"],
      educationTable = mti_keyFile[0]["educationTable"],
      industryTable = mti_keyFile[0]["industryTable"],
      occupationTable = mti_keyFile[0]["occupationTable"],
      stemTable = mti_keyFile[0]["stemTable"],
      healthcareTable = mti_keyFile[0]["healthcareTable"],
      housingTable = mti_keyFile[0]["housingTable"],
      internationalTable = mti_keyFile[0]["internationalTable"],
      naturalizationTable = mti_keyFile[0]["naturalizationTable"],
      undocumentedTable = mti_keyFile[0]["undocumentedTable"],
      undocIndustryTable = mti_keyFile[0]["undocIndustryTable"],
      dacaTable = mti_keyFile[0]["dacaTable"],
      dacaSmallTable = mti_keyFile[0]["dacaSmallTable"],
      refugeesTable = mti_keyFile[0]["refugeesTable"],
      refugeesTableOrigin = mti_keyFile[0]["refugeesTableOrigin"],
      tpsTable = mti_keyFile[0]["tpsTable"],
      tpsSmall = mti_keyFile[0]["tpsSmall"],
      refugeeSmall = mti_keyFile[0]["refugeeSmall"];
    console.log(stateData);
    var dacaEducValue = stateData[0]["DACA, # of Additional Residents Who Would Satisfy All But Edu Rec"];
    var dacaEduc;
    if (Number.isInteger(dacaEducValue)) {
      var str;
      str = dacaEducValue.toLocaleString();
      var cleanedStr = str.replace(/,/g, "");

      // Convert the cleaned string to a number
      var num = parseFloat(cleanedStr);

      // Check if the conversion resulted in a valid number
      if (isNaN(num)) {
        throw new Error("Invalid number");
      }

      // Round the number to the nearest 100
      var roundedNum = Math.round(num / 100) * 100;

      // Return the rounded number with commas as a string
      dacaEduc = roundedNum.toLocaleString();
    } else {
      dacaEduc = (0, _misc.aic_round_to_nearest_hundred)(dacaEducValue);
    }
    var dacaEntreValue = stateData[0]["Immigrant Entrepreneurs, DACA-Eligible"];
    var dacaEntre;
    if (Number.isInteger(dacaEntreValue)) {
      dacaEntre = dacaEntreValue.toLocaleString();
      dacaEntre = (0, _misc.aic_round_to_nearest_hundred)(dacaEntre);
    } else {
      dacaEntre = (0, _misc.aic_round_to_nearest_hundred)(dacaEntreValue);
    }
    setTimeout(function () {
      // Generate PDF
      var doc = new jsPDF("p", "pt", "letter"),
        intro = stateData[0]["Introduction"],
        overview0 = stateData[0]["Immigrant Share of Population"],
        overview1 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant Residents"]),
        overview2 = stateData[0]["Immigrant Spending Power"],
        overview3 = stateData[0]["Immigrant Taxes Paid"],
        demo0 = stateData[0]["U.S.-born Residents, At Least One Immigrant Parent, %"],
        demo1 = stateData[0]["Foreign-Born, Women"],
        demo2 = stateData[0]["Foreign-Born, Men"],
        demo3 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Foreign-Born, Children"]),
        demo4 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["U.S.-born Residents, At Least One Immigrant Parent"]),
        demo5 = stateData[0]["Foreign-Born, Share Proficient in English"],
        demoAge_1_1 = stateData[0]["Foreign-Born, Ages 0-15"],
        demoAge_1_2 = stateData[0]["Native-Born, Ages 0-15"],
        demoAge_2_1 = stateData[0]["Foreign-Born, Ages 16-64"],
        demoAge_2_2 = stateData[0]["Native-Born, Ages 16-64"],
        demoAge_3_1 = stateData[0]["Foreign-Born, Ages 65+"],
        demoAge_3_2 = stateData[0]["Native-Born, Ages 65+"],
        topCountry1 = stateData[0]["#1 Country of Origin"],
        topCountry2 = stateData[0]["#2 Country of Origin"],
        topCountry3 = stateData[0]["#3 Country of Origin"],
        topCountry4 = stateData[0]["#4 Country of Origin"],
        topCountry5 = stateData[0]["#5 Country of Origin"],
        topCountry1v = stateData[0]["#1 Country of Origin, Value"],
        topCountry2v = stateData[0]["#2 Country of Origin, Value"],
        topCountry3v = stateData[0]["#3 Country of Origin, Value"],
        topCountry4v = stateData[0]["#4 Country of Origin, Value"],
        topCountry5v = stateData[0]["#5 Country of Origin, Value"],
        entre1 = stateData[0]["Entrepreneur, Foreign-Born Share"],
        entre2 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant Entrepreneurs"]),
        entre3 = stateData[0]["Business Income of Immigrant Entrepreneurs"],
        entre4 = stateData[0]["Fortune 500 Companies"],
        taxes1 = stateData[0]["Immigrant Household Income"],
        taxes2 = stateData[0]["Immigrant Spending Power"],
        taxes3 = stateData[0]["State & Local Taxes"],
        taxes4 = stateData[0]["Federal Taxes"],
        taxes5 = stateData[0]["Immigrant Taxes Paid"],
        taxes6 = stateData[0]["Foreign-born, Contributions to Social Security"],
        taxes7 = stateData[0]["Foreign-born, Contributions to Medicare"],
        work1 = stateData[0]["Labor Force, Foreign-Born Share"],
        work2 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Labor Force, Foreign-Born"]),
        work3_1_1 = stateData[0]["Foreign-Born, Less Than High School"],
        work3_1_2 = stateData[0]["Native-Born, Less Than High School"],
        work3_2_1 = stateData[0]["Foreign-Born, High School & Some College"],
        work3_2_2 = stateData[0]["Native-Born, High School & Some College"],
        work3_3_1 = stateData[0]["Foreign-Born, Bachelor's Degree"],
        work3_3_2 = stateData[0]["Native-Born, Bachelor's Degree"],
        work3_4_1 = stateData[0]["Foreign-Born, Graduate Degree"],
        work3_4_2 = stateData[0]["Native-Born, Graduate Degree"],
        workUnder_fb = stateData[0]["Foreign-Born, Underemployed"],
        workUnder_us = stateData[0]["US-Born, Underemployed"],
        topIndustry1 = stateData[0]["#1 Industry"],
        topIndustry1v = stateData[0]["#1 Industry, Value"],
        topIndustry2 = stateData[0]["#2 Industry"],
        topIndustry2v = stateData[0]["#2 Industry, Value"],
        topIndustry3 = stateData[0]["#3 Industry"],
        topIndustry3v = stateData[0]["#3 Industry, Value"],
        topIndustry4 = stateData[0]["#4 Industry"],
        topIndustry4v = stateData[0]["#4 Industry, Value"],
        topIndustry5 = stateData[0]["#5 Industry"],
        topIndustry5v = stateData[0]["#5 Industry, Value"],
        topOccupation1 = stateData[0]["#1 Occupation"],
        topOccupation1v = stateData[0]["#1 Occupation, Value"],
        topOccupation2 = stateData[0]["#2 Occupation"],
        topOccupation2v = stateData[0]["#2 Occupation, Value"],
        topOccupation3 = stateData[0]["#3 Occupation"],
        topOccupation3v = stateData[0]["#3 Occupation, Value"],
        topOccupation4 = stateData[0]["#4 Occupation"],
        topOccupation4v = stateData[0]["#4 Occupation, Value"],
        topOccupation5 = stateData[0]["#5 Occupation"],
        topOccupation5v = stateData[0]["#5 Occupation, Value"],
        stemWorkersImm = stateData[0]["STEM workers who are immigrants"],
        nurses = stateData[0]["Nurses who are foreign-born"],
        healthAides = stateData[0]["Health aides who are foreign-born"],
        housingOwners = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant homeowners"]),
        housingShare = stateData[0]["Share of recent homebuyers who were foreign-born"],
        housingWealth = stateData[0]["Housing wealth held by immigrant households"],
        housingRent = stateData[0]["Amount paid by immigrant-led households in rent"],
        internationalStd = stateData[0]["Students at [state] colleges and universities who are international"],
        internationalStdEcon = stateData[0]["Economic contribution of international students"],
        internationalStdJobs = stateData[0]["Jobs supported by international students"].toLocaleString(),
        naturalizationShare = stateData[0]["Foreign-Born, Naturalized Share"],
        naturalizationVote = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrants eligible to vote"]),
        naturalizationValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Foreign-Born, Naturalized"]),
        naturalizationEligible = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Foreign-Born, Eligible to Naturalize"]),
        undocumentedWorkers = stateData[0]["Share of undocumented immigrants, working age"],
        undocumentedValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Undocumented Immigrants"]),
        undocumentedEntre = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant entrepreneurs, Undocumented Immigrants"]),
        undocumentedIncome = stateData[0]["Immigrant Household Income, Undocumented Immigrants"],
        undocumentedSpending = stateData[0]["Immigrant Spending Power, Undocumented Immigrants"],
        undocumentedStateTx = stateData[0]["State & Local Taxes, Undocumented Immigrants"],
        undocumentedFedTax = stateData[0]["Federal Taxes, Undocumented Immigrants"],
        undocumentedTotalTax = stateData[0]["Taxes Paid, Undocumented Immigrants"],
        undocumentedShareImm = stateData[0]["Foreign-Born, Share Undocumented"],
        undocumentedShareTotal = stateData[0]["Total Pop, Share Undocumented"],
        undocumentedShareWork = stateData[0]["Labor Force, Share Undocumented"],
        undocumentedOneFamValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["U.S. Citizens Living With >= 1 Undoc Fam Member"]),
        undocumentedOneFamShare = stateData[0]["U.S. Citizens Living With >= 1 Undoc Fam Member, Share"],
        undocumentedChildValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["U.S. Citizen Children Living With >= 1 Undoc Fam Member"]),
        undocumentedChildShare = stateData[0]["U.S. Citizen Children Living With >= 1 Undoc Fam Member, Share"],
        undocumentedParentValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["U.S. Citizen Children Living With >= 1 Undoc Parent"]),
        undocumentedParentShare = stateData[0]["U.S. Citizen Children Living With >= 1 Undoc Parent, Share"],
        dacaActive = stateData[0]["Number of Active DACA Recipients"].toLocaleString(),
        dacaWork = stateData[0]["Share of DACA Eligible Population in Labor Force that is Employed"],
        dacaValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Number of DACA Eligible Residents"]),
        // dacaEduc = aic_round_to_nearest_hundred(
        //   stateData[0][
        //     "DACA, # of Additional Residents Who Would Satisfy All But Edu Rec"
        //   ]
        // ),
        // dacaEntre = aic_round_to_nearest_hundred(
        //   stateData[0]["Immigrant Entrepreneurs, DACA-Eligible"]
        // ),
        dacaIncome = stateData[0]["Immigrant Household Income, DACA-Eligible"],
        dacaSpending = stateData[0]["Immigrant Spending Power, DACA-Eligible"],
        dacaStateTx = stateData[0]["State & Local Taxes, DACA-Eligible"],
        dacaFedTax = stateData[0]["Federal Taxes, DACA-Eligible"],
        dacaTotalTax = stateData[0]["Taxes Paid, DACA-Eligible"],
        dacaGranted = stateData[0]["Number of People with DACA Granted"].toLocaleString(),
        refugeeWork = stateData[0]["Share of Refugees in Labor Force, Employed"],
        refugeeValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Number of Refugees"]),
        refugeeIncome = stateData[0]["Refugees' Household Income"],
        refugeeSpending = stateData[0]["Refugees' Total Spending Power"],
        refugeeStateTx = stateData[0]["State & Local Taxes, Refugees"],
        refugeeFedTax = stateData[0]["Federal Taxes, Refugees"],
        refugeeTotalTax = stateData[0]["Taxes Paid, Refugees"],
        refugeeEntre = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant Entrepreneurs, Refugees"]),
        refugeeEntreIncome = stateData[0]["Business Income of Refugee Entrepreneurs"],
        refugeeNat = stateData[0]["Refugee, Pct Naturalized"],
        refugeeResettle = stateData[0]["Recent Refugees Resettled"].toLocaleString(),
        tpsWork = stateData[0]["Share of TPS Holders, Working Age"],
        tpsValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Number of TPS Holders"]),
        tpsEmploy = stateData[0]["Share of TPS Holders in Labor Force, Employed"],
        tpsIncome = stateData[0]["TPS Holders' Household Income"],
        tpsSpending = stateData[0]["TPS Holders' Total Spending Power"],
        tpsStateTx = stateData[0]["State & Local Taxes, TPS Holders"],
        tpsFedTax = stateData[0]["Federal Taxes, TPS Holders"],
        tpsTotalTax = stateData[0]["Taxes Paid, TPS Holders"],
        newWidth = Number(sizeFile[0]["newWidth"]),
        newLength = Number(sizeFile[0]["newLength"]),
        undocInd1 = stateData[0]["Undoc #1 Industry"],
        undocInd2 = stateData[0]["Undoc #2 Industry"],
        undocInd3 = stateData[0]["Undoc #3 Industry"],
        undocInd4 = stateData[0]["Undoc #4 Industry"],
        undocInd5 = stateData[0]["Undoc #5 Industry"],
        undocShareInd1 = stateData[0]["#1 Industry, Pct Undoc"],
        undocShareInd2 = stateData[0]["#2 Industry, Pct Undoc"],
        undocShareInd3 = stateData[0]["#3 Industry, Pct Undoc"],
        undocShareInd4 = stateData[0]["#4 Industry, Pct Undoc"],
        undocShareInd5 = stateData[0]["#5 Industry, Pct Undoc"],
        refugeeCountry1 = stateData[0]["Recent Refugee - #1 Country of Origin"],
        refugeeCountry2 = stateData[0]["Recent Refugee - #2 Country of Origin"],
        refugeeCountry3 = stateData[0]["Recent Refugee - #3 Country of Origin"],
        refugeeCountry4 = stateData[0]["Recent Refugee - #4 Country of Origin"],
        refugeeCountry5 = stateData[0]["Recent Refugee - #5 Country of Origin"],
        refugeeCountry1Share = stateData[0]["Recent Refugee - #1 Country of Origin, Value"],
        refugeeCountry2Share = stateData[0]["Recent Refugee - #2 Country of Origin, Value"],
        refugeeCountry3Share = stateData[0]["Recent Refugee - #3 Country of Origin, Value"],
        refugeeCountry4Share = stateData[0]["Recent Refugee - #4 Country of Origin, Value"],
        refugeeCountry5Share = stateData[0]["Recent Refugee - #5 Country of Origin, Value"];
      function convert(x) {
        x = Number(x.replace(/\$|,/g, ""));
        if (x >= 999999999999) {
          x = "$" + (x / 1000000000000).toFixed(1) + "T";
        } else if (x > 999999999 & x < 999999999999) {
          x = "$" + (x / 1000000000).toFixed(1) + "B";
        } else if (x > 100 && x <= 999999999) {
          x = "$" + (x / 1000000).toFixed(1) + "M";
        } else {
          x = "-";
        }
        return x;
      }
      overview2 = convert(overview2);
      overview3 = convert(overview3);
      if (entre3 != "-" || entre3 != "$0.0" || entre3 != "-" || entre3 != null) {
        entre3 = convert(entre3);
      }
      if (taxes1 != "$-" || taxes1 != "$0.0") {
        taxes1 = convert(taxes1);
      }
      if (taxes2 != "$-" || taxes2 != "$0.0") {
        taxes2 = convert(taxes2);
      }
      if (taxes3 != "$-" || taxes3 != "$0.0") {
        taxes3 = convert(taxes3);
      }
      if (taxes4 != "$-" || taxes4 != "$0.0") {
        taxes4 = convert(taxes4);
      }
      if (taxes5 != "$-" || taxes5 != "$0.0") {
        taxes5 = convert(taxes5);
      }
      if (taxes6 != "$-" || taxes6 != "$0.0") {
        taxes6 = convert(taxes6);
      }
      if (taxes7 != "$-" || taxes7 != "$0.0") {
        taxes7 = convert(taxes7);
      }
      if (housingWealth != "$-" || housingWealth != "$0.0") {
        housingWealth = convert(housingWealth);
      }
      if (housingRent != "$-" || housingRent != "$0.0") {
        housingRent = convert(housingRent);
      }
      if (internationalStdEcon != "$-" || internationalStdEcon != "$0.0") {
        internationalStdEcon = convert(internationalStdEcon);
      }
      if (undocumentedIncome != "$-" || undocumentedIncome != "$0.0") {
        undocumentedIncome = convert(undocumentedIncome);
      }
      if (undocumentedSpending != "$-" || undocumentedSpending != "$0.0") {
        undocumentedSpending = convert(undocumentedSpending);
      }
      if (undocumentedStateTx != "$-" || undocumentedStateTx != "$0.0") {
        undocumentedStateTx = convert(undocumentedStateTx);
      }
      if (undocumentedFedTax != "$-" || undocumentedFedTax != "$0.0") {
        undocumentedFedTax = convert(undocumentedFedTax);
      }
      if (undocumentedTotalTax != "$-" || undocumentedTotalTax != "$0.0") {
        undocumentedTotalTax = convert(undocumentedTotalTax);
      }
      if (dacaIncome != "$-" || dacaIncome != "$0.0") {
        dacaIncome = convert(dacaIncome);
      }
      if (dacaSpending != "$-" || dacaSpending != "$0.0") {
        dacaSpending = convert(dacaSpending);
      }
      if (dacaStateTx != "$-" || dacaStateTx != "$0.0") {
        dacaStateTx = convert(dacaStateTx);
      }
      if (dacaFedTax != "$-" || dacaFedTax != "$0.0") {
        dacaFedTax = convert(dacaFedTax);
      }
      if (dacaTotalTax != "$-" || dacaTotalTax != "$0.0") {
        dacaTotalTax = convert(dacaTotalTax);
      }
      if (refugeeIncome != "$-" || refugeeIncome != "$0.0") {
        refugeeIncome = convert(refugeeIncome);
      }
      if (refugeeSpending != "$-" || refugeeSpending != "$0.0") {
        refugeeSpending = convert(refugeeSpending);
      }
      if (refugeeStateTx != "$-" || refugeeStateTx != "$0.0") {
        refugeeStateTx = convert(refugeeStateTx);
      }
      if (refugeeFedTax != "$-" || refugeeFedTax != "$0.0") {
        refugeeFedTax = convert(refugeeFedTax);
      }
      if (refugeeTotalTax != "$-" || refugeeTotalTax != "$0.0") {
        refugeeTotalTax = convert(refugeeTotalTax);
      }
      if (refugeeEntreIncome != "$-" || refugeeEntreIncome != "$0.0") {
        refugeeEntreIncome = convert(refugeeEntreIncome);
      }
      if (tpsIncome != "$-" || tpsIncome != "$0.0") {
        tpsIncome = convert(tpsIncome);
      }
      if (tpsSpending != "$-" || tpsSpending != "$0.0") {
        tpsSpending = convert(tpsSpending);
      }
      if (tpsStateTx != "$-" || tpsStateTx != "$0.0") {
        tpsStateTx = convert(tpsStateTx);
      }
      if (tpsFedTax != "$-" || tpsFedTax != "$0.0") {
        tpsFedTax = convert(tpsFedTax);
      }
      if (tpsTotalTax != "$-" || tpsTotalTax != "$0.0") {
        tpsTotalTax = convert(tpsTotalTax);
      }
      if (topCountry2 == "") {
        topCountry2 = "-";
      }
      if (topCountry3 == "") {
        topCountry3 = "-";
      }
      if (topCountry4 == "") {
        topCountry4 = "-";
      }
      if (topCountry5 == "") {
        topCountry5 = "-";
      }
      if (topCountry2v == "") {
        topCountry2v = "-";
      }
      if (topCountry3v == "") {
        topCountry3v = "-";
      }
      if (topCountry4v == "") {
        topCountry4v = "-";
      }
      if (topCountry5v == "") {
        topCountry5v = "-";
      }
      if (entre2 == "") {
        entre2 = "-";
      }
      if (dacaWork == "0.0%") {
        dacaWork = "-";
      }
      if (refugeeWork == "0.0%") {
        refugeeWork = "-";
      }
      if (tpsWork == "0.0%") {
        refugeeWork = "-";
      }
      if (undocumentedWorkers == "0.0%") {
        undocumentedWorkers = "-";
      }
      if (undocumentedShareImm == "0.0%") {
        undocumentedShareImm = "-";
      }
      if (undocumentedShareWork == "0.0%") {
        undocumentedShareWork = "-";
      }
      if (undocumentedShareTotal == "0.0%") {
        undocumentedShareTotal = "-";
      }
      if (refugeeEntre == "") {
        refugeeEntre = "-";
      }
      if (refugeeNat == "") {
        refugeeNat = "-";
      }
      if (undocumentedEntre == "") {
        undocumentedEntre = "-";
      }
      if (undocumentedEntre == "") {
        undocumentedEntre = "-";
      }
      if (demo3 == "") {
        demo3 = "-";
      }
      if (topIndustry2 == "") {
        topIndustry2 = "-";
      }
      if (topIndustry3 == "") {
        topIndustry3 = "-";
      }
      if (topIndustry4 == "") {
        topIndustry4 = "-";
      }
      if (topIndustry5 == "") {
        topIndustry5 = "-";
      }
      if (topIndustry2v == "") {
        topIndustry2v = "-";
      }
      if (topIndustry3v == "") {
        topIndustry3v = "-";
      }
      if (topIndustry4v == "") {
        topIndustry4v = "-";
      }
      if (topIndustry5v == "") {
        topIndustry5v = "-";
      }
      if (housingOwners == "") {
        housingOwners = "-";
      }
      if (housingShare == "") {
        housingShare = "-";
      }
      if (dacaEntre == "") {
        dacaEntre = "-";
      }
      if (refugeeEntreIncome == "") {
        refugeeEntreIncome = "-";
      }
      if (demoAge_1_1 == "") {
        demoAge_1_1 = "-";
      }
      if (demoAge_2_1 == "") {
        demoAge_2_1 = "-";
      }
      if (demoAge_3_1 == "") {
        demoAge_3_1 = "-";
      }
      if (entre1 == "") {
        entre1 = "-";
      }
      if (entre2 == "") {
        entre2 = "-";
      }
      if (entre3 == "") {
        entre3 = "-";
      }
      if (work3_1_1 == "") {
        work3_1_1 = "-";
      }
      if (work3_2_1 == "") {
        work3_2_1 = "-";
      }
      if (work3_3_1 == "") {
        work3_3_1 = "-";
      }
      if (work3_4_1 == "") {
        work3_4_1 = "-";
      }
      if (workUnder_fb == "" || workUnder_fb == "-") {
        workUnder_us = "-";
      }
      var imgUrl = AIC_GLOBAL_VARS.url + "/static/img/aic-logo-transparent.png";
      if (window.location.href.indexOf("/es/") == -1) {
        var stateName = stateData[0]["Account Name"].replace(/\s/g, "_");
      } else {
        var stateName = translateToEnglish(stateData[0]["Account Name"]).replace(/\s/g, "_");
      }
      if (stateName == "National") {
        stateName = "USA";
      }
      var stateImage = AIC_GLOBAL_VARS.url + "/static/img/state_images/" + stateName + ".png";
      var moneyValues = [taxes1, taxes2, taxes3, taxes4, taxes5, taxes6, taxes7, housingWealth, housingRent, internationalStdEcon, undocumentedIncome, undocumentedSpending, undocumentedStateTx, undocumentedFedTax, undocumentedTotalTax, dacaIncome, dacaSpending, dacaStateTx, dacaFedTax, dacaTotalTax, refugeeIncome, refugeeSpending, refugeeStateTx, refugeeFedTax, refugeeTotalTax, tpsIncome, tpsSpending, tpsStateTx, tpsFedTax, tpsTotalTax, refugeeEntreIncome];
      function newPage(p) {
        doc.addPage();
        doc.setFontSize(16);
        doc.setFont("Karla-Medium", "medium");
        doc.text(40, 40, "New Americans in");
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(16);
        doc.text(177, 40, nameProper);
        var pageNumber = p.toString();
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(560, 765, pageNumber);
      }
      function FirstPage() {
        function newPage() {
          doc.addPage();
          doc.setFontSize(16);
          doc.setFont("Karla-Medium", "medium");
          doc.text(40, 40, "New Americans in");
          doc.setFont("Karla-ExtraBold", "bold");
          doc.setFontSize(16);
          doc.text(158, 40, nameProper);
        }
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.src = imgUrl;
        var imgState = new Image();
        imgState.crossOrigin = "anonymous";
        imgState.src = stateImage;
        doc.addImage(img, "png", 450, 23, 117, 57);
        doc.addImage(imgState, "png", 300, 23, newWidth, newLength);
        doc.setFontSize(20);
        doc.setFont("Karla-Regular", "regular");
        doc.text(40, 40, "New Americans in");
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(30);
        doc.text(40, 75, nameProper);
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        doc.text(40, 135, intro, {
          maxWidth: 530
        });
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, 250, "OVERVIEW");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(115, 244, "1");
        doc.setFontSize(14);
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, 255, 565, 255, "S");
        doc.setFont("Karla-Regular", "regular");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: 260,
          startX: 0,
          tableWidth: 530,
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[mtiTranslations.immResidents, overview1], [mtiTranslations.immSharePopulation, overview0], [mtiTranslations.immigrant_taxes_paid, overview3], [mtiTranslations.immigrant_spending_power, overview2]]
        });
        doc.setFontSize(8);
        doc.text(150, 268, "2");
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, 380, "DEMOGRAPHICS");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, 385, 565, 385, "S");
        var demoText = $("#demograpicsText");
        demoText = demoText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        demoText = doc.splitTextToSize(demoText, 530);
        doc.text(40, 405, demoText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: 465,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Share of immigrant women", demo1], ["Share of immigrant men", demo2], ["Number of immigrant children", demo3], ["Share of U.S.-born residents living with at least one immigrant parent", demo0], ["Number of U.S.-born residents living with at least one immigrant parent", demo4], ["Share of foreign-born that are proficient in English", demo5]]
        });
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: 625,
          startX: 0,
          tableWidth: 525,
          headStyles: {
            textColor: [0, 0, 0],
            font: "Karla-Bold",
            fontSize: 12,
            fillColor: [255, 255, 255]
          },
          //         columnStyles: {
          //   0: {cellWidth: 390},
          //   1: {cellWidth: 140}
          // },
          head: [["Age Group", "Foreign-Born Population", "U.S.-Born Population"]],
          body: [["0-15", demoAge_1_1, demoAge_1_2], ["16-64", demoAge_2_1, demoAge_2_2], ["65+", demoAge_3_1, demoAge_3_2]]
        });
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(13);
        doc.setTextColor(0, 0, 0);
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, 765, "Data Year: 2023");
        doc.text(560, 765, "1");
      }
      var n = 75,
        p = 2,
        e = 2;
      FirstPage();
      newPage(p);
      function originCountries(n) {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(13);
        doc.text(40, n, "Top Countries of Origin for Immigrants");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 12,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204],
            font: "Karla-Bold",
            fontSize: 12
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[topCountry1, topCountry1v], [topCountry2, topCountry2v], [topCountry3, topCountry3v], [topCountry4, topCountry4v], [topCountry5, topCountry5v]]
        });
      }
      function entrepreneurship(n) {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "ENTREPRENEURSHIP");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var entreText = $("#entrepreneurshipText");
        entreText = entreText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        entreText = doc.splitTextToSize(entreText, 530);
        doc.text(40, n + 25, entreText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 80,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Immigrant entrepreneurs", entre2], ["Share of entrepreneurs who are immigrants", entre1], ["Total business income of immigrant entrepreneurs", entre3], ["Number of Fortune 500 companies founded by immigrants or children of immigrants", entre4]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        var endnote3 = e + 1;
        doc.text(106, n + 171, endnote3.toString());
        e = e + 1;
        endnoteArray.push("C_ENTRE");
        return;
      }
      function taxesSpending(n) {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "TAXES & SPENDING POWER");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var taxText = $("#taxText");
        taxText = taxText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        taxText = doc.splitTextToSize(taxText, 530);
        doc.text(40, n + 25, taxText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 110,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Immigrant household income", taxes1], ["Total taxes paid", taxes5], ["Federal taxes paid", taxes4], ["State & local taxes paid", taxes3], ["Total spending power", taxes2], ["Foreign-born, contributions to Social Security", taxes6], ["Foreign-born, contributions to Medicare", taxes7]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        var endnote3 = e + 1,
          endnote4 = e + 2;
        doc.text(137, n + 164, endnote3.toString());
        doc.text(167, n + 187, endnote4.toString());
        e = e + 2;
        endnoteArray.push("D_CBO", "E_ITEP");
      }
      function workforce() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "WORKFORCE");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var workText = $("#workText");
        workText = workText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        workText = doc.splitTextToSize(workText, 530);
        doc.text(40, n + 25, workText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 90,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of immigrant workers in the labor force", work2], ["Share of workers in the labor force who are immigrants", work1]]
        });
      }
      function education() {
        doc.setFont("Karla-Regular", "regular");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n,
          startX: 0,
          tableWidth: 525,
          headStyles: {
            textColor: [0, 0, 0],
            font: "Karla-Bold",
            fontSize: 12,
            fillColor: [255, 255, 255]
          },
          //         columnStyles: {
          //   0: {cellWidth: 390},
          //   1: {cellWidth: 140}
          // },
          head: [["Education Level", "Foreign-Born Population", "U.S.-Born Population"]],
          body: [["Less than high school", work3_1_1, work3_1_2], ["High school & some college", work3_2_1, work3_2_2], ["Bachelor’s degree", work3_3_1, work3_3_2], ["Graduate degree", work3_4_1, work3_4_2], ["Share of college-educated workers employed\nin jobs that don’t require a college degree", workUnder_fb, workUnder_us]]
        });
      }
      function industry() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Top Industries with Highest Share of Immigrant Workers");
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 15,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[topIndustry1, topIndustry1v], [topIndustry2, topIndustry2v], [topIndustry3, topIndustry3v], [topIndustry4, topIndustry4v], [topIndustry5, topIndustry5v]]
        });
      }
      function occupation() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Top Occupations with Highest Share of Immigrant Workers");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 15,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[topOccupation1, topOccupation1v], [topOccupation2, topOccupation2v], [topOccupation3, topOccupation3v], [topOccupation4, topOccupation4v], [topOccupation5, topOccupation5v]]
        });
      }
      function stem() {
        var endnote5 = e + 1;
        e = e + 1;
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Science, Technology, Engineering, and Math");
        var stemText = $("#stemText");
        stemText = stemText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        stemText = doc.splitTextToSize(stemText, 530);
        doc.text(40, n + 20, stemText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 100,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Share of STEM workers who are immigrants", stemWorkersImm]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(265, n + 108, endnote5.toString());
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        endnoteArray.push("F_STEM");
        return;
      }
      function healthcare() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Healthcare");
        var healthText = $("#healthcareText");
        healthText = healthText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        healthText = doc.splitTextToSize(healthText, 530);
        doc.text(40, n + 20, healthText);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 98,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Nurses who are foreign-born", nurses], ["Health aides who are foreign-born", healthAides]]
        });
      }
      function housing() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "HOUSING");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var housingText = $("#housingText");
        housingText = housingText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        housingText = doc.splitTextToSize(housingText, 530);
        doc.text(40, n + 20, housingText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 85,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Immigrant homeowners", housingOwners], ["Share of recent homebuyers who were foreign-born", housingShare], ["Housing wealth held by immigrant households", housingWealth], ["Amount paid by immigrant-led households in rent", housingRent]]
        });
      }
      function international() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "INTERNATIONAL STUDENTS");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var internationalStdText = $("#internationalStdText");
        internationalStdText = internationalStdText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        internationalStdText = doc.splitTextToSize(internationalStdText, 530);
        doc.text(40, n + 20, internationalStdText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 75,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Students at " + nameProper2 + " colleges and universities who are international students", internationalStd], ["Economic contribution of international students", internationalStdEcon], ["Jobs supported by international students", internationalStdJobs]]
        });
        var intEndnote = e + 1;
        e = e + 1;
        endnoteArray.push("G_NAFSA");
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(230, n - 6, intEndnote.toString()); //footnotes
      }
      function naturalization() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "NATURALIZATION & VOTING POWER"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var naturalizationText = $("#naturalizationText");
        naturalizationText = naturalizationText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        naturalizationText = doc.splitTextToSize(naturalizationText, 530);
        doc.text(40, n + 20, naturalizationText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 60,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Share of immigrants who are naturalized U.S. citizens", naturalizationShare], ["Number of immigrants who are naturalized U.S. citizens", naturalizationValue], ["Number of immigrants who are eligible for naturalization", naturalizationEligible], ["Number of immigrants eligible to vote", naturalizationVote]]
        });
      }
      function undocumented_1() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "UNDOCUMENTED IMMIGRANTS");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var undocumentedText = $("#undocumentedText");
        undocumentedText = undocumentedText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        undocumentedText = doc.splitTextToSize(undocumentedText, 530);
        doc.text(40, n + 25, undocumentedText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 95,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of undocumented immigrants", undocumentedValue], ["Share of immigrant population who are undocumented immigrants", undocumentedShareImm], ["Share of population that is undocumented", undocumentedShareTotal], ["Share of workforce that is undocumented", undocumentedShareWork], ["Share of undocumented immigrants who are working age", undocumentedWorkers], ["Undocumented entrepreneurs", undocumentedEntre], ["Undocumented household income", undocumentedIncome], ["Total taxes paid", undocumentedTotalTax], ["Federal taxes paid", undocumentedFedTax], ["State & local taxes paid", undocumentedStateTx], ["Total spending power", undocumentedSpending], ["Number of U.S. citizens living with at least one undocumented family member", undocumentedOneFamValue], ["Share of U.S. citizens living with at least one undocumented family member", undocumentedOneFamShare]]
        });
        var undocEndnote1 = e + 1;
        var undocEndnote2 = e + 2;
        endnoteArray.push("H_UNDOC1", "I_UNDOC2");
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(242, n + 105, undocEndnote1.toString());
        doc.text(126, n + 263, undocEndnote2.toString());
        e = e + 2;
      }
      function undocumented_2() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "UNDOCUMENTED IMMIGRANTS"); //70
        doc.setFontSize(12);
        doc.text(255, n, "(CONTINUED)");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //

        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 25,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of U.S. citizen children living with at least one undocumented family member", undocumentedChildValue], ["Share of U.S. citizen children living with at least one undocumented family member", undocumentedChildShare], ["Number of U.S. citizen children living with at least one undocumented parent", undocumentedParentValue], ["Share of U.S. citizen children living with at least one undocumented parent", undocumentedParentShare]]
        });
      }
      function undocumented_3() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "UNDOCUMENTED IMMIGRANTS");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var undocumentedText = $("#undocumentedText");
        undocumentedText = undocumentedText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        undocumentedText = doc.splitTextToSize(undocumentedText, 530);
        doc.text(40, n + 25, undocumentedText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 85,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of undocumented immigrants", undocumentedValue], ["Share of immigrant population who are undocumented immigrants", undocumentedShareImm], ["Share of population that is undocumented", undocumentedShareTotal], ["Share of workforce that is undocumented", undocumentedShareWork], ["Share of undocumented immigrants who are working age", undocumentedWorkers], ["Undocumented entrepreneurs", undocumentedEntre], ["Undocumented household income", undocumentedIncome], ["Total taxes paid", undocumentedTotalTax], ["Federal taxes paid", undocumentedFedTax], ["State & local taxes paid", undocumentedStateTx], ["Total spending power", undocumentedSpending], ["Number of U.S. citizens living with at least one undocumented family member", undocumentedOneFamValue], ["Share of U.S. citizens living with at least one undocumented family member", undocumentedOneFamShare], ["Number of U.S. citizen children living with at least one undocumented family member", undocumentedChildValue], ["Share of U.S. citizen children living with at least one undocumented family member", undocumentedChildShare], ["Number of U.S. citizen children living with at least one undocumented parent", undocumentedParentValue], ["Share of U.S. citizen children living with at least one undocumented parent", undocumentedParentShare]]
        });
        var undocEndnote1 = e + 1;
        var undocEndnote2 = e + 2;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(242, n + 95, undocEndnote1.toString());
        doc.text(126, n + 253, undocEndnote2.toString());
        e = e + 2;
        endnoteArray.push("H_UNDOC1", "I_UNDOC2");
      }
      function undocIndustry() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Top Industries with Highest Share of Undocumented Immigrant Workers");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 15,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[undocInd1, undocShareInd1], [undocInd2, undocShareInd2], [undocInd3, undocShareInd3], [undocInd4, undocShareInd4], [undocInd5, undocShareInd5]]
        });
      }
      function daca() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "THE DACA-ELIGIBLE POPULATION"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var dacaText = $("#dacaText");
        dacaText = dacaText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        dacaText = doc.splitTextToSize(dacaText, 530);
        doc.text(40, n + 25, dacaText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 70,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of DACA-eligible residents", dacaValue], ["Employment rate of DACA-eligible population", dacaWork], ["Number of DACA-eligible entrepreneurs", dacaEntre], ["DACA-eligible household income", dacaIncome], ["Total taxes paid", dacaTotalTax], ["Federal taxes paid", dacaFedTax], ["State & local taxes paid", dacaStateTx], ["Total spending power", dacaSpending], ["Number of active DACA recipients", dacaActive], ["Number of people with DACA granted", dacaGranted], ["Number of additional residents who would satisfy all but the educational requirements for DACA", dacaEduc]]
        });
        var dacaEndnote1 = e + 1;
        var dacaEndnote2 = e + 2;
        var dacaEndnote3 = e + 3;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(210, n + 148, dacaEndnote1.toString());
        doc.text(215, n + 262, dacaEndnote2.toString());
        doc.text(231, n + 282, dacaEndnote3.toString());
        e = e + 3;
        endnoteArray.push("J_DACA1", "K_DACA2", "L_DACA3");
      }
      function dacaSmall() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "THE DACA-ELIGIBLE POPULATION"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var dacaText = $("#dacaText");
        dacaText = dacaText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        dacaText = doc.splitTextToSize(dacaText, 530);
        doc.text(40, n + 25, dacaText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 70,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of active DACA recipients", dacaActive], ["Number of people with DACA granted", dacaGranted]]
        });
        var dacaEndnote2 = e + 1;
        var dacaEndnote3 = e + 2;
        endnoteArray.push("K_DACA2", "L_DACA3");
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(214, n + 80, dacaEndnote2.toString());
        doc.text(231, n + 100, dacaEndnote3.toString());
        e = e + 2;
      }
      function refugees() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "REFUGEES"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var refugeeEndnote1 = e + 1;
        var refugeeEndnote2 = e + 2;
        doc.setFont("Karla-Bold", "bold");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(114, n - 5, refugeeEndnote1.toString());
        var refugeeText = $("#refugeeText");
        refugeeText = refugeeText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        refugeeText = doc.splitTextToSize(refugeeText, 530);
        doc.text(40, n + 25, refugeeText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 75,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of likely refugees", refugeeValue], ["Employment rate of likely refugees", refugeeWork], ["Share of refugees who are naturalized U.S. citizens", refugeeNat], ["Refugee household income", refugeeIncome], ["Total taxes paid", refugeeTotalTax], ["Federal taxes paid", refugeeFedTax], ["State & local taxes paid", refugeeStateTx], ["Total spending power", refugeeSpending], ["Number of refugee entrepreneurs", refugeeEntre], ["Total business income of refugee entrepreneurs", refugeeEntreIncome], ["Number of refugees resettled in the last fiscal year", refugeeResettle]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(300, n + 312, refugeeEndnote2.toString());
        e = e + 2;
        endnoteArray.push("M_REFUGEE", "N_REFUGEE2");
      }
      function refugeeSmallTable() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "REFUGEES"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var refugeeEndnote2 = e + 1;
        var refugeeText = $("#refugeeText");
        refugeeText = refugeeText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        refugeeText = doc.splitTextToSize(refugeeText, 530);
        doc.text(40, n + 25, refugeeText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 75,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of refugees resettled in the last fiscal year", refugeeResettle]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(300, n + 85, refugeeEndnote2.toString());
        e = e + 1;
        endnoteArray.push("N_REFUGEE2");
      }
      function refugeeOrigin() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Top Countries of Origin for Refugees Resettled in the Last Fiscal Year");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 15,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[refugeeCountry1, refugeeCountry1Share], [refugeeCountry2, refugeeCountry2Share], [refugeeCountry3, refugeeCountry3Share], [refugeeCountry4, refugeeCountry4Share], [refugeeCountry5, refugeeCountry5Share]]
        });
      }
      function temporaryStatus() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "TEMPORARY PROTECTED STATUS HOLDERS");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var tpsText = $("#tpsText");
        tpsText = tpsText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        tpsText = doc.splitTextToSize(tpsText, 530);
        doc.text(40, n + 25, tpsText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 75,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of TPS holders", tpsValue], ["Share of TPS holders who are working age", tpsWork], ["Employment rate of TPS holders", tpsEmploy], ["TPS household income", tpsIncome], ["Total taxes paid", tpsTotalTax], ["Federal taxes paid", tpsFedTax], ["State & local taxes paid", tpsStateTx], ["Total spending power", tpsSpending]]
        });
        var tpsEndnote = e + 1;
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(160, n + 85, tpsEndnote.toString());
        e = e + 1;
        endnoteArray.push("O_TPS");
      }

      //tpsSmall

      function temporaryStatusSmall() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "TEMPORARY PROTECTED STATUS HOLDERS");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var tpsText = $("#tpsText");
        tpsText = tpsText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        tpsText = doc.splitTextToSize(tpsText, 530);
        doc.text(40, n + 25, tpsText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 75,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Number of TPS holders", tpsValue]]
        });
        var tpsEndnote = e + 1;
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(160, n + 85, tpsEndnote.toString());
        e = e + 1;
        endnoteArray.push("O_TPS");
      }
      function endnote() {
        p = p + 1;
        var en = 230;
        newPage(p);
        doc.setFontSize(9);
        doc.setFont("Karla-Regular", "regular");
        doc.text(40, 70, "To learn more about Map the Impact, visit");
        doc.setTextColor(51, 102, 204);
        doc.textWithLink("maptheimpact.org.", 214, 70, {
          url: "https://data.americanimmigrationcouncil.org/map-the-impact/"
        });
        doc.setTextColor(0, 0, 0);
        doc.text(40, 90, "The American Immigration Council works to empower immigrants from arrival to belonging.");
        doc.text(40, 100, "To learn more about the Council's work, visit");
        doc.setTextColor(51, 102, 204);
        doc.textWithLink("americanimmigrationcouncil.org.", 224, 100, {
          url: "https://americanimmigrationcouncil.org."
        });
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(14);
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setTextColor(51, 102, 204);
        doc.text(40, 130, "ENDNOTES");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, 135, 580, 135, "S");
        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0);
        doc.setFont("Karla-Regular", "regular");
        doc.text(48, 150, "1.", {
          align: "right"
        });
        doc.text(55, 150, "Unless otherwise specified, data comes from the American Immigration Council analysis of microdata from the 1-year", {
          align: "left"
        });
        doc.text(55, 160, "sample of the 2023 American Community Survey (ACS), downloaded from the Integrated Public Use Microdata Series (IPUMS)", {
          align: "left"
        });
        // doc.text(
        //   55,
        //   170,
        //   "Use Microdata Series (IPUMS),",
        //    { align: "left" }
        // );
        doc.setTextColor(51, 102, 204);
        doc.textWithLink("https://www.ipums.org/.", 55, 170, {
          url: "https://www.ipums.org/"
        });
        doc.setTextColor(0, 0, 0);
        doc.text(48, 190, "2.", {
          align: "right"
        });
        doc.text(55, 190, "Except where otherwise noted, an immigrant refers to anyone born outside the country to non-U.S. citizen parents who", {
          align: "left"
        });
        doc.text(55, 200, "is resident in the United States. This includes naturalized citizens, green card holders, individuals holding temporary");
        doc.text(55, 210, "(nonimmigrant) status, refugees, asylees, and undocumented immigrants, among others.");

        // ['C_CBO', 'D_ITEP', 'E_STEM', 'F_NAFSA', 'G_UNDOC1', 'H_UNDOC2', 'I_DACA1', 'J_DACA2', 'K_DACA3', 'L_REFUGEE']

        for (var i = 0; i < endnoteArray.length; i++) {
          if (endnoteArray[i] == "C_ENTRE") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "American Immigration Council analysis of the 2024 Fortune 500 rankings", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://fortune.com/ranking/fortune500/.", 55, en + 10, {
              url: "https://fortune.com/ranking/fortune500/"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "D_CBO") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Congressional Budget Office. 2022. “The Distribution of Household Income and Federal Taxes, 2019.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.cbo.gov/publication/58353.", 55, en + 10, {
              url: "https://www.cbo.gov/publication/58353"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "E_ITEP") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Institute on Taxation and Economic Policy (ITEP). 2024. “Who Pays? A Distributional Analysis of the Tax Systems in", {
              align: "left"
            });
            doc.text(55, en + 10, "All 50 States (7th edition).“", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://itep.org/whopays-7th-edition/.", 171, en + 10, {
              url: "https://itep.org/whopays-7th-edition/"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "F_STEM") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "U.S. Census Bureau. 2018. “STEM, STEM-related, and Non-STEM Occupation Code List 2018.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www2.census.gov/programs-surveys/demo/guidance/industry-occupation/", 55, en + 10, {
              url: "https://www2.census.gov/programs-surveys/demo/guidance/industry-occupation/2018-census-stem-related-and-non-stem-occupation-code-list.xlsx"
            });
            doc.textWithLink("2018-census-stem-related-and-non-stem-occupation-code-list.xlsx", 55, en + 20, {
              url: "https://www2.census.gov/programs-surveys/demo/guidance/industry-occupation/2018-census-stem-related-and-non-stem-occupation-code-list.xlsx"
            });
            en = en + 40;
          }
          if (endnoteArray[i] == "G_NAFSA") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "We use the state-level data of international students in the 2023-24 academic year from the “International Student", {
              align: "left"
            });
            doc.text(55, en + 10, "Economic Value Tool” developed by NAFSA,");
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("www.nafsa.org/economicvalue.", 237, en + 10, {
              url: "www.nafsa.org/economicvalue"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "H_UNDOC1") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "We use data from the ACS to arrive at an estimate of the undocumented immigrant population by applying the", {
              align: "left"
            });
            doc.text(55, en + 10, "methodological approach outlined by Harvard University economist George Borjas in his 2016 NBER working paper, ");
            doc.text(55, en + 20, '“The Labor Supply of Undocumented Immigrants",');
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://ideas.repec.org/p/nbr/nberwo/22102.html.", 268, en + 20, {
              url: "https://ideas.repec.org/p/nbr/nberwo/22102.html"
            });
            en = en + 40;
          }
          if (endnoteArray[i] == "I_UNDOC2") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "When estimating the tax contributions of undocumented immigrants, we follow the methodology detailed by Institute", {
              align: "left"
            });
            doc.text(55, en + 10, "on Taxation and Economic Policy (ITEP). ITEP. 2024 “Tax Payments By Undocumented Immigrants.”");
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://itep.org/undocumented-immigrants-taxes-2024/.", 55, en + 20, {
              url: "https://itep.org/undocumented-immigrants-taxes-2024/"
            });
            en = en + 40;
          }
          if (endnoteArray[i] == "J_DACA1") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "We treat each DACA-eligible individual as a single taxpaying unit, following the lead of other groups that have also", {
              align: "left"
            });
            doc.text(55, en + 10, "sought to quantify the economic and tax contributions of this population, such as ITEP in its report “State & Local Tax");
            doc.text(55, en + 20, "Contributions of Young Undocumented Immigrants”,");
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://itep.sfo2.digitaloceanspaces.com/2017DACA.pdf.", 280, en + 20, {
              url: "https://itep.sfo2.digitaloceanspaces.com/2017DACA.pdf"
            });
            en = en + 40;
          }
          if (endnoteArray[i] == "K_DACA2") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "U.S. Citizenship and Immigration Services (USCIS). 2024. “Active DACA Recipients - Fiscal Year 2024, Quarter 4", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.uscis.gov/sites/default/files/document/data/active_daca_recipients_fy2024_q4.xlsx.", 55, en + 10, {
              url: "https://www.uscis.gov/sites/default/files/document/data/active_daca_recipients_fy2024_q4.xlsx"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "L_DACA3") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "USCIS. 2024. “Deferred Action for Childhood Arrivals (DACA) Quarterly Report (Fiscal Year 2024, Quarter 4).”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink(" https://www.uscis.gov/sites/default/files/document/data/daca_performancedata_fy2024_q4.xlsx.", 55, en + 10, {
              url: "https://www.uscis.gov/sites/default/files/document/data/daca_performancedata_fy2024_q4.xlsx"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "M_REFUGEE") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "To identify cases in microdata from the 2023 ACS that are likely to be refugees, we use an imputation method", {
              align: "left"
            });
            doc.text(55, en + 10, "based on each foreign-born respondent’s country of birth and their year of arrival, similar to the work of");
            doc.text(55, en + 20, "Kallick and Mathema in “Refugee Integration in the United States,”");
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.americanprogress.org/article/refugee-integration-in-the-united-states,", 55, en + 30, {
              link: "https://www.americanprogress.org/article/refugee-integration-in-the-united-states"
            });
            doc.setTextColor(0, 0, 0);
            doc.text(55, en + 40, "as well as Capps et al in “The Integration Outcomes of U.S. Refugees: Successes and Challenges");
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.migrationpolicy.org/research/integration-outcomes-us-refugees-successes-and-challenges.", 55, en + 50, {
              url: "https://www.migrationpolicy.org/research/integration-outcomes-us-refugees-successes-and-challenges"
            });
            en = en + 70;
          }
          if (endnoteArray[i] == "N_REFUGEE2") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Refugee Processing Center (RPC). 2024. “FY 2024 Refugee Arrivals by State and Nationality.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.wrapsnet.org/archives/", 55, en + 10, {
              url: "https://www.wrapsnet.org/archives/"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "O_TPS") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Congressional Research Service (CRS). 2023. “Temporary Protected Status and Deferred Enforced Departure.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://crsreports.congress.gov/product/pdf/RS/RS20844/70", 55, en + 10, {
              url: "https://crsreports.congress.gov/product/pdf/RS/RS20844/70"
            });
            en = en + 30;
          }
        }
      }
      if (originCountriesTable == 1) {
        if (n + 165 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        originCountries(n);
        n = n + 165;
      }
      if (entrepreneurshipTable == 1) {
        if (n + 220 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        entrepreneurship(n);
        n = n + 220;
      }
      if (taxesTable == 1) {
        if (n + 300 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        taxesSpending(n);
        n = n + 300;
        CBO = 1;
        ITEP = 1;
      }
      if (workforceTable == 1) {
        if (n + 150 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        workforce(n);
        n = n + 150;
      }
      if (educationTable == 1) {
        if (n + 190 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        education(n);
        n = n + 190;
      }
      if (industryTable == 1) {
        if (n + 165 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        industry(n);
        n = n + 160;
      }
      if (occupationTable == 1) {
        if (n + 160 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        occupation(n);
        n = n + 160;
      }
      if (stemTable == 1) {
        if (n + 155 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        stem(n);
        STEM = 1;
        n = n + 155;
      }
      if (healthcareTable == 1) {
        if (n + 175 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        healthcare(n);
        n = n + 175;
      }
      if (housingTable == 1) {
        if (n + 210 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        housing(n);
        n = n + 210;
      }
      if (internationalTable == 1) {
        if (n + 190 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        international(n);
        NAFSA = 1;
        n = n + 190;
      }
      if (naturalizationTable == 1) {
        if (n + 185 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        naturalization(n);
        n = n + 185;
      }
      if (undocumentedTable == 1) {
        if (n + 570 >= 770) {
          if (n + 330 >= 770) {
            p = p + 1;
            n = 75;
            newPage(p);
            UNDOC1 = 1;
            UNDOC2 = 1;
            undocumented_3();
            n = n + 570;
          } else {
            undocumented_1();
            p = p + 1;
            n = 75;
            UNDOC1 = 1;
            UNDOC2 = 1;
            newPage(p);
            undocumented_2();
            n = n + 200;
          }
        } else {
          undocumented_3();
          UNDOC1 = 1;
          UNDOC2 = 1;
          n = n + 570;
        }
      }
      if (undocIndustryTable == 1) {
        if (n + 160 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        undocIndustry(n);
        n = n + 160;
      }
      if (dacaTable == 1) {
        if (n + 365 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        daca(n);
        n = n + 365;
      }
      if (dacaSmallTable == 1) {
        if (n + 150 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        dacaSmall(n);
        n = n + 150;
      }
      if (refugeesTable == 1) {
        if (n + 360 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        refugees(n);
        n = n + 360;
      }
      if (refugeeSmall == 1) {
        if (n + 132 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        refugeeSmallTable(n);
        n = n + 132;
      }
      if (refugeesTableOrigin == 1) {
        if (n + 160 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        refugeeOrigin(n);
        n = n + 160;
      }
      if (tpsTable == 1) {
        if (n + 310 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        temporaryStatus();
        n = n + 310;
      }
      if (tpsSmall == 1) {
        if (n + 150 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        temporaryStatusSmall();
        n = n + 150;
      }
      endnote();
      var download_button = document.getElementById("downloadButton");
      var file_name = "AIC_Map_the_Impact-" + name + ".pdf";
      download_button.addEventListener("click", function () {
        doc.save(file_name);
      });
    }, 100);
  }
}
function mti_generate_pdf_es() {
  var name = document.getElementById("page-term-name").textContent;

  // var name = "Estados Unidos"

  if (name == "United States of America") {
    name = "National";
  }
  var keyName = name;
  if (name == "Misisipí") {
    keyName = "Misisipi";
    nameProper = "Misisipí";
    nameProper2 = "Misisipí";
  }
  if (name == "Nuevo México") {
    keyName = "Nuevo Mexico";
    nameProper = "Nuevo México";
    nameProper2 = "Nuevo México";
  }
  if (name == "Oregón") {
    keyName = "Oregon";
    nameProper = "Oregón";
    nameProper2 = "Oregón";
  }
  var nameProper = name;
  var nameProper2 = nameProper;
  if (nameProper == "National" || nameProper == "Estados Unidos") {
    nameProper2 = "Los Estados Unidos";
    console.log(nameProper2);
  }
  if (nameProper == "District of Columbia") {
    nameProper = "El Distrito de Columbia";
    nameProper2 = "El Distrito de Columbia";
  }
  if (nameProper == "Hawaii") {
    nameProper = "Hawái";
    nameProper2 = "Hawái";
  }
  // if (nameProper=="New Jersey") { nameProper="Nueva Jersey"; nameProper2="Nueva Jersey";}
  // if (nameProper=="New Mexico") { nameProper="Nuevo México"; nameProper2=="Nuevo México";}
  // if (nameProper=="New York") { nameProper="Nueva York"; nameProper2="Nueva York";}
  // if (nameProper=="North Carolina") { nameProper="Carolina del Norte"; nameProper2="Carolina del Norte";}
  // if (nameProper=="North Dakota") { nameProper="Dakota del Norte"; nameProper2="Dakota del Norte";}
  if (nameProper == "Oregon") {
    nameProper = "Oregón";
    nameProper2 = "Oregón";
  }
  // if (nameProper=="South Carolina") { nameProper="Carolina del Sur"; nameProper2="Carolina del Sur";}
  // if (nameProper=="South Dakota") { nameProper="Dakota del Sur"; nameProper2="Dakota del Sur";}
  // if (nameProper=="West Virginia") { nameProper="Virginia Occidental"; nameProper2="Virginia Occidental";}

  var ENTRE = 0,
    //Number 3
    CBO = 0,
    //Number 4
    ITEP = 0,
    //Number 5
    STEM = 0,
    //Number 6
    NAFSA = 0,
    //Number 7
    UNDOC1 = 0,
    //Number 8
    UNDOC2 = 0,
    //Number 9
    DACA1 = 0,
    //Number 10
    DACA2 = 0,
    //Number 11
    DACA3 = 0,
    //Number 12
    REFUGEE = 0,
    //Number 13
    REFUGEE2 = 0,
    //Number 14
    TPS = 9; //Number 15

  var endnoteArray = ["A_first", "B_second"];
  var jsPDF = window.jspdf.jsPDF;
  var imgWidth = 100;
  var imgHeight = 73;

  // var AIC_GLOBAL_VARS = "https://mtistaging.wpengine.com/wp-content/themes/map-the-impact"
  // var state_data

  // const AIC_GLOBAL_VARS = {
  //   url: "https://example.com/data" // or whatever the base URL is
  // };

  // state_data = d3.json(AIC_GLOBAL_VARS.url + "/mti-state-2022.json");

  // var usData = state_data

  var usData = _config.state_data;

  // var usData = d3.json(
  //   "https://mtistaging.wpengine.com/wp-content/themes/map-the-impact/mti-state-2022.json"
  // );

  var stateSize = _config.state_image_size;

  // var mti_key = d3.csv("https://immcouncil-data.s3.us-east-2.amazonaws.com/state_data_with_key.csv")

  var mti_key = d3.csv(AIC_GLOBAL_VARS.url + "/static/data/map-the-impact/state_data_with_key_updateV5.csv");
  var dataPDF = [usData, stateSize, mti_key];
  function addComma() {}
  prepareAndStartChange();
  function prepareAndStartChange() {
    Promise.all(dataPDF).then(startChange);
  }
  function startChange(dataPDF) {
    if (name == "National" || name == "Estado Unidos") {
      nameProper = "Estados Unidos";
      nameProper = "Los Estados Unidos";
    }
    var stateData = dataPDF[0].filter(function (d) {
      return d["Account Name"] === name;
    });
    var sizeFile = dataPDF[1].filter(function (d) {
      return d["stateName"] === keyName;
    });
    var mti_keyFile = dataPDF[2].filter(function (d) {
      return d["State"] === keyName;
    });
    // var stateData = data[0].filter(function(d) { return d["Account Name"] === "District of Columbia"})

    var originCountriesTable = mti_keyFile[0]["originCountriesTable"],
      entrepreneurshipTable = mti_keyFile[0]["entrepreneurshipTable"],
      taxesTable = mti_keyFile[0]["taxesTable"],
      workforceTable = mti_keyFile[0]["workforceTable"],
      educationTable = mti_keyFile[0]["educationTable"],
      industryTable = mti_keyFile[0]["industryTable"],
      occupationTable = mti_keyFile[0]["occupationTable"],
      stemTable = mti_keyFile[0]["stemTable"],
      healthcareTable = mti_keyFile[0]["healthcareTable"],
      housingTable = mti_keyFile[0]["housingTable"],
      internationalTable = mti_keyFile[0]["internationalTable"],
      naturalizationTable = mti_keyFile[0]["naturalizationTable"],
      undocumentedTable = mti_keyFile[0]["undocumentedTable"],
      undocIndustryTable = mti_keyFile[0]["undocIndustryTable"],
      dacaTable = mti_keyFile[0]["dacaTable"],
      dacaSmallTable = mti_keyFile[0]["dacaSmallTable"],
      refugeesTable = mti_keyFile[0]["refugeesTable"],
      refugeesTableOrigin = mti_keyFile[0]["refugeesTableOrigin"],
      tpsTable = mti_keyFile[0]["tpsTable"],
      tpsSmall = mti_keyFile[0]["tpsSmall"],
      refugeeSmall = mti_keyFile[0]["refugeeSmall"];

    // console.log(originCountriesTable, entrepreneurshipTable, taxesTable, workforceTable,
    // educationTable, industryTable, occupationTable, stemTable,
    // healthcareTable, housingTable, internationalTable, naturalizationTable,
    // undocumentedTable, undocIndustryTable, dacaTable, dacaSmallTable,
    // refugeesTable, refugeesTableOrigin, tpsTable, tpsSmall, refugeeSmall)

    var dacaEducValue = stateData[0]["DACA, # of Additional Residents Who Would Satisfy All But Edu Rec"];
    var dacaEduc;
    if (Number.isInteger(dacaEducValue)) {
      var str;
      str = dacaEducValue.toLocaleString();
      var cleanedStr = str.replace(/,/g, "");

      // Convert the cleaned string to a number
      var num = parseFloat(cleanedStr);

      // Check if the conversion resulted in a valid number
      if (isNaN(num)) {
        throw new Error("Invalid number");
      }

      // Round the number to the nearest 100
      var roundedNum = Math.round(num / 100) * 100;

      // Return the rounded number with commas as a string
      dacaEduc = roundedNum.toLocaleString();
    } else {
      dacaEduc = (0, _misc.aic_round_to_nearest_hundred)(dacaEducValue);
    }
    var dacaEntreValue = stateData[0]["Immigrant Entrepreneurs, DACA-Eligible"];
    var dacaEntre;
    if (Number.isInteger(dacaEntreValue)) {
      dacaEntre = dacaEntreValue.toLocaleString();
      dacaEntre = (0, _misc.aic_round_to_nearest_hundred)(dacaEntre);
    } else {
      dacaEntre = (0, _misc.aic_round_to_nearest_hundred)(dacaEntreValue);
    }
    setTimeout(function () {
      // Generate PDF
      var doc = new jsPDF("p", "pt", "letter"),
        intro = stateData[0]["Introduction"],
        overview0 = stateData[0]["Immigrant Share of Population"],
        overview1 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant Residents"]),
        overview2 = stateData[0]["Immigrant Spending Power"],
        overview3 = stateData[0]["Immigrant Taxes Paid"],
        demo0 = stateData[0]["U.S.-born Residents, At Least One Immigrant Parent, %"],
        demo1 = stateData[0]["Foreign-Born, Women"],
        demo2 = stateData[0]["Foreign-Born, Men"],
        demo3 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Foreign-Born, Children"]),
        demo4 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["U.S.-born Residents, At Least One Immigrant Parent"]),
        demo5 = stateData[0]["Foreign-Born, Share Proficient in English"],
        demoAge_1_1 = stateData[0]["Foreign-Born, Ages 0-15"],
        demoAge_1_2 = stateData[0]["Native-Born, Ages 0-15"],
        demoAge_2_1 = stateData[0]["Foreign-Born, Ages 16-64"],
        demoAge_2_2 = stateData[0]["Native-Born, Ages 16-64"],
        demoAge_3_1 = stateData[0]["Foreign-Born, Ages 65+"],
        demoAge_3_2 = stateData[0]["Native-Born, Ages 65+"],
        topCountry1 = stateData[0]["#1 Country of Origin"],
        topCountry2 = stateData[0]["#2 Country of Origin"],
        topCountry3 = stateData[0]["#3 Country of Origin"],
        topCountry4 = stateData[0]["#4 Country of Origin"],
        topCountry5 = stateData[0]["#5 Country of Origin"],
        topCountry1v = stateData[0]["#1 Country of Origin, Value"],
        topCountry2v = stateData[0]["#2 Country of Origin, Value"],
        topCountry3v = stateData[0]["#3 Country of Origin, Value"],
        topCountry4v = stateData[0]["#4 Country of Origin, Value"],
        topCountry5v = stateData[0]["#5 Country of Origin, Value"],
        entre1 = stateData[0]["Entrepreneur, Foreign-Born Share"],
        entre2 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant Entrepreneurs"]),
        entre3 = stateData[0]["Business Income of Immigrant Entrepreneurs"],
        entre4 = stateData[0]["Fortune 500 Companies"],
        taxes1 = stateData[0]["Immigrant Household Income"],
        taxes2 = stateData[0]["Immigrant Spending Power"],
        taxes3 = stateData[0]["State & Local Taxes"],
        taxes4 = stateData[0]["Federal Taxes"],
        taxes5 = stateData[0]["Immigrant Taxes Paid"],
        taxes6 = stateData[0]["Foreign-born, Contributions to Social Security"],
        taxes7 = stateData[0]["Foreign-born, Contributions to Medicare"],
        work1 = stateData[0]["Labor Force, Foreign-Born Share"],
        work2 = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Labor Force, Foreign-Born"]),
        work3_1_1 = stateData[0]["Foreign-Born, Less Than High School"],
        work3_1_2 = stateData[0]["Native-Born, Less Than High School"],
        work3_2_1 = stateData[0]["Foreign-Born, High School & Some College"],
        work3_2_2 = stateData[0]["Native-Born, High School & Some College"],
        work3_3_1 = stateData[0]["Foreign-Born, Bachelor's Degree"],
        work3_3_2 = stateData[0]["Native-Born, Bachelor's Degree"],
        work3_4_1 = stateData[0]["Foreign-Born, Graduate Degree"],
        work3_4_2 = stateData[0]["Native-Born, Graduate Degree"],
        workUnder_fb = stateData[0]["Foreign-Born, Underemployed"],
        workUnder_us = stateData[0]["US-Born, Underemployed"],
        topIndustry1 = stateData[0]["#1 Industry"],
        topIndustry1v = stateData[0]["#1 Industry, Value"],
        topIndustry2 = stateData[0]["#2 Industry"],
        topIndustry2v = stateData[0]["#2 Industry, Value"],
        topIndustry3 = stateData[0]["#3 Industry"],
        topIndustry3v = stateData[0]["#3 Industry, Value"],
        topIndustry4 = stateData[0]["#4 Industry"],
        topIndustry4v = stateData[0]["#4 Industry, Value"],
        topIndustry5 = stateData[0]["#5 Industry"],
        topIndustry5v = stateData[0]["#5 Industry, Value"],
        topOccupation1 = stateData[0]["#1 Occupation"],
        topOccupation1v = stateData[0]["#1 Occupation, Value"],
        topOccupation2 = stateData[0]["#2 Occupation"],
        topOccupation2v = stateData[0]["#2 Occupation, Value"],
        topOccupation3 = stateData[0]["#3 Occupation"],
        topOccupation3v = stateData[0]["#3 Occupation, Value"],
        topOccupation4 = stateData[0]["#4 Occupation"],
        topOccupation4v = stateData[0]["#4 Occupation, Value"],
        topOccupation5 = stateData[0]["#5 Occupation"],
        topOccupation5v = stateData[0]["#5 Occupation, Value"],
        stemWorkersImm = stateData[0]["STEM workers who are immigrants"],
        nurses = stateData[0]["Nurses who are foreign-born"],
        healthAides = stateData[0]["Health aides who are foreign-born"],
        housingOwners = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant homeowners"]),
        housingShare = stateData[0]["Share of recent homebuyers who were foreign-born"],
        housingWealth = stateData[0]["Housing wealth held by immigrant households"],
        housingRent = stateData[0]["Amount paid by immigrant-led households in rent"],
        internationalStd = stateData[0]["Students at [state] colleges and universities who are international"],
        internationalStdEcon = stateData[0]["Economic contribution of international students"],
        internationalStdJobs = stateData[0]["Jobs supported by international students"].toLocaleString(),
        naturalizationShare = stateData[0]["Foreign-Born, Naturalized Share"],
        naturalizationVote = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrants eligible to vote"]),
        naturalizationValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Foreign-Born, Naturalized"]),
        naturalizationEligible = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Foreign-Born, Eligible to Naturalize"]),
        undocumentedWorkers = stateData[0]["Share of undocumented immigrants, working age"],
        undocumentedValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Undocumented Immigrants"]),
        undocumentedEntre = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant entrepreneurs, Undocumented Immigrants"]),
        undocumentedIncome = stateData[0]["Immigrant Household Income, Undocumented Immigrants"],
        undocumentedSpending = stateData[0]["Immigrant Spending Power, Undocumented Immigrants"],
        undocumentedStateTx = stateData[0]["State & Local Taxes, Undocumented Immigrants"],
        undocumentedFedTax = stateData[0]["Federal Taxes, Undocumented Immigrants"],
        undocumentedTotalTax = stateData[0]["Taxes Paid, Undocumented Immigrants"],
        undocumentedShareImm = stateData[0]["Foreign-Born, Share Undocumented"],
        undocumentedShareTotal = stateData[0]["Total Pop, Share Undocumented"],
        undocumentedShareWork = stateData[0]["Labor Force, Share Undocumented"],
        undocumentedOneFamValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["U.S. Citizens Living With >= 1 Undoc Fam Member"]),
        undocumentedOneFamShare = stateData[0]["U.S. Citizens Living With >= 1 Undoc Fam Member, Share"],
        undocumentedChildValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["U.S. Citizen Children Living With >= 1 Undoc Fam Member"]),
        undocumentedChildShare = stateData[0]["U.S. Citizen Children Living With >= 1 Undoc Fam Member, Share"],
        undocumentedParentValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["U.S. Citizen Children Living With >= 1 Undoc Parent"]),
        undocumentedParentShare = stateData[0]["U.S. Citizen Children Living With >= 1 Undoc Parent, Share"],
        dacaActive = stateData[0]["Number of Active DACA Recipients"].toLocaleString(),
        dacaWork = stateData[0]["Share of DACA Eligible Population in Labor Force that is Employed"],
        dacaValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Number of DACA Eligible Residents"]),
        // dacaEduc = aic_round_to_nearest_hundred(
        //   stateData[0][
        //     "DACA, # of Additional Residents Who Would Satisfy All But Edu Rec"
        //   ]
        // ),
        // dacaEntre = aic_round_to_nearest_hundred(
        //   stateData[0]["Immigrant Entrepreneurs, DACA-Eligible"]
        // ),
        dacaIncome = stateData[0]["Immigrant Household Income, DACA-Eligible"],
        dacaSpending = stateData[0]["Immigrant Spending Power, DACA-Eligible"],
        dacaStateTx = stateData[0]["State & Local Taxes, DACA-Eligible"],
        dacaFedTax = stateData[0]["Federal Taxes, DACA-Eligible"],
        dacaTotalTax = stateData[0]["Taxes Paid, DACA-Eligible"],
        dacaGranted = stateData[0]["Number of People with DACA Granted"].toLocaleString(),
        refugeeWork = stateData[0]["Share of Refugees in Labor Force, Employed"],
        refugeeValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Number of Refugees"]),
        refugeeIncome = stateData[0]["Refugees' Household Income"],
        refugeeSpending = stateData[0]["Refugees' Total Spending Power"],
        refugeeStateTx = stateData[0]["State & Local Taxes, Refugees"],
        refugeeFedTax = stateData[0]["Federal Taxes, Refugees"],
        refugeeTotalTax = stateData[0]["Taxes Paid, Refugees"],
        refugeeEntre = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Immigrant Entrepreneurs, Refugees"]),
        refugeeEntreIncome = stateData[0]["Business Income of Refugee Entrepreneurs"],
        refugeeNat = stateData[0]["Refugee, Pct Naturalized"],
        refugeeResettle = stateData[0]["Recent Refugees Resettled"].toLocaleString(),
        tpsWork = stateData[0]["Share of TPS Holders, Working Age"],
        tpsValue = (0, _misc.aic_round_to_nearest_hundred)(stateData[0]["Number of TPS Holders"]),
        tpsEmploy = stateData[0]["Share of TPS Holders in Labor Force, Employed"],
        tpsIncome = stateData[0]["TPS Holders' Household Income"],
        tpsSpending = stateData[0]["TPS Holders' Total Spending Power"],
        tpsStateTx = stateData[0]["State & Local Taxes, TPS Holders"],
        tpsFedTax = stateData[0]["Federal Taxes, TPS Holders"],
        tpsTotalTax = stateData[0]["Taxes Paid, TPS Holders"],
        newWidth = Number(sizeFile[0]["newWidth"]),
        newLength = Number(sizeFile[0]["newLength"]),
        undocInd1 = stateData[0]["Undoc #1 Industry"],
        undocInd2 = stateData[0]["Undoc #2 Industry"],
        undocInd3 = stateData[0]["Undoc #3 Industry"],
        undocInd4 = stateData[0]["Undoc #4 Industry"],
        undocInd5 = stateData[0]["Undoc #5 Industry"],
        undocShareInd1 = stateData[0]["#1 Industry, Pct Undoc"],
        undocShareInd2 = stateData[0]["#2 Industry, Pct Undoc"],
        undocShareInd3 = stateData[0]["#3 Industry, Pct Undoc"],
        undocShareInd4 = stateData[0]["#4 Industry, Pct Undoc"],
        undocShareInd5 = stateData[0]["#5 Industry, Pct Undoc"],
        refugeeCountry1 = stateData[0]["Recent Refugee - #1 Country of Origin"],
        refugeeCountry2 = stateData[0]["Recent Refugee - #2 Country of Origin"],
        refugeeCountry3 = stateData[0]["Recent Refugee - #3 Country of Origin"],
        refugeeCountry4 = stateData[0]["Recent Refugee - #4 Country of Origin"],
        refugeeCountry5 = stateData[0]["Recent Refugee - #5 Country of Origin"],
        refugeeCountry1Share = stateData[0]["Recent Refugee - #1 Country of Origin, Value"],
        refugeeCountry2Share = stateData[0]["Recent Refugee - #2 Country of Origin, Value"],
        refugeeCountry3Share = stateData[0]["Recent Refugee - #3 Country of Origin, Value"],
        refugeeCountry4Share = stateData[0]["Recent Refugee - #4 Country of Origin, Value"],
        refugeeCountry5Share = stateData[0]["Recent Refugee - #5 Country of Origin, Value"];
      var introText = $('[data-mti-data-label= "dataYear"]').text(),
        overview1_text = $('[data-mti-data-label="immResidents"]').text(),
        overview0_text = "Porcentaje de inmigrantes en la población",
        overview2_text = "Poder adquisitivo de los inmigrantes",
        overview3_text = $('[data-mti-data-label="immTaxesPaid"]').text(),
        demo3_text = $('[data-mti-data-label="demo_number_immigrantChildren"]').text(),
        demo2_text = $('[data-mti-data-label="demo_number_immigrantMen"]').text(),
        demo1_text = $('[data-mti-data-label="demo_number_immigrantWomen"]').text(),
        demoAge_1_1_text = $('[data-mti-data-label="demoForeignBorn015"]').text(),
        demoAge_2_1_text = $('[data-mti-data-label="demoForeignBorn1664"]').text(),
        demoAge_3_1_text = $('[data-mti-data-label="demoForeignBorn65"]').text(),
        demoAge_1_2_text = $('[data-mti-data-label= "demoNativeBorn015"]').text(),
        demoAge_2_2_text = $('[data-mti-data-label="demoNativeBorn1664"]').text(),
        demoAge_3_2_text = $('[data-mti-data-label="demoNativeBorn65"]').text(),
        demo4_text = $('[data-mti-data-label="demo_number_oneImmigrantParent"]').text(),
        demo0_text = $('[data-mti-data-label="demo_share_oneImmigrantParent"]').text(),
        demo5_text = $('[data-mti-data-label="demo_share_immProficientEnglish"]').text(),
        entre2_text = $('[data-mti-data-label="immEntrepreneurs"]').text(),
        entre1_text = $('[data-mti-data-label="shareEntrepreneursImm"]').text(),
        entre3_text = $('[data-mti-data-label="busIncomeImmEntrepreneurs"]').text(),
        entre4_text = $('[data-mti-data-label="entrepreneurship-fortune500"]').text(),
        work3_1_1_text = $('[data-mti-data-label="workforceForeignLessHighSchool"]').text(),
        work3_2_1_text = $('[data-mti-data-label="workforceForeignHighSchoolSomeCollege"]').text(),
        work3_3_1_text = $('[data-mti-data-label="workforceForeignBachelors"]').text(),
        work3_4_1_text = $('[data-mti-data-label="workforceForeignGraduate"]').text(),
        work3_1_2_text = $('[data-mti-data-label="workforceNativeLessHighSchool"]').text(),
        work3_2_2_text = $('[data-mti-data-label="workforceNativeHighSchoolSomeCollege"]').text(),
        work3_3_2_text = $('[data-mti-data-label="workforceNativeBachelors"]').text(),
        work3_4_2_text = $('[data-mti-data-label="workforceNativeGraduate"]').text(),
        workUnder_fb_text = $('[data-mti-data-label="workforceForeignUnderemployed"]').text(),
        workUnder_us_text = $('[data-mti-data-label="workforceNativeUnderemployed"]').text(),
        work2_text = $('[data-mti-data-label="workforce_foreign"]').text(),
        work1_text = $('[data-mti-data-label="workforce_foreignShare"]').text(),
        stemWorkersImm_text = $('[data-mti-data-label="shareStem"]').text(),
        nurses_text = $('[data-mti-data-label="nursesForeign"]').text(),
        healthAides_text = $('[data-mti-data-label="aidesForeign"]').text(),
        naturalizationVote_text = $('[data-mti-data-label="immEligibleVote"]').text(),
        naturalizationValue_text = $('[data-mti-data-label="immNaturalized"]').text(),
        naturalizationShare_text = $('[data-mti-data-label="immNaturalizedShare"]').text(),
        naturalizationEligible_text = $('[data-mti-data-label="immNaturalizationEligible"]').text(),
        undocumentedOneFamValue_text = $('[data-mti-data-label="undoc_citizensLivingWithOneFamMember"]').text(),
        undocumentedOneFamShar_text = $('[data-mti-data-label="undoc_citizensLivingWithOneFamMemberShare"]').text(),
        undocumentedChildValue_text = $('[data-mti-data-label="undoc_citizensChildrenLivingWithOneUndocFamMember"]').text(),
        undocumentedChildShare_text = $('[data-mti-data-label="undoc_citizensChildrenLivingWithOneUndocFamMemberShare"]').text(),
        undocumentedParentValue_text = $('[data-mti-data-label="undoc_citizensChildrenLivingWithOneUndocParent"]').text(),
        undocumentedParentShare_text = $('[data-mti-data-label="undoc_citizensChildrenLivingWithOneUndocParentShare"]').text(),
        refugeeValue_text = $('[data-mti-data-label="refugees-number"]').text(),
        refugeeWork_text = $('[data-mti-data-label="refugees-shareLaborForceEmployed"]').text(),
        refugeeEntre_text = $('[data-mti-data-label="refugees-immEntrepreneurs"]').text(),
        refugeeEntreIncome_text = $('[data-mti-data-label="refugees-businessIncomeEntrepeneurs"]').text(),
        refugeeNat_text = $('[data-mti-data-label="refugees-naturalized"]').text(),
        undocumentedValue_text = $('[data-mti-data-label= "undocumentedImm"]').text(),
        undocumentedShareImm_text = $('[data-mti-data-label="undoc_foreignBornShareUndoc"]').text(),
        undocumentedShareTotal_text = $('[data-mti-data-label="undoc_totalPopShareUndocumented"]').text(),
        undocumentedShareWork_text = $('[data-mti-data-label= "undoc_laborForceShareUndocumented"]').text(),
        undocumentedWorkers_text = $('[data-mti-data-label="shareUndocumentedWorkingAge"]').text(),
        undocumentedEntre_text = $('[data-mti-data-label="immEntrepreneursUndocumentedImm"]').text(),
        dacaValue_text = $('[data-mti-data-label="numDacaEligibleResidents"]').text(),
        dacaWork_text = $('[data-mti-data-label="shareDACALaborForceEmployed"]').text(),
        dacaEntre_text = $('[data-mti-data-label="immEntrepreneursDACA"]').text(),
        dacaEduc_text = $('[data-mti-data-label="dacaResidentsAllButEdu"]').text(),
        dacaIncome_text = $('[data-mti-data-label="immHouseholdIncomeDACA"]').text(),
        dacaIncome_text = $('[data-mti-data-label="immHouseholdIncomeDACA"]').text(),
        taxes6_text = $('[data-mti-data-label="socialSecurity"]').text(),
        taxes7_text = $('[data-mti-data-label="medicare"]').text(),
        taxes1_text = $('[data-mti-data-label="immHouseholdIncome"]').text(),
        taxes4_text = $('[data-mti-data-label="federalTaxes"]').text(),
        taxes3_text = $('[data-mti-data-label="stateLocalTaxes"]').text(),
        taxes5_text = $('[data-mti-data-label="immTaxesPaid"]').text(),
        taxes2_text = $('[data-mti-data-label="immSpendingPower"]').text(),
        housingOwners_text = $('[data-mti-data-label="immHomeowners"]').text(),
        housingWealth_text = $('[data-mti-data-label="housingWealthImmHouseholds"]').text(),
        housingRent_text = $('[data-mti-data-label="amountPaidImmHouseholdsRent"]').text(),
        housingShare_text = $('[data-mti-data-label="shareHomebuyersForeign"]').text(),
        dacaActive_text = $('[data-mti-data-label= "dacaActiveRecipients"]').text(),
        dacaGranted_text = $('[data-mti-data-label="dacaNumPeopleDacaGranted"]').text(),
        refugeeResettle_text = $('[data-mti-data-label="refugees-resettled"]').text(),
        tpsWork_text = $('[data-mti-data-label="tps-shareWorkingAge"]').text(),
        tpsValue_text = $('[data-mti-data-label="tps-numHolders"]').text(),
        tpsEmploy_text = $('[data-mti-data-label="tps-shareLaborForceEmployed"]').text(),
        tpsIncome_text = $('[data-mti-data-label="tps-householdIncome"]').text(),
        tpsSpending_text = $('[data-mti-data-label="tps-totalSpendingPower"]').text();
      function convert(x) {
        x = Number(x.replace(/\$|,/g, ""));
        if (x >= 999999999999) {
          x = "$" + (x / 1000000000000).toFixed(1) + "T";
        } else if (x > 999999999 & x < 999999999999) {
          x = "$" + (x / 1000000000).toFixed(1) + "B";
        } else if (x > 100 && x <= 999999999) {
          x = "$" + (x / 1000000).toFixed(1) + "M";
        } else {
          x = "-";
        }
        return x;
      }
      overview2 = convert(overview2);
      overview3 = convert(overview3);
      if (entre3 != "-" || entre3 != "$0.0" || entre3 != "-" || entre3 != null) {
        entre3 = convert(entre3);
      }
      if (taxes1 != "$-" || taxes1 != "$0.0") {
        taxes1 = convert(taxes1);
      }
      if (taxes2 != "$-" || taxes2 != "$0.0") {
        taxes2 = convert(taxes2);
      }
      if (taxes3 != "$-" || taxes3 != "$0.0") {
        taxes3 = convert(taxes3);
      }
      if (taxes4 != "$-" || taxes4 != "$0.0") {
        taxes4 = convert(taxes4);
      }
      if (taxes5 != "$-" || taxes5 != "$0.0") {
        taxes5 = convert(taxes5);
      }
      if (taxes6 != "$-" || taxes6 != "$0.0") {
        taxes6 = convert(taxes6);
      }
      if (taxes7 != "$-" || taxes7 != "$0.0") {
        taxes7 = convert(taxes7);
      }
      if (housingWealth != "$-" || housingWealth != "$0.0") {
        housingWealth = convert(housingWealth);
      }
      if (housingRent != "$-" || housingRent != "$0.0") {
        housingRent = convert(housingRent);
      }
      if (internationalStdEcon != "$-" || internationalStdEcon != "$0.0") {
        internationalStdEcon = convert(internationalStdEcon);
      }
      if (undocumentedIncome != "$-" || undocumentedIncome != "$0.0") {
        undocumentedIncome = convert(undocumentedIncome);
      }
      if (undocumentedSpending != "$-" || undocumentedSpending != "$0.0") {
        undocumentedSpending = convert(undocumentedSpending);
      }
      if (undocumentedStateTx != "$-" || undocumentedStateTx != "$0.0") {
        undocumentedStateTx = convert(undocumentedStateTx);
      }
      if (undocumentedFedTax != "$-" || undocumentedFedTax != "$0.0") {
        undocumentedFedTax = convert(undocumentedFedTax);
      }
      if (undocumentedTotalTax != "$-" || undocumentedTotalTax != "$0.0") {
        undocumentedTotalTax = convert(undocumentedTotalTax);
      }
      if (dacaIncome != "$-" || dacaIncome != "$0.0") {
        dacaIncome = convert(dacaIncome);
      }
      if (dacaSpending != "$-" || dacaSpending != "$0.0") {
        dacaSpending = convert(dacaSpending);
      }
      if (dacaStateTx != "$-" || dacaStateTx != "$0.0") {
        dacaStateTx = convert(dacaStateTx);
      }
      if (dacaFedTax != "$-" || dacaFedTax != "$0.0") {
        dacaFedTax = convert(dacaFedTax);
      }
      if (dacaTotalTax != "$-" || dacaTotalTax != "$0.0") {
        dacaTotalTax = convert(dacaTotalTax);
      }
      if (refugeeIncome != "$-" || refugeeIncome != "$0.0") {
        refugeeIncome = convert(refugeeIncome);
      }
      if (refugeeSpending != "$-" || refugeeSpending != "$0.0") {
        refugeeSpending = convert(refugeeSpending);
      }
      if (refugeeStateTx != "$-" || refugeeStateTx != "$0.0") {
        refugeeStateTx = convert(refugeeStateTx);
      }
      if (refugeeFedTax != "$-" || refugeeFedTax != "$0.0") {
        refugeeFedTax = convert(refugeeFedTax);
      }
      if (refugeeTotalTax != "$-" || refugeeTotalTax != "$0.0") {
        refugeeTotalTax = convert(refugeeTotalTax);
      }
      if (refugeeEntreIncome != "$-" || refugeeEntreIncome != "$0.0") {
        refugeeEntreIncome = convert(refugeeEntreIncome);
      }
      if (tpsIncome != "$-" || tpsIncome != "$0.0") {
        tpsIncome = convert(tpsIncome);
      }
      if (tpsSpending != "$-" || tpsSpending != "$0.0") {
        tpsSpending = convert(tpsSpending);
      }
      if (tpsStateTx != "$-" || tpsStateTx != "$0.0") {
        tpsStateTx = convert(tpsStateTx);
      }
      if (tpsFedTax != "$-" || tpsFedTax != "$0.0") {
        tpsFedTax = convert(tpsFedTax);
      }
      if (tpsTotalTax != "$-" || tpsTotalTax != "$0.0") {
        tpsTotalTax = convert(tpsTotalTax);
      }
      if (topCountry2 == "") {
        topCountry2 = "-";
      }
      if (topCountry3 == "") {
        topCountry3 = "-";
      }
      if (topCountry4 == "") {
        topCountry4 = "-";
      }
      if (topCountry5 == "") {
        topCountry5 = "-";
      }
      if (topCountry2v == "") {
        topCountry2v = "-";
      }
      if (topCountry3v == "") {
        topCountry3v = "-";
      }
      if (topCountry4v == "") {
        topCountry4v = "-";
      }
      if (topCountry5v == "") {
        topCountry5v = "-";
      }
      if (entre2 == "") {
        entre2 = "-";
      }
      if (dacaWork == "0.0%") {
        dacaWork = "-";
      }
      if (refugeeWork == "0.0%") {
        refugeeWork = "-";
      }
      if (tpsWork == "0.0%") {
        refugeeWork = "-";
      }
      if (undocumentedWorkers == "0.0%") {
        undocumentedWorkers = "-";
      }
      if (undocumentedShareImm == "0.0%") {
        undocumentedShareImm = "-";
      }
      if (undocumentedShareWork == "0.0%") {
        undocumentedShareWork = "-";
      }
      if (undocumentedShareTotal == "0.0%") {
        undocumentedShareTotal = "-";
      }
      if (refugeeEntre == "") {
        refugeeEntre = "-";
      }
      if (refugeeNat == "") {
        refugeeNat = "-";
      }
      if (undocumentedEntre == "") {
        undocumentedEntre = "-";
      }
      if (undocumentedEntre == "") {
        undocumentedEntre = "-";
      }
      if (demo3 == "") {
        demo3 = "-";
      }
      if (topIndustry2 == "") {
        topIndustry2 = "-";
      }
      if (topIndustry3 == "") {
        topIndustry3 = "-";
      }
      if (topIndustry4 == "") {
        topIndustry4 = "-";
      }
      if (topIndustry5 == "") {
        topIndustry5 = "-";
      }
      if (topIndustry2v == "") {
        topIndustry2v = "-";
      }
      if (topIndustry3v == "") {
        topIndustry3v = "-";
      }
      if (topIndustry4v == "") {
        topIndustry4v = "-";
      }
      if (topIndustry5v == "") {
        topIndustry5v = "-";
      }
      if (housingOwners == "") {
        housingOwners = "-";
      }
      if (housingShare == "") {
        housingShare = "-";
      }
      if (dacaEntre == "") {
        dacaEntre = "-";
      }
      if (refugeeEntreIncome == "") {
        refugeeEntreIncome = "-";
      }
      if (demoAge_1_1 == "") {
        demoAge_1_1 = "-";
      }
      if (demoAge_2_1 == "") {
        demoAge_2_1 = "-";
      }
      if (demoAge_3_1 == "") {
        demoAge_3_1 = "-";
      }
      if (entre1 == "") {
        entre1 = "-";
      }
      if (entre2 == "") {
        entre2 = "-";
      }
      if (entre3 == "") {
        entre3 = "-";
      }
      if (work3_1_1 == "") {
        work3_1_1 = "-";
      }
      if (work3_2_1 == "") {
        work3_2_1 = "-";
      }
      if (work3_3_1 == "") {
        work3_3_1 = "-";
      }
      if (work3_4_1 == "") {
        work3_4_1 = "-";
      }
      if (workUnder_fb == "" || workUnder_fb == "-") {
        workUnder_us = "-";
      }
      var imgUrl = AIC_GLOBAL_VARS.url + "static/img/aic-logo-transparent.png";
      var stateName = stateData[0]["Account Name"].replace(/\s/g, "_");
      if (stateName == "National") {
        stateName = "USA";
      }
      if (stateName == "Estados Unidos") {
        stateName = "USA";
      }
      if (stateName == "") {
        stateName = "USA";
      }
      if (stateName == "Misisipí") {
        stateName = "Misisipi";
      }
      if (stateName == "Oregón") {
        stateName = "Oregon";
      }
      if (stateName == "Nuevo_México") {
        stateName = "Nuevo_Mexico";
      }
      var stateImage = AIC_GLOBAL_VARS.url + "/static/img/state_images/" + stateName + ".png";
      var moneyValues = [taxes1, taxes2, taxes3, taxes4, taxes5, taxes6, taxes7, housingWealth, housingRent, internationalStdEcon, undocumentedIncome, undocumentedSpending, undocumentedStateTx, undocumentedFedTax, undocumentedTotalTax, dacaIncome, dacaSpending, dacaStateTx, dacaFedTax, dacaTotalTax, refugeeIncome, refugeeSpending, refugeeStateTx, refugeeFedTax, refugeeTotalTax, tpsIncome, tpsSpending, tpsStateTx, tpsFedTax, tpsTotalTax, refugeeEntreIncome];
      var introText = $('[data-mti-data-label="introduction"]');
      var shareList = [overview0, demo0, demo1, demo2, demo5, demoAge_1_1, demoAge_1_2, demoAge_2_1, demoAge_2_2, demoAge_3_1, demoAge_3_2, topCountry1v, topCountry2v, topCountry3v, topCountry4v, topCountry5v, entre1, work1, work3_1_1, work3_1_2, work3_2_1, work3_2_2, work3_3_1, work3_3_2, work3_4_1, work3_4_2, workUnder_fb, workUnder_us, topIndustry1v, topIndustry2v, topIndustry3v, topIndustry4v, topIndustry5v, topOccupation1v, topOccupation2v, topOccupation3v, topOccupation4v, topOccupation5v, stemWorkersImm, nurses, healthAides, housingShare, naturalizationShare, undocumentedWorkers, undocumentedShareImm, undocumentedShareTotal, undocumentedShareWork, undocumentedOneFamShare, undocumentedChildShare, undocumentedParentShare, dacaWork, refugeeWork, tpsWork, tpsEmploy, undocShareInd1, undocShareInd2, undocShareInd3, undocShareInd4, undocShareInd5, refugeeCountry1Share, refugeeCountry2Share, refugeeCountry3Share, refugeeCountry4Share, refugeeCountry5Share, refugeeNat];

      // Modify values directly in the array:
      shareList = shareList.map(function (value) {
        if (typeof value === "string" && value.endsWith("0%")) {
          return value.replace(/0%$/, "%");
        }
        return value;
      });
      var _shareList = shareList;
      var _shareList2 = _slicedToArray(_shareList, 65);
      overview0 = _shareList2[0];
      demo0 = _shareList2[1];
      demo1 = _shareList2[2];
      demo2 = _shareList2[3];
      demo5 = _shareList2[4];
      demoAge_1_1 = _shareList2[5];
      demoAge_1_2 = _shareList2[6];
      demoAge_2_1 = _shareList2[7];
      demoAge_2_2 = _shareList2[8];
      demoAge_3_1 = _shareList2[9];
      demoAge_3_2 = _shareList2[10];
      topCountry1v = _shareList2[11];
      topCountry2v = _shareList2[12];
      topCountry3v = _shareList2[13];
      topCountry4v = _shareList2[14];
      topCountry5v = _shareList2[15];
      entre1 = _shareList2[16];
      work1 = _shareList2[17];
      work3_1_1 = _shareList2[18];
      work3_1_2 = _shareList2[19];
      work3_2_1 = _shareList2[20];
      work3_2_2 = _shareList2[21];
      work3_3_1 = _shareList2[22];
      work3_3_2 = _shareList2[23];
      work3_4_1 = _shareList2[24];
      work3_4_2 = _shareList2[25];
      workUnder_fb = _shareList2[26];
      workUnder_us = _shareList2[27];
      topIndustry1v = _shareList2[28];
      topIndustry2v = _shareList2[29];
      topIndustry3v = _shareList2[30];
      topIndustry4v = _shareList2[31];
      topIndustry5v = _shareList2[32];
      topOccupation1v = _shareList2[33];
      topOccupation2v = _shareList2[34];
      topOccupation3v = _shareList2[35];
      topOccupation4v = _shareList2[36];
      topOccupation5v = _shareList2[37];
      stemWorkersImm = _shareList2[38];
      nurses = _shareList2[39];
      healthAides = _shareList2[40];
      housingShare = _shareList2[41];
      naturalizationShare = _shareList2[42];
      undocumentedWorkers = _shareList2[43];
      undocumentedShareImm = _shareList2[44];
      undocumentedShareTotal = _shareList2[45];
      undocumentedShareWork = _shareList2[46];
      undocumentedOneFamShare = _shareList2[47];
      undocumentedChildShare = _shareList2[48];
      undocumentedParentShare = _shareList2[49];
      dacaWork = _shareList2[50];
      refugeeWork = _shareList2[51];
      tpsWork = _shareList2[52];
      tpsEmploy = _shareList2[53];
      undocShareInd1 = _shareList2[54];
      undocShareInd2 = _shareList2[55];
      undocShareInd3 = _shareList2[56];
      undocShareInd4 = _shareList2[57];
      undocShareInd5 = _shareList2[58];
      refugeeCountry1Share = _shareList2[59];
      refugeeCountry2Share = _shareList2[60];
      refugeeCountry3Share = _shareList2[61];
      refugeeCountry4Share = _shareList2[62];
      refugeeCountry5Share = _shareList2[63];
      refugeeNat = _shareList2[64];
      function newPage(p) {
        doc.addPage();
        doc.setFontSize(16);
        doc.setFont("Karla-Medium", "medium");
        doc.text(40, 40, "Inmigrantes en");
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(16);
        doc.text(157, 40, nameProper2);
        var pageNumber = p.toString();
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(560, 765, pageNumber);
      }
      function FirstPage() {
        console.log(nameProper2);
        function newPage() {
          doc.addPage();
          doc.setFontSize(16);
          doc.setFont("Karla-Medium", "medium");
          doc.text(40, 40, "Inmigrantes en");
          doc.setFont("Karla-ExtraBold", "bold");
          doc.setFontSize(16);
          doc.text(138, 40, nameProper2);
        }
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.src = imgUrl;
        var imgState = new Image();
        imgState.crossOrigin = "anonymous";
        imgState.src = stateImage;
        doc.addImage(img, "png", 450, 23, 117, 57);
        if (nameProper2 == "Los Estados Unidos") {
          doc.addImage(imgState, "png", 330, 23, newWidth, newLength);
        } else {
          doc.addImage(imgState, "png", 300, 23, newWidth, newLength);
        }
        doc.setFontSize(20);
        doc.setFont("Karla-Regular", "regular");
        doc.text(40, 40, "Inmigrantes en");
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(30);
        doc.text(40, 75, nameProper2);
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        doc.text(40, 135, intro, {
          maxWidth: 530
        });
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, 250, "RESUMEN");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(110, 244, "1");
        doc.setFontSize(14);
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, 255, 565, 255, "S");
        doc.setFont("Karla-Regular", "regular");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: 260,
          startX: 0,
          tableWidth: 530,
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[overview1_text, overview1], [overview0_text, overview0], [overview3_text, overview3], [overview2_text, overview2]]
        });
        doc.setFontSize(8);
        doc.text(166, 269, "2");
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, 390, "DEMOGRAFÍA");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, 395, 565, 395, "S");
        var demoText = $("#demograpicsText");
        demoText = demoText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        demoText = doc.splitTextToSize(demoText, 530);
        doc.text(40, 415, demoText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: 475,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[demo1_text, demo1], [demo2_text, demo2], [demo3_text, demo3], [demo0_text, demo0], [demo4_text, demo4], [demo5_text, demo5]]
        });
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: 645,
          startX: 0,
          tableWidth: 525,
          headStyles: {
            textColor: [0, 0, 0],
            font: "Karla-Bold",
            fontSize: 11,
            fillColor: [255, 255, 255]
          },
          //         columnStyles: {
          //   0: {cellWidth: 390},
          //   1: {cellWidth: 140}
          // },
          head: [["Grupo de edad", "Población nacida en el extranjero", "Población nacida en los Estados Unidos"]],
          body: [["0-15", demoAge_1_1, demoAge_1_2], ["16-64", demoAge_2_1, demoAge_2_2], ["65+", demoAge_3_1, demoAge_3_2]]
        });
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(13);
        doc.setTextColor(0, 0, 0);
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, 765, "Año de datos: 2023");
        doc.text(560, 765, "1");
      }
      var n = 75,
        p = 2,
        e = 2;
      FirstPage();
      newPage(p);
      function originCountries(n) {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(13);
        doc.text(40, n, "Principales países de origen de los inmigrantes");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 12,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204],
            font: "Karla-Bold",
            fontSize: 12
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[topCountry1, topCountry1v], [topCountry2, topCountry2v], [topCountry3, topCountry3v], [topCountry4, topCountry4v], [topCountry5, topCountry5v]]
        });
      }
      function entrepreneurship(n) {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "Emprendimiento");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var entreText = $("#entrepreneurshipText");
        entreText = entreText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        entreText = doc.splitTextToSize(entreText, 530);
        doc.text(40, n + 25, entreText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 90,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[entre2_text, entre2], [entre1_text, entre1], [entre3_text, entre3], [entre4_text, entre4]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        var endnote3 = e + 1;
        doc.text(111, n + 181, endnote3.toString());
        e = e + 1;
        endnoteArray.push("C_ENTRE");
        return;
      }
      function taxesSpending(n) {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "IMPUESTOS Y PODER ADQUISITIVO");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var taxText = $("#taxText");
        taxText = taxText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        taxText = doc.splitTextToSize(taxText, 530);
        doc.text(40, n + 25, taxText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 110,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[taxes1_text, taxes1], ["Impuestos totales pagados", taxes5], ["Impuestos federales pagados", taxes4], ["Impuestos estatales y locales pagados", taxes3], ["Poder adquisitivo total", taxes2], [taxes6_text, taxes6], [taxes7_text, taxes7]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        var endnote3 = e + 1,
          endnote4 = e + 2;
        doc.text(195, n + 164, endnote3.toString());
        doc.text(240, n + 187, endnote4.toString());
        e = e + 2;
        endnoteArray.push("D_CBO", "E_ITEP");
      }
      function workforce() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "FUERZA LABORAL");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var workText = $("#workText");
        workText = workText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        workText = doc.splitTextToSize(workText, 530);
        doc.text(40, n + 25, workText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 110,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[work2_text, work2], [work1_text, work1]]
        });
      }
      function education() {
        doc.setFont("Karla-Regular", "regular");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n,
          startX: 0,
          tableWidth: 525,
          headStyles: {
            textColor: [0, 0, 0],
            font: "Karla-Bold",
            fontSize: 11,
            fillColor: [255, 255, 255]
          },
          //         columnStyles: {
          //   0: {cellWidth: 390},
          //   1: {cellWidth: 140}
          // },
          head: [["Nivel de educación", "Población nacida en el extranjero", "Población nacida en los Estados Unidos"]],
          body: [["Menos que la secundaria", work3_1_1, work3_1_2], ["Secundaria y algo de universidad", work3_2_1, work3_2_2], ["Licenciatura", work3_3_1, work3_3_2], ["Maestría", work3_4_1, work3_4_2], ["Porcentaje de trabajadores con estudios universitarios empleados en empleos que no requieren un título universitario", workUnder_fb, workUnder_us]]
        });
      }
      function industry() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Principales industrias con mayor proporción de trabajadores inmigrantes");
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 20,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[topIndustry1, topIndustry1v], [topIndustry2, topIndustry2v], [topIndustry3, topIndustry3v], [topIndustry4, topIndustry4v], [topIndustry5, topIndustry5v]]
        });
      }
      function occupation() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Ocupaciones principales con mayor proporción de trabajadores inmigrantes");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 25,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[topOccupation1, topOccupation1v], [topOccupation2, topOccupation2v], [topOccupation3, topOccupation3v], [topOccupation4, topOccupation4v], [topOccupation5, topOccupation5v]]
        });
      }
      function stem() {
        var endnote5 = e + 1;
        e = e + 1;
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Ciencia, tecnología, ingeniería y matemáticas");
        var stemText = $("#stemText");
        stemText = stemText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        stemText = doc.splitTextToSize(stemText, 530);
        doc.text(40, n + 20, stemText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 110,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Porcentaje de trabajadores STEM que son inmigrantes", stemWorkersImm]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(316, n + 118, endnote5.toString());
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        endnoteArray.push("F_STEM");
        return;
      }
      function healthcare() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Industria de la salud");
        var healthText = $("#healthcareText");
        healthText = healthText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        healthText = doc.splitTextToSize(healthText, 530);
        doc.text(40, n + 20, healthText);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 108,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Enfermeras nacidas en el extranjero", nurses], ["Asistentes de salud nacidos en el extranjero", healthAides]]
        });
      }
      function housing() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "ALOJAMIENTO");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var housingText = $("#housingText");
        housingText = housingText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        housingText = doc.splitTextToSize(housingText, 530);
        doc.text(40, n + 20, housingText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 95,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[housingOwners_text, housingOwners], [housingShare_text, housingShare], [housingWealth_text, housingWealth], [housingRent_text, housingRent]]
        });
      }
      function international() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "ESTUDIANTES INTERNACIONALES");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var internationalStdText = $("#internationalStdText");
        internationalStdText = internationalStdText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        internationalStdText = doc.splitTextToSize(internationalStdText, 530);
        doc.text(40, n + 20, internationalStdText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 85,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Estudiates universitarios en " + nameProper + " que son estudiantes internacionales", internationalStd], ["Contribución económica de los estudiantes internacionales", internationalStdEcon], ["Empleos apoyados por estudiantes internacionales", internationalStdJobs]]
        });
        var intEndnote = e + 1;
        e = e + 1;
        endnoteArray.push("G_NAFSA");
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(272, n - 6, intEndnote.toString()); //footnotes
      }
      function naturalization() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "NATURALIZACIÓN Y DERECHO AL VOTO"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var naturalizationText = $("#naturalizationText");
        naturalizationText = naturalizationText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        naturalizationText = doc.splitTextToSize(naturalizationText, 530);
        doc.text(40, n + 20, naturalizationText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 60,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[naturalizationShare_text, naturalizationShare], [naturalizationValue_text, naturalizationValue], [naturalizationEligible_text, naturalizationEligible], [naturalizationVote_text, naturalizationVote]]
        });
      }
      function undocumented_1() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "INMIGRANTES INDOCUMENTADOS");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var undocumentedText = $("#undocumentedText");
        undocumentedText = undocumentedText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        undocumentedText = doc.splitTextToSize(undocumentedText, 530);
        doc.text(40, n + 25, undocumentedText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 95,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[undocumentedValue_text, undocumentedValue], ["Porcentaje de la población inmigrante que son inmigrantes indocumentados", undocumentedShareImm], ["Porcentaje de población indocumentada", undocumentedShareTotal], ["Porcentaje de inmigrantes indocumentados en edad de trabajar", undocumentedShareWork], ["Porcentaje de la mano de obra que no tiene documentación", undocumentedWorkers], [undocumentedEntre_text, undocumentedEntre], ["Ingresos familiares indocumentados", undocumentedIncome], ["Impuestos totales pagados", undocumentedTotalTax], ["Impuestos federales pagados", undocumentedFedTax], ["Impuestos estatales y locales pagados", undocumentedStateTx], ["Poder adquisitivo total", undocumentedSpending], [undocumentedOneFamValue_text, undocumentedOneFamValue], ["Porcentaje de ciudadanos estadounidenses que viven con al menos un familiar indocumentado", undocumentedOneFamShare]]
        });
        var undocEndnote1 = e + 1;
        var undocEndnote2 = e + 2;
        endnoteArray.push("H_UNDOC1", "I_UNDOC2");
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(254, n + 105, undocEndnote1.toString());
        doc.text(182, n + 275, undocEndnote2.toString());
        e = e + 2;
      }
      function undocumented_2() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "INMIGRANTES INDOCUMENTADOS"); //70
        doc.setFontSize(12);
        doc.text(280, n, "(CONTINUÓ)");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //

        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 25,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[undocumentedChildValue_text, undocumentedChildValue], ["Porcentaje de niños ciudadanos estadounidenses que viven con al menos un familiar indocumentado", undocumentedChildShare], [undocumentedParentValue_text, undocumentedParentValue], ["Porcentaje de niños ciudadanos estadounidenses que viven con al menos un padre indocumentado", undocumentedParentShare]]
        });
      }
      function undocumented_3() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "INMIGRANTES INDOCUMENTADOS");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var undocumentedText = $("#undocumentedText");
        undocumentedText = undocumentedText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        undocumentedText = doc.splitTextToSize(undocumentedText, 530);
        doc.text(40, n + 25, undocumentedText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 85,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[undocumentedValue_text, undocumentedValue], ["Porcentaje de la población inmigrante que son inmigrantes indocumentados", undocumentedShareImm], ["Porcentaje de población indocumentada", undocumentedShareTotal], ["Porcentaje de inmigrantes indocumentados en edad de trabajar", undocumentedShareWork], ["Porcentaje de la mano de obra que no tiene documentación", undocumentedWorkers], [undocumentedEntre_text, undocumentedEntre], ["Ingresos familiares indocumentados", undocumentedIncome], ["Impuestos totales pagados", undocumentedTotalTax], ["Impuestos federales pagados", undocumentedFedTax], ["Impuestos estatales y locales pagados", undocumentedStateTx], ["Poder adquisitivo total", undocumentedSpending], [undocumentedOneFamValue_text, undocumentedOneFamValue], ["Porcentaje de ciudadanos estadounidenses que viven con al menos un familiar indocumentado", undocumentedOneFamShare], [undocumentedChildValue_text, undocumentedChildValue], ["Porcentaje de niños ciudadanos estadounidenses que viven con al menos un familiar indocumentado", undocumentedChildShare], [undocumentedParentValue_text, undocumentedParentValue], ["Porcentaje de niños ciudadanos estadounidenses que viven con al menos un padre indocumentado", undocumentedParentShare]]
        });
        var undocEndnote1 = e + 1;
        var undocEndnote2 = e + 2;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(254, n + 95, undocEndnote1.toString());
        doc.text(182, n + 265, undocEndnote2.toString());
        e = e + 2;
        endnoteArray.push("H_UNDOC1", "I_UNDOC2");
      }
      function undocIndustry() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Principales industrias con mayor proporción de trabajadores indocumentados");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 15,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[undocInd1, undocShareInd1], [undocInd2, undocShareInd2], [undocInd3, undocShareInd3], [undocInd4, undocShareInd4], [undocInd5, undocShareInd5]]
        });
      }
      function daca() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "LA POBLACIÓN ELEGIBLE PARA DACA"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var dacaText = $("#dacaText");
        dacaText = dacaText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        dacaText = doc.splitTextToSize(dacaText, 530);
        doc.text(40, n + 25, dacaText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 80,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[dacaValue_text, dacaValue], [dacaWork_text, dacaWork], [dacaEntre_text, dacaEntre], [dacaIncome_text, dacaIncome], ["Impuestos totales pagados", dacaTotalTax], ["Impuestos federales pagados", dacaFedTax], ["Impuestos estatales y locales pagados", dacaStateTx], ["Poder adquisitivo total", dacaSpending], [dacaActive_text, dacaActive], [dacaGranted_text, dacaGranted], [dacaEduc_text, dacaEduc]]
        });
        var dacaEndnote1 = e + 1;
        var dacaEndnote2 = e + 2;
        var dacaEndnote3 = e + 3;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(284, n + 170, dacaEndnote1.toString());
        doc.text(252, n + 284, dacaEndnote2.toString());
        doc.text(305, n + 305, dacaEndnote3.toString());
        e = e + 3;
        endnoteArray.push("J_DACA1", "K_DACA2", "L_DACA3");
      }
      function dacaSmall() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "LA POBLACIÓN ELEGIBLE PARA DACA"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var dacaText = $("#dacaText");
        dacaText = dacaText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        dacaText = doc.splitTextToSize(dacaText, 530);
        doc.text(40, n + 25, dacaText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 80,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[dacaActive_text, dacaActive], [dacaGranted_text, dacaGranted]]
        });
        var dacaEndnote2 = e + 1;
        var dacaEndnote3 = e + 2;
        endnoteArray.push("K_DACA2", "L_DACA3");
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(252, n + 90, dacaEndnote2.toString());
        doc.text(307, n + 110, dacaEndnote3.toString());
        e = e + 2;
      }
      function refugees() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "REFUGIADOS"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var refugeeEndnote1 = e + 1;
        var refugeeEndnote2 = e + 2;
        doc.setFont("Karla-Bold", "bold");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(131, n - 5, refugeeEndnote1.toString());
        var refugeeText = $("#refugeeText");
        refugeeText = refugeeText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        refugeeText = doc.splitTextToSize(refugeeText, 530);
        doc.text(40, n + 25, refugeeText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 75,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[refugeeValue_text, refugeeValue], [refugeeWork_text, refugeeWork], [refugeeNat_text, refugeeNat], ["Ingresos de los hogares de refugiados", refugeeIncome], ["Impuestos totales pagados", refugeeTotalTax], ["Impuestos federales pagados", refugeeFedTax], ["Impuestos estatales y locales pagados", refugeeStateTx], ["Poder adquisitivo total", refugeeSpending], [refugeeEntre_text, refugeeEntre], [refugeeEntreIncome_text, refugeeEntreIncome], [refugeeResettle_text, refugeeResettle]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(336, n + 322, refugeeEndnote2.toString());
        e = e + 2;
        endnoteArray.push("M_REFUGEE", "N_REFUGEE2");
      }
      function refugeeSmallTable() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "REFUGIADOS"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var refugeeEndnote2 = e + 1;
        var refugeeText = $("#refugeeText");
        refugeeText = refugeeText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        refugeeText = doc.splitTextToSize(refugeeText, 530);
        doc.text(40, n + 25, refugeeText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 75,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[refugeeResettle_text, refugeeResettle]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(336, n + 85, refugeeEndnote2.toString());
        e = e + 1;
        endnoteArray.push("N_REFUGEE2");
      }
      function refugeeOrigin() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Principales países de origen de los refugiados reasentados en el último año fiscal");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 15,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[refugeeCountry1, refugeeCountry1Share], [refugeeCountry2, refugeeCountry2Share], [refugeeCountry3, refugeeCountry3Share], [refugeeCountry4, refugeeCountry4Share], [refugeeCountry5, refugeeCountry5Share]]
        });
      }
      function temporaryStatus() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "TITULARES DEL ESTATUS DE PROTECCIÓN TEMPORAL");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var tpsText = $("#tpsText");
        tpsText = tpsText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        tpsText = doc.splitTextToSize(tpsText, 530);
        doc.text(40, n + 25, tpsText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 75,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Número de titulares de TPS", tpsValue], ["Porcentaje de beneficiarios del TPS que están en edad de trabajar", tpsWork], ["Tasa de empleo de los titulares del TPS", tpsEmploy], ["Ingresos familiares del TPS", tpsIncome], ["Impuestos totales pagados", tpsTotalTax], ["Impuestos federales pagados", tpsFedTax], ["Impuestos estatales y locales pagados", tpsStateTx], ["Poder adquisitivo total", tpsSpending]]
        });
        var tpsEndnote = e + 1;
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(181, n + 85, tpsEndnote.toString());
        e = e + 1;
        endnoteArray.push("O_TPS");
      }

      //tpsSmall

      function temporaryStatusSmall() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "TITULARES DEL ESTATUS DE PROTECCIÓN TEMPORAL");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var tpsText = $("#tpsText");
        tpsText = tpsText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        tpsText = doc.splitTextToSize(tpsText, 530);
        doc.text(40, n + 25, tpsText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 75,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Número de titulares de TPS", tpsValue]]
        });
        var tpsEndnote = e + 1;
        doc.setFont("Karla-Regular", "regular");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(181, n + 85, tpsEndnote.toString());
        e = e + 1;
        endnoteArray.push("O_TPS");
      }
      function endnote() {
        p = p + 1;
        var en = 240;
        newPage(p);
        doc.setFontSize(9);
        doc.setFont("Karla-Regular", "regular");
        doc.text(40, 70, "Para obtener más información sobre Map the Impact,");
        doc.setTextColor(51, 102, 204);
        doc.textWithLink("maptheimpact.org.", 261, 70, {
          url: "https://data.americanimmigrationcouncil.org/map-the-impact/"
        });
        doc.setTextColor(0, 0, 0);
        doc.text(40, 90, "El Consejo Americano de Inmigración trabaja para empoderar a los inmigrantes desde su llegada hasta su pertenencia.");
        doc.text(40, 100, "Para obtener más información sobre el trabajo del Consejo, visite");
        doc.setTextColor(51, 102, 204);
        doc.textWithLink("americanimmigrationcouncil.org.", 312, 100, {
          url: "https://americanimmigrationcouncil.org."
        });
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(14);
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setTextColor(51, 102, 204);
        doc.text(40, 130, "NOTAS FINALES");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, 135, 580, 135, "S");
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        doc.setFont("Karla-Regular", "regular");
        doc.text(48, 150, "1.", {
          align: "right"
        });
        doc.text(55, 150, "A menos que se especifique lo contrario, los datos provienen del análisis de microdatos del Consejo Americano de Inmigración de la muestra", {
          align: "left"
        });
        doc.text(55, 160, "de un año de la Encuesta sobre la Comunidad Estadounidense (ACS) de 2023, descargados de la Serie Integrada de Microdatos de Uso Público", {
          align: "left"
        });
        doc.text(55, 170, "(IPUMS)", {
          align: "left"
        });
        // doc.text(
        //   55,
        //   170,
        //   "Use Microdata Series (IPUMS),",
        //    { align: "left" }
        // );
        doc.setTextColor(51, 102, 204);
        doc.textWithLink("https://www.ipums.org/.", 88, 170, {
          url: "https://www.ipums.org/"
        });
        doc.setTextColor(0, 0, 0);
        doc.text(48, 190, "2.", {
          align: "right"
        });
        doc.text(55, 190, "Al menos que se indique lo contrario (por ejemplo, “inmigrante indocumentado” o “elegible para DACA”), definimos a un inmigrante como", {
          align: "left"
        });
        doc.text(55, 200, "cualquier persona nacida fuera del país de padres que no son ciudadanos estadounidenses y que es residente de los Estados Unidos. ");
        doc.text(55, 210, "Esto incluye a los ciudadanos naturalizados, residentes permanentes legales, los titulares de visas temporales, los refugiados,");
        doc.text(55, 220, "solicitantes de asilo y los inmigrantes indocumentados, entre otros.");

        // ['C_CBO', 'D_ITEP', 'E_STEM', 'F_NAFSA', 'G_UNDOC1', 'H_UNDOC2', 'I_DACA1', 'J_DACA2', 'K_DACA3', 'L_REFUGEE']

        for (var i = 0; i < endnoteArray.length; i++) {
          if (endnoteArray[i] == "C_ENTRE") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "American Immigration Council. 2024. “New American Fortune 500 in 2024.", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://fortune.com/ranking/fortune500/.", 55, en + 10, {
              url: "https://fortune.com/ranking/fortune500/"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "D_CBO") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Congressional Budget Office. 2022. “The Distribution of Household Income and Federal Taxes, 2019.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.cbo.gov/publication/58353.", 55, en + 10, {
              url: "https://www.cbo.gov/publication/58353"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "E_ITEP") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Institute on Taxation and Economic Policy (ITEP). 2024. “Who Pays? A Distributional Analysis of the Tax Systems in", {
              align: "left"
            });
            doc.text(55, en + 10, "All 50 States (7th edition).“", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://itep.org/whopays-7th-edition/.", 157, en + 10, {
              url: "https://itep.org/whopays-7th-edition/"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "F_STEM") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "U.S. Census Bureau. 2018. “STEM, STEM-related, and Non-STEM Occupation Code List 2018.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www2.census.gov/programs-surveys/demo/guidance/industry-occupation/", 55, en + 10, {
              url: "https://www2.census.gov/programs-surveys/demo/guidance/industry-occupation/2018-census-stem-related-and-non-stem-occupation-code-list.xlsx"
            });
            doc.textWithLink("2018-census-stem-related-and-non-stem-occupation-code-list.xlsx", 55, en + 20, {
              url: "https://www2.census.gov/programs-surveys/demo/guidance/industry-occupation/2018-census-stem-related-and-non-stem-occupation-code-list.xlsx"
            });
            en = en + 40;
          }
          if (endnoteArray[i] == "G_NAFSA") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "NAFSA. 2024. “International Student Economic Value Tool.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("www.nafsa.org/economicvalue.", 55, en + 10, {
              url: "www.nafsa.org/economicvalue"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "H_UNDOC1") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Utilizando datos de la ACS, aplicamos el enfoque metodológico detallado por el economista de la Universidad de Harvard", {
              align: "left"
            });
            doc.text(55, en + 10, "George Borjas para llegar a una estimación de la población inmigrante indocumentada. Borjas, George J. 2016.");
            doc.text(55, en + 20, '“The Labor Supply of Undocumented Immigrants",');
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://ideas.repec.org/p/nbr/nberwo/22102.html.", 242, en + 20, {
              url: "https://ideas.repec.org/p/nbr/nberwo/22102.html"
            });
            en = en + 40;
          }
          if (endnoteArray[i] == "I_UNDOC2") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Al estimar lo que los inmigrantes indocumentados pagan en impuestos, seguimos la metodología detallada", {
              align: "left"
            });
            doc.text(55, en + 10, "por el Instituto de Política Fiscal y Económica (ITEP). ITEP. 2024 “Tax Payments By Undocumented Immigrants.”");
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://itep.org/undocumented-immigrants-taxes-2024/.", 55, en + 20, {
              url: "https://itep.org/undocumented-immigrants-taxes-2024/"
            });
            en = en + 40;
          }
          if (endnoteArray[i] == "J_DACA1") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Esto sigue el ejemplo de otros grupos, como el no partidista Institute on Taxation and Economic Policy (ITEP), que también han buscado", {
              align: "left"
            });
            doc.text(55, en + 10, "cuantificar las contribuciones económicas e impositivas de esta población. Hill, Misha E. and Meg Wiehe. 2017. “State and Local Tax");
            doc.text(55, en + 20, "Contributions of Young Undocumented Immigrants.” Institute on Taxation and Economic Policy.");
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://itep.sfo2.digitaloceanspaces.com/2017DACA.pdf.", 55, en + 30, {
              url: "https://itep.sfo2.digitaloceanspaces.com/2017DACA.pdf"
            });
            en = en + 50;
          }

          //itep.sfo2.digitaloceanspaces.com/2017DACA.pdf.

          https: if (endnoteArray[i] == "K_DACA2") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "U.S. Citizenship and Immigration Services (USCIS). 2024. “Active DACA Recipients - Fiscal Year 2024, Quarter 4", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.uscis.gov/sites/default/files/document/data/active_daca_recipients_fy2024_q4.xlsx.", 55, en + 10, {
              url: "https://www.uscis.gov/sites/default/files/document/data/active_daca_recipients_fy2024_q4.xlsx"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "L_DACA3") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "USCIS. 2024. “Deferred Action for Childhood Arrivals (DACA) Quarterly Report (Fiscal Year 2024, Quarter 4).”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink(" https://www.uscis.gov/sites/default/files/document/data/daca_performancedata_fy2024_q4.xlsx.", 55, en + 10, {
              url: "https://www.uscis.gov/sites/default/files/document/data/daca_performancedata_fy2024_q4.xlsx"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "M_REFUGEE") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Utilizamos un método de imputación, similar al trabajo de Kallick y Mathema así como de Capps et al, para identificar casos en microdatos", {
              align: "left"
            });
            doc.text(55, en + 10, " de la ACS que probablemente sean refugiados, utilizando el país de nacimiento de cada encuestado nacido en el extranjero y su año de llegada.");
            doc.text(55, en + 20, "Kallick, David D. and Silva Mathema. 2016. “Refugee Integration in the United States,”");
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.americanprogress.org/article/refugee-integration-in-the-united-states,", 55, en + 30, {
              link: "https://www.americanprogress.org/article/refugee-integration-in-the-united-states"
            });
            doc.setTextColor(0, 0, 0);
            doc.text(55, en + 40, "as well as Capps et al in “The Integration Outcomes of U.S. Refugees: Successes and Challenges");
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.migrationpolicy.org/research/integration-outcomes-us-refugees-successes-and-challenges.", 55, en + 50, {
              url: "https://www.migrationpolicy.org/research/integration-outcomes-us-refugees-successes-and-challenges"
            });
            en = en + 70;
          }
          if (endnoteArray[i] == "N_REFUGEE2") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Refugee Processing Center (RPC). 2024. “FY 2024 Refugee Arrivals by State and Nationality.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.wrapsnet.org/archives/", 55, en + 10, {
              url: "https://www.wrapsnet.org/archives/"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "O_TPS") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Congressional Research Service (CRS). 2024. “Temporary Protected Status and Deferred Enforced Departure.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://crsreports.congress.gov/product/pdf/RS/RS20844/70", 55, en + 10, {
              url: "https://crsreports.congress.gov/product/pdf/RS/RS20844/70"
            });
            en = en + 30;
          }
        }
      }
      if (originCountriesTable == 1) {
        if (n + 165 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        originCountries(n);
        n = n + 165;
      }
      if (entrepreneurshipTable == 1) {
        if (n + 220 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        entrepreneurship(n);
        n = n + 220;
      }
      if (taxesTable == 1) {
        if (n + 300 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        taxesSpending(n);
        n = n + 300;
        CBO = 1;
        ITEP = 1;
      }
      if (workforceTable == 1) {
        if (n + 160 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        workforce(n);
        n = n + 160;
      }
      if (educationTable == 1) {
        if (n + 210 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        education(n);
        n = n + 210;
      }
      if (industryTable == 1) {
        if (n + 165 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        industry(n);
        n = n + 160;
      }
      if (occupationTable == 1) {
        if (n + 180 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        occupation(n);
        n = n + 180;
      }
      if (stemTable == 1) {
        if (n + 155 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        stem(n);
        STEM = 1;
        n = n + 155;
      }
      if (healthcareTable == 1) {
        if (n + 175 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        healthcare(n);
        n = n + 175;
      }
      if (housingTable == 1) {
        if (n + 220 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        housing(n);
        n = n + 220;
      }
      if (internationalTable == 1) {
        if (n + 190 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        international(n);
        NAFSA = 1;
        n = n + 200;
      }
      if (naturalizationTable == 1) {
        if (n + 195 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        naturalization(n);
        n = n + 195;
      }
      if (undocumentedTable == 1) {
        if (n + 570 >= 770) {
          if (n + 330 >= 770) {
            p = p + 1;
            n = 75;
            newPage(p);
            UNDOC1 = 1;
            UNDOC2 = 1;
            undocumented_3();
            n = n + 570;
          } else {
            undocumented_1();
            p = p + 1;
            n = 75;
            UNDOC1 = 1;
            UNDOC2 = 1;
            newPage(p);
            undocumented_2();
            n = n + 200;
          }
        } else {
          undocumented_3();
          UNDOC1 = 1;
          UNDOC2 = 1;
          n = n + 570;
        }
      }
      if (undocIndustryTable == 1) {
        if (n + 160 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        undocIndustry(n);
        n = n + 160;
      }
      if (dacaTable == 1) {
        if (n + 375 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        daca(n);
        n = n + 375;
      }
      if (dacaSmallTable == 1) {
        if (n + 160 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        dacaSmall(n);
        n = n + 160;
      }
      if (refugeesTable == 1) {
        if (n + 360 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        refugees(n);
        n = n + 360;
      }
      if (refugeeSmall == 1) {
        if (n + 132 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        refugeeSmallTable(n);
        n = n + 132;
      }
      if (refugeesTableOrigin == 1) {
        if (n + 160 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        refugeeOrigin(n);
        n = n + 160;
      }
      if (tpsTable == 1) {
        if (n + 310 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        temporaryStatus();
        n = n + 310;
      }
      if (tpsSmall == 1) {
        if (n + 150 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        temporaryStatusSmall();
        n = n + 150;
      }
      endnote();
      var download_button = document.getElementById("downloadButton");
      var file_name = "AIC_Map_the_Impact-" + name + ".pdf";
      download_button.addEventListener("click", function () {
        doc.save(file_name);
      });
    }, 100);
  }
}
function mti_generate_pdf_msa() {
  var name = document.getElementById("page-term-name").textContent;

  // var name = "Honolulu Metro Area";

  var keyName = name;
  var miniName = name.replace(" Metro Area", "");
  var nameProper = name;
  var nameProper2 = nameProper;
  var ENTRE = 0,
    //Number 3
    CBO = 0,
    //Number 4
    ITEP = 0,
    //Number 5
    STEM = 0,
    //Number 6
    NAFSA = 0,
    //Number 7
    UNDOC1 = 0,
    //Number 8
    UNDOC2 = 0,
    //Number 9
    DACA1 = 0,
    //Number 10
    DACA2 = 0,
    //Number 11
    DACA3 = 0,
    //Number 12
    REFUGEE = 0,
    //Number 13
    REFUGEE2 = 0,
    //Number 14
    TPS = 9; //Number 15

  var endnoteArray = ["A_first", "B_second"];
  var jsPDF = window.jspdf.jsPDF;
  var imgWidth = 100;
  var imgHeight = 73;
  var msaData = d3.json(AIC_GLOBAL_VARS.url + "/mti-metro-area.json");
  var MSA_key = d3.csv(AIC_GLOBAL_VARS.url + "/static/data/map-the-impact/MSA_data_with_key.csv");
  var dataPDF = [msaData, MSA_key];
  prepareAndStartChange();
  function prepareAndStartChange() {
    Promise.all(dataPDF).then(startChange);
  }
  function startChange(dataPDF) {
    var msaFiltered = dataPDF[0].filter(function (d) {
      return d["Account Name"] === name;
    });
    var mti_keyFile = dataPDF[1].filter(function (d) {
      return d["MSA"] === name;
    });

    // var stateData = data[0].filter(function(d) { return d["Account Name"] === "District of Columbia"})

    var originCountriesTable = mti_keyFile[0]["originCountriesTable"],
      entrepreneurshipTable = mti_keyFile[0]["entrepreneurshipTable"],
      taxesTable = mti_keyFile[0]["taxesTable"],
      workforceTable = mti_keyFile[0]["workforceTable"],
      educationTable = mti_keyFile[0]["educationTable"],
      industryTable = mti_keyFile[0]["industryTable"],
      occupationTable = mti_keyFile[0]["occupationTable"],
      stemTable = mti_keyFile[0]["stemTable"],
      healthcareTable = mti_keyFile[0]["healthcareTable"],
      housingTable = mti_keyFile[0]["housingTable"],
      // internationalTable = mti_keyFile[0]["internationalTable"],
      naturalizationTable = mti_keyFile[0]["naturalizationTable"];
    console.log(naturalizationTable);
    setTimeout(function () {
      // Generate PDF
      var doc = new jsPDF("p", "pt", "letter"),
        dataSource = msaFiltered[0]["Source"],
        msaFormal = msaFiltered[0]["CBSA Formal"],
        counties = msaFiltered[0]["County Names"],
        overview0 = msaFiltered[0]["Immigrant Share of Population"],
        overview1 = (0, _misc.aic_round_to_nearest_hundred)(msaFiltered[0]["Immigrant Residents"]),
        overview2 = msaFiltered[0]["Immigrant Spending Power"],
        overview3 = msaFiltered[0]["Immigrant Taxes Paid"],
        demo0 = msaFiltered[0]["U.S.-born Residents, At Least One Immigrant Parent, %"],
        demo1 = msaFiltered[0]["Foreign-Born, Women"],
        demo2 = msaFiltered[0]["Foreign-Born, Men"],
        demo3 = (0, _misc.aic_round_to_nearest_hundred)(msaFiltered[0]["Foreign-Born, Children"]),
        demo4 = (0, _misc.aic_round_to_nearest_hundred)(msaFiltered[0]["U.S.-born Residents, At Least One Immigrant Parent"]),
        demo5 = msaFiltered[0]["Foreign-Born, Share Proficient in English"],
        demoAge_1_1 = msaFiltered[0]["Foreign-Born, Ages 0-15"],
        demoAge_1_2 = msaFiltered[0]["Native-Born, Ages 0-15"],
        demoAge_2_1 = msaFiltered[0]["Foreign-Born, Ages 16-64"],
        demoAge_2_2 = msaFiltered[0]["Native-Born, Ages 16-64"],
        demoAge_3_1 = msaFiltered[0]["Foreign-Born, Ages 65+"],
        demoAge_3_2 = msaFiltered[0]["Native-Born, Ages 65+"],
        topCountry1 = msaFiltered[0]["#1 Country of Origin"],
        topCountry2 = msaFiltered[0]["#2 Country of Origin"],
        topCountry3 = msaFiltered[0]["#3 Country of Origin"],
        topCountry4 = msaFiltered[0]["#4 Country of Origin"],
        topCountry5 = msaFiltered[0]["#5 Country of Origin"],
        topCountry1v = msaFiltered[0]["#1 Country of Origin, Value"],
        topCountry2v = msaFiltered[0]["#2 Country of Origin, Value"],
        topCountry3v = msaFiltered[0]["#3 Country of Origin, Value"],
        topCountry4v = msaFiltered[0]["#4 Country of Origin, Value"],
        topCountry5v = msaFiltered[0]["#5 Country of Origin, Value"],
        entre1 = msaFiltered[0]["Entrepreneur, Foreign-Born Share"],
        entre2 = (0, _misc.aic_round_to_nearest_hundred)(msaFiltered[0]["Immigrant Entrepreneurs"]),
        entre3 = msaFiltered[0]["Business Income of Immigrant Entrepreneurs"],
        taxes1 = msaFiltered[0]["Immigrant Household Income"],
        taxes2 = msaFiltered[0]["Immigrant Spending Power"],
        taxes3 = msaFiltered[0]["State & Local Taxes"],
        taxes4 = msaFiltered[0]["Federal Taxes"],
        taxes5 = msaFiltered[0]["Immigrant Taxes Paid"],
        work1 = msaFiltered[0]["Labor Force, Foreign-Born Share"],
        work2 = (0, _misc.aic_round_to_nearest_hundred)(msaFiltered[0]["Labor Force, Foreign-Born"]),
        work3_1_1 = msaFiltered[0]["Foreign-Born, Less Than High School"],
        work3_1_2 = msaFiltered[0]["Native-Born, Less Than High School"],
        work3_2_1 = msaFiltered[0]["Foreign-Born, High School & Some College"],
        work3_2_2 = msaFiltered[0]["Native-Born, High School & Some College"],
        work3_3_1 = msaFiltered[0]["Foreign-Born, Bachelor's Degree"],
        work3_3_2 = msaFiltered[0]["Native-Born, Bachelor's Degree"],
        work3_4_1 = msaFiltered[0]["Foreign-Born, Graduate Degree"],
        work3_4_2 = msaFiltered[0]["Native-Born, Graduate Degree"],
        workUnder_fb = msaFiltered[0]["Foreign-Born, Underemployed"],
        workUnder_us = msaFiltered[0]["US-Born, Underemployed"],
        topIndustry1 = msaFiltered[0]["#1 Industry"],
        topIndustry1v = msaFiltered[0]["#1 Industry, Value"],
        topIndustry2 = msaFiltered[0]["#2 Industry"],
        topIndustry2v = msaFiltered[0]["#2 Industry, Value"],
        topIndustry3 = msaFiltered[0]["#3 Industry"],
        topIndustry3v = msaFiltered[0]["#3 Industry, Value"],
        topIndustry4 = msaFiltered[0]["#4 Industry"],
        topIndustry4v = msaFiltered[0]["#4 Industry, Value"],
        topIndustry5 = msaFiltered[0]["#5 Industry"],
        topIndustry5v = msaFiltered[0]["#5 Industry, Value"],
        stemWorkersImm = msaFiltered[0]["STEM workers who are immigrants"],
        nurses = msaFiltered[0]["Nurses who are foreign-born"],
        healthAides = msaFiltered[0]["Health aides who are foreign-born"],
        housingOwners = (0, _misc.aic_round_to_nearest_hundred)(msaFiltered[0]["Immigrant homeowners"]),
        // housingShare =
        //   stateData[0]["Share of recent homebuyers who were foreign-born"],
        housingWealth = msaFiltered[0]["Housing wealth held by immigrant households"],
        housingRent = msaFiltered[0]["Amount paid by immigrant-led households in rent"],
        naturalizationShare = msaFiltered[0]["Foreign-Born, Naturalized Share"],
        naturalizationVote = (0, _misc.aic_round_to_nearest_hundred)(msaFiltered[0]["Immigrants eligible to vote"]),
        naturalizationValue = (0, _misc.aic_round_to_nearest_hundred)(msaFiltered[0]["Foreign-Born, Naturalized"]),
        naturalizationEligible = (0, _misc.aic_round_to_nearest_hundred)(msaFiltered[0]["Foreign-Born, Eligible to Naturalize"]);
      console.log(entre1);
      var overview1_text = $('[data-mti-data-label="immResidents"]').text(),
        overview0_text = $('[data-mti-data-label="immSharePopulation"]').text(),
        overview2_text = $('[data-mti-data-label="immSpendingPower"]').text(),
        overview3_text = $('[data-mti-data-label="immTaxesPaid"]').text(),
        demo3_text = $('[data-mti-data-label="demo_number_immigrantChildren"]').text(),
        demo2_text = $('[data-mti-data-label="demo_number_immigrantMen"]').text(),
        demo1_text = $('[data-mti-data-label="demo_number_immigrantWomen"]').text(),
        demoAge_1_1_text = $('[data-mti-data-label="demoForeignBorn015"]').text(),
        demoAge_2_1_text = $('[data-mti-data-label="demoForeignBorn1664"]').text(),
        demoAge_3_1_text = $('[data-mti-data-label="demoForeignBorn65"]').text(),
        demoAge_1_2_text = $('[data-mti-data-label= "demoNativeBorn015"]').text(),
        demoAge_2_2_text = $('[data-mti-data-label="demoNativeBorn1664"]').text(),
        demoAge_3_2_text = $('[data-mti-data-label="demoNativeBorn65"]').text(),
        demo4_text = $('[data-mti-data-label="demo_number_oneImmigrantParent"]').text(),
        demo0_text = $('[data-mti-data-label="demo_share_oneImmigrantParent"]').text(),
        demo5_text = $('[data-mti-data-label="demo_share_immProficientEnglish"]').text(),
        entre2_text = $('[data-mti-data-label="immEntrepreneurs"]').text(),
        entre1_text = $('[data-mti-data-label="shareEntrepreneursImm"]').text(),
        entre3_text = $('[data-mti-data-label="busIncomeImmEntrepreneurs"]').text(),
        work3_1_1_text = $('[data-mti-data-label="workforceForeignLessHighSchool"]').text(),
        work3_2_1_text = $('[data-mti-data-label="workforceForeignHighSchoolSomeCollege"]').text(),
        work3_3_1_text = $('[data-mti-data-label="workforceForeignBachelors"]').text(),
        work3_4_1_text = $('[data-mti-data-label="workforceForeignGraduate"]').text(),
        work3_1_2_text = $('[data-mti-data-label="workforceNativeLessHighSchool"]').text(),
        work3_2_2_text = $('[data-mti-data-label="workforceNativeHighSchoolSomeCollege"]').text(),
        work3_3_2_text = $('[data-mti-data-label="workforceNativeBachelors"]').text(),
        work3_4_2_text = $('[data-mti-data-label="workforceNativeGraduate"]').text(),
        workUnder_fb_text = $('[data-mti-data-label="workforceForeignUnderemployed"]').text(),
        workUnder_us_text = $('[data-mti-data-label="workforceNativeUnderemployed"]').text(),
        work2_text = $('[data-mti-data-label="workforce_foreign"]').text(),
        work1_text = $('[data-mti-data-label="workforce_foreignShare"]').text(),
        stemWorkersImm_text = $('[data-mti-data-label="shareStem"]').text(),
        nurses_text = $('[data-mti-data-label="nursesForeign"]').text(),
        healthAides_text = $('[data-mti-data-label="aidesForeign"]').text(),
        naturalizationVote_text = $('[data-mti-data-label="immEligibleVote"]').text(),
        naturalizationValue_text = $('[data-mti-data-label="immNaturalized"]').text(),
        naturalizationShare_text = $('[data-mti-data-label="immNaturalizedShare"]').text(),
        naturalizationEligible_text = $('[data-mti-data-label="immNaturalizationEligible"]').text(),
        taxes1_text = $('[data-mti-data-label="immHouseholdIncome"]').text(),
        taxes4_text = $('[data-mti-data-label="federalTaxes"]').text(),
        taxes3_text = $('[data-mti-data-label="stateLocalTaxes"]').text(),
        taxes5_text = $('[data-mti-data-label="immTaxesPaid"]').text(),
        taxes2_text = $('[data-mti-data-label="immSpendingPower"]').text(),
        housingOwners_text = $('[data-mti-data-label="immHomeowners"]').text(),
        housingWealth_text = $('[data-mti-data-label="housingWealthImmHouseholds"]').text(),
        housingRent_text = $('[data-mti-data-label="amountPaidImmHouseholdsRent"]').text(),
        housingShare_text = $('[data-mti-data-label="shareHomebuyersForeign"]').text();
      var cleanCounties = counties.replace(/^\[|\]$/g, "");

      // Step 2: Add a space after each semicolon
      var countiesList = cleanCounties.split(";").map(function (s) {
        return s.trim();
      }).join("; ");

      // function convert(x) {

      //   x = Number(x.replace(/\$|,/g, ""));
      //   if (x >= 999999) {
      //     x = "$" + (x / 1000000).toFixed(1) + "T";
      //   } else if ((x > 999) & (x < 999999)) {
      //     x = "$" + (x / 1000).toFixed(1) + "B";
      //   } else if (x > 0 && x <= 999) {
      //     x = "$" + (x / 1).toFixed(1) + "M";
      //   } else {
      //     x = "-";
      //   }

      //   return x;
      // }

      function convert(x) {
        x = Number(x.replace(/\$|,/g, ""));
        if (x >= 999999999999) {
          x = "$" + (x / 1000000000000).toFixed(1) + "T";
        } else if (x > 999999999 & x < 999999999999) {
          x = "$" + (x / 1000000000).toFixed(1) + "B";
        } else if (x > 100 && x <= 999999999) {
          x = "$" + (x / 1000000).toFixed(1) + "M";
        } else {
          x = "-";
        }
        return x;
      }
      overview2 = convert(overview2);
      overview3 = convert(overview3);
      if (entre3 != "-" || entre3 != "$0.0" || entre3 != "-" || entre3 != null) {
        entre3 = convert(entre3);
      }
      if (taxes1 != "$-" || taxes1 != "$0.0") {
        taxes1 = convert(taxes1);
      }
      if (taxes2 != "$-" || taxes2 != "$0.0") {
        taxes2 = convert(taxes2);
      }
      if (taxes3 != "$-" || taxes3 != "$0.0") {
        taxes3 = convert(taxes3);
      }
      if (taxes4 != "$-" || taxes4 != "$0.0") {
        taxes4 = convert(taxes4);
      }
      if (taxes5 != "$-" || taxes5 != "$0.0") {
        taxes5 = convert(taxes5);
      }
      // if (taxes6 != "$-" || taxes6 != "$0.0") {
      //   taxes6 = convert(taxes6);
      // }
      // if (taxes7 != "$-" || taxes7 != "$0.0") {
      //   taxes7 = convert(taxes7);
      // }
      if (housingWealth != "$-" || housingWealth != "$0.0") {
        housingWealth = convert(housingWealth);
      }
      if (housingRent != "$-" || housingRent != "$0.0") {
        housingRent = convert(housingRent);
      }
      if (topCountry2 == "") {
        topCountry2 = "-";
      }
      if (topCountry3 == "") {
        topCountry3 = "-";
      }
      if (topCountry4 == "") {
        topCountry4 = "-";
      }
      if (topCountry5 == "") {
        topCountry5 = "-";
      }
      if (topCountry2v == "") {
        topCountry2v = "-";
      }
      if (topCountry3v == "") {
        topCountry3v = "-";
      }
      if (topCountry4v == "") {
        topCountry4v = "-";
      }
      if (topCountry5v == "") {
        topCountry5v = "-";
      }
      if (entre2 == "") {
        entre2 = "-";
      }
      if (demo3 == "") {
        demo3 = "-";
      }
      if (topIndustry2 == "") {
        topIndustry2 = "-";
      }
      if (topIndustry3 == "") {
        topIndustry3 = "-";
      }
      if (topIndustry4 == "") {
        topIndustry4 = "-";
      }
      if (topIndustry5 == "") {
        topIndustry5 = "-";
      }
      if (topIndustry2v == "") {
        topIndustry2v = "-";
      }
      if (topIndustry3v == "") {
        topIndustry3v = "-";
      }
      if (topIndustry4v == "") {
        topIndustry4v = "-";
      }
      if (topIndustry5v == "") {
        topIndustry5v = "-";
      }
      if (housingOwners == "") {
        housingOwners = "-";
      }
      if (demoAge_1_1 == "") {
        demoAge_1_1 = "-";
      }
      if (demoAge_2_1 == "") {
        demoAge_2_1 = "-";
      }
      if (demoAge_3_1 == "") {
        demoAge_3_1 = "-";
      }
      if (entre1 == "") {
        entre1 = "-";
      }
      if (entre2 == "") {
        entre2 = "-";
      }
      if (entre3 == "") {
        entre3 = "-";
      }
      if (work3_1_1 == "") {
        work3_1_1 = "-";
      }
      if (work3_2_1 == "") {
        work3_2_1 = "-";
      }
      if (work3_3_1 == "") {
        work3_3_1 = "-";
      }
      if (work3_4_1 == "") {
        work3_4_1 = "-";
      }
      if (workUnder_fb == "" || workUnder_fb == "-") {
        workUnder_us = "-";
      }
      var logo = AIC_GLOBAL_VARS.url + "/static/img/" + "aiclogowithtype-small.png";
      var msaMap = msaFiltered[0]["Account Name"].replace(/\s/g, "_");
      console.log(AIC_GLOBAL_VARS.url + "/static/img/msa_images/" + msaMap + "_map.png");
      msaMap = AIC_GLOBAL_VARS.url + "/static/img/msa_images/" + msaMap + "_map.png";
      var intro = "In the United States, immigrants are more likely to be working-age than their U.S.-born counterparts. This means they are more likely to be active in the labor force, allowing them to contribute to the economy not only as consumers but also as taxpayers, helping fund social services and programs like Medicare and Social Security.";
      var moneyValues = [taxes1, taxes2, taxes3, taxes4, taxes5, entre3, housingWealth, housingRent];
      var introText = $('[data-mti-data-label="introduction"]');

      // let shareList = [
      //   overview0, demo0, demo1, demo2, demo5, demoAge_1_1, demoAge_1_2,
      //   demoAge_2_1, demoAge_2_2, demoAge_3_1, demoAge_3_2, topCountry1v,
      //   topCountry2v, topCountry3v, topCountry4v, topCountry5v, entre1,
      //   work1, work3_1_1, work3_1_2, work3_2_1, work3_2_2, work3_3_1,
      //   work3_3_2, work3_4_1, work3_4_2, workUnder_fb, workUnder_us,
      //   topIndustry1v, topIndustry2v, topIndustry3v, topIndustry4v,
      //   topIndustry5v, stemWorkersImm, nurses,
      //   healthAides, naturalizationShare
      // ];

      // // Modify values directly in the array:
      // shareList = shareList.map(value => {
      //   if (typeof value === "string" && value.endsWith("0%")) {
      //     return value.replace(/0%$/, "%");
      //   }
      //   return value;
      // });

      // [
      // overview0, demo0, demo1, demo2, demo5, demoAge_1_1, demoAge_1_2,
      //   demoAge_2_1, demoAge_2_2, demoAge_3_1, demoAge_3_2, topCountry1v,
      //   topCountry2v, topCountry3v, topCountry4v, topCountry5v, entre1,
      //   work1, work3_1_1, work3_1_2, work3_2_1, work3_2_2, work3_3_1,
      //   work3_3_2, work3_4_1, work3_4_2, workUnder_fb, workUnder_us,
      //   topIndustry1v, topIndustry2v, topIndustry3v, topIndustry4v,
      //   topIndustry5v, stemWorkersImm, nurses,
      //   healthAides, naturalizationShare
      // ] = shareList;

      function newPage(p) {
        doc.addPage();
        doc.setFontSize(16);
        doc.setFont("Karla-Medium", "medium");
        doc.text(40, 40, "Immigrants in the");
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(16);
        doc.text(180, 40, nameProper2);
        var pageNumber = p.toString();
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(560, 765, pageNumber);
      }
      function FirstPage() {
        function newPage() {
          doc.addPage();
          doc.setFontSize(16);
          doc.setFont("Karla-Medium", "medium");
          doc.text(40, 100, "Immigrants in the");
          doc.setFont("Karla-ExtraBold", "bold");
          doc.setFontSize(16);
          doc.text(150, 40, nameProper2);
        }
        console.log(msaMap);
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.src = logo;
        var imgMSA = new Image();
        imgMSA.crossOrigin = "anonymous";
        imgMSA.src = msaMap;
        doc.addImage(img, "png", 40, 20, 87.5, 42.75);
        doc.addImage(imgMSA, "png", 325, 58, 216, 144);

        ///Start new

        doc.setFontSize(20);
        doc.setFont("Karla-Regular", "regular");
        doc.text(40, 100, "Immigrants in the");
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(30);
        doc.text(40, 135, miniName);
        doc.text(40, 170, "Metro Area");
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, 220, "OVERVIEW"); //Y_value
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        doc.text(115, 214, "1"); //Y_value
        doc.setFontSize(14);
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, 225, 565, 225, "S"); //Y_value

        doc.setFont("Karla-Regular", "regular");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: 240,
          //Y_value
          startX: 0,
          tableWidth: 530,
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[overview1_text, overview1], [overview0_text, overview0], [overview3_text, overview3], ["Immigrant spending power", overview2]]
        });
        doc.setFontSize(8);
        doc.text(205, 249, "2"); //Y_value
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, 370, "DEMOGRAPHICS"); //Y_value
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, 375, 565, 375, "S"); //Y_value
        var demoText = $("#demograpicsText");
        demoText = demoText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        demoText = doc.splitTextToSize(demoText, 530);
        doc.text(40, 395, demoText); //Y_value

        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: 455,
          //Y_value
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[demo1_text, demo1], [demo2_text, demo2], [demo3_text, demo3], [demo0_text, demo0], [demo4_text, demo4], [demo5_text, demo5]]
        });
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: 600,
          //Y_value
          startX: 0,
          tableWidth: 530,
          headStyles: {
            textColor: [0, 0, 0],
            font: "Karla-Bold",
            fontSize: 11,
            fillColor: [255, 255, 255]
          },
          //         columnStyles: {
          //   0: {cellWidth: 390},
          //   1: {cellWidth: 140}
          // },
          head: [["Age Group", "Foreign-Born Population", "U.S.-Born Population"]],
          body: [["0-15", demoAge_1_1, demoAge_1_2], ["16-64", demoAge_2_1, demoAge_2_2], ["65+", demoAge_3_1, demoAge_3_2]]
        });
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(13);
        doc.setTextColor(0, 0, 0);
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);

        // 1. Create paragraphs
        var countyNote = "Note: The " + msaFormal + " metropolitan area includes the following counties: " + countiesList + ". Metropolitan areas are defined by the Office of Management and Budget (OMB): ";
        var ombText = "https://www.whitehouse.gov/wp-content/uploads/2023/07/OMB-Bulletin-23-01.pdf."; // 2. Join them as one string for wrapping

        var noteText = countyNote + ombText; // 3. Split the paragraph into lines

        var noteLines = doc.splitTextToSize(noteText, 540); // 4. Print the text line-by-line and track where the link goes

        var yNote = 710;
        var marginNote = 40;
        var linkStartX = null;
        var linkStartY = null;
        var linkWidth = null;
        noteLines.forEach(function (line) {
          var linkIndex = line.indexOf(ombText);
          if (linkIndex !== -1) {
            // Draw the text before the link in black
            var beforeLink = line.substring(0, linkIndex);
            doc.setTextColor(0, 0, 0);
            doc.text(beforeLink, marginNote, yNote); // Draw the link in blue

            var linkX = marginNote + doc.getTextWidth(beforeLink);
            doc.setTextColor(51, 102, 204); // blue
            doc.text(ombText, linkX, yNote);
            linkStartX = linkX;
            linkStartY = yNote;
            linkWidth = doc.getTextWidth(ombText);
          } else {
            doc.setTextColor(0, 0, 0);
            doc.text(line, marginNote, yNote);
          }
          yNote += 10;
        }); // 5. Add the hyperlink after text is drawn

        if (linkStartX !== null && linkStartY !== null && linkWidth !== null) {
          doc.link(linkStartX, linkStartY - 5, linkWidth, 10, {
            url: "https://www.whitehouse.gov/wp-content/uploads/2023/07/OMB-Bulletin-23-01.pdf"
          });
        }
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, 775, "Data Year: 2023");
        doc.text(560, 775, "1");

        //End of changes for #5
      }
      var n = 75,
        p = 2,
        e = 2;
      FirstPage();
      newPage(p);
      function originCountries(n) {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(13);
        doc.text(40, n, "Top Countries of Origin for Immigrants");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 12,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204],
            font: "Karla-Bold",
            fontSize: 12
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[topCountry1, topCountry1v], [topCountry2, topCountry2v], [topCountry3, topCountry3v], [topCountry4, topCountry4v], [topCountry5, topCountry5v]]
        });
      }
      function entrepreneurship(n) {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "ENTREPRENEURSHIP");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var entreText = $("#entrepreneurshipText");
        entreText = entreText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        entreText = doc.splitTextToSize(entreText, 530);
        doc.text(40, n + 25, entreText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 80,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[entre2_text, entre2], [entre1_text, entre1], [entre3_text, entre3]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
      }
      function taxesSpending(n) {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "TAXES & SPENDING POWER");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var taxText = $("#taxText");
        taxText = taxText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        taxText = doc.splitTextToSize(taxText, 530);
        doc.text(40, n + 25, taxText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 110,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[taxes1_text, taxes1], ["Total Taxes Paid", taxes5], ["Federal Taxes Paid", taxes4], ["State & Local Taxes Paid", taxes3], ["Total Spending Power", taxes2]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        var endnote3 = e + 1,
          endnote4 = e + 2,
          endnote5 = e + 3;
        doc.text(196, n + 121, endnote3.toString());
        doc.text(139, n + 164, endnote4.toString());
        doc.text(171, n + 187, endnote5.toString());
        e = e + 3;
        endnoteArray.push("X_EXP", "D_CBO", "E_ITEP");
      }
      function workforce() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "WORKFORCE");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var workText = $("#workText");
        workText = workText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        workText = doc.splitTextToSize(workText, 530);
        doc.text(40, n + 25, workText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 100,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[work2_text, work2], [work1_text, work1]]
        });
      }
      function education() {
        doc.setFont("Karla-Regular", "regular");
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n,
          startX: 0,
          tableWidth: 525,
          headStyles: {
            textColor: [0, 0, 0],
            font: "Karla-Bold",
            fontSize: 11,
            fillColor: [255, 255, 255]
          },
          //         columnStyles: {
          //   0: {cellWidth: 390},
          //   1: {cellWidth: 140}
          // },
          head: [["Education Level", "Foreign-Born Population", "U.S.-Born Population"]],
          body: [["Less than High School", work3_1_1, work3_1_2], ["High School & Some College", work3_2_1, work3_2_2], ["Bachelor's Degree", work3_3_1, work3_3_2], ["Graduate Degree", work3_4_1, work3_4_2]]
        });
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 125,
          startX: 0,
          tableWidth: 525,
          headStyles: {
            textColor: [0, 0, 0],
            font: "Karla-Bold",
            fontSize: 11,
            fillColor: [255, 255, 255]
          },
          head: [["Underemployment", "Foreign-Born Population", "U.S.-Born Population"]],
          body: [["Share of College-Educated Workers Employed in Jobs That Don’t Require a College Degree", workUnder_fb, workUnder_us]]
        });
      }
      function industry() {
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Top Industries with the Highest Shares of Immigrant Workers");
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 20,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[topIndustry1, topIndustry1v], [topIndustry2, topIndustry2v], [topIndustry3, topIndustry3v], [topIndustry4, topIndustry4v], [topIndustry5, topIndustry5v]]
        });
      }
      function stem() {
        var endnote5 = e + 1;
        e = e + 1;
        doc.setFont("Karla-Bold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Science, Technology, Engineering, & Math");
        var stemText = $("#stemText");
        stemText = stemText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        stemText = doc.splitTextToSize(stemText, 530);
        doc.text(40, n + 20, stemText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 100,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Share of STEM workers who are immigrants", stemWorkersImm]]
        });
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(8);
        doc.text(265, n + 111, endnote5.toString());
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        endnoteArray.push("F_STEM");
        return;
      }
      function healthcare() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(40, n, "Healthcare");
        var healthText = $("#healthcareText");
        healthText = healthText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        healthText = doc.splitTextToSize(healthText, 530);
        doc.text(40, n + 20, healthText);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 98,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [["Nurses who are foreign-born", nurses], ["Health aides who are foreign-born", healthAides]]
        });
      }
      function housing() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "HOUSING");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S");
        var housingText = $("#housingText");
        housingText = housingText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        housingText = doc.splitTextToSize(housingText, 530);
        doc.text(40, n + 20, housingText);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 95,
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[housingOwners_text, housingOwners], [housingWealth_text, housingWealth], [housingRent_text, housingRent]]
        });
      }
      function naturalization() {
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setFontSize(14);
        doc.setTextColor(51, 102, 204);
        doc.text(40, n, "NATURALIZATION & VOTING POWER"); //70
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, n + 5, 565, n + 5, "S"); //75

        var naturalizationText = $("#naturalizationText");
        naturalizationText = naturalizationText[0].innerHTML;
        doc.setFont("Karla-Regular", "regular");
        doc.setFontSize(11);
        doc.setTextColor(0, 0, 0);
        naturalizationText = doc.splitTextToSize(naturalizationText, 530);
        doc.text(40, n + 20, naturalizationText); //93

        doc.autoTable({
          theme: "striped",
          styles: {
            fontSize: 11,
            font: "Karla-Regular"
          },
          startY: n + 60,
          //150
          startX: 0,
          tableWidth: 530,
          headStyles: {
            fillColor: [51, 102, 204]
          },
          columnStyles: {
            0: {
              cellWidth: 390
            },
            1: {
              cellWidth: 140
            }
          },
          body: [[naturalizationShare_text, naturalizationShare], [naturalizationValue_text, naturalizationValue], [naturalizationEligible_text, naturalizationEligible], [naturalizationVote_text, naturalizationVote]]
        });
      }
      function endnote() {
        p = p + 1;
        var en = 230;
        newPage(p);
        doc.setFontSize(9);
        doc.setFont("Karla-Regular", "regular");
        doc.text(40, 70, "To learn more about Map the Impact, visit");
        doc.setTextColor(51, 102, 204);
        doc.textWithLink("maptheimpact.org.", 214, 70, {
          url: "https://data.americanimmigrationcouncil.org/map-the-impact/"
        });
        doc.setTextColor(0, 0, 0);
        doc.text(40, 90, "The American Immigration Council works to empower immigrants from arrival to belonging.");
        doc.text(40, 100, "To learn more about the Council's work, visit");
        doc.setTextColor(51, 102, 204);
        doc.textWithLink("americanimmigrationcouncil.org.", 224, 100, {
          url: "https://americanimmigrationcouncil.org."
        });
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(14);
        doc.setFont("Karla-ExtraBold", "bold");
        doc.setTextColor(51, 102, 204);
        doc.text(40, 130, "ENDNOTES");
        doc.setDrawColor(51, 102, 204);
        doc.setLineWidth(0.8);
        doc.line(40, 135, 580, 135, "S");
        if (dataSource === "3-year") {
          doc.setFontSize(8);
          doc.setTextColor(0, 0, 0);
          doc.setFont("Karla-Regular", "regular");
          doc.text(48, 150, "1.", {
            align: "right"
          });
          doc.text(55, 150, "Unless otherwise specified, data comes from the American Immigration Council analysis of a pooled 3-year sample of the 2021-2023 ", {
            align: "left"
          });
          doc.text(55, 160, "American Community Survey (ACS) microdata, downloaded from the Integrated Public Use Microdata Series (IPUMS) accessed at ", {
            align: "left"
          });
          // doc.text(
          //   55,
          //   170,
          //   "Use Microdata Series (IPUMS),",
          //    { align: "left" }
          // );
          doc.setTextColor(51, 102, 204);
          doc.textWithLink("https://www.ipums.org/.", 55, 170, {
            url: "https://www.ipums.org/"
          });
        } else {
          doc.setFontSize(8);
          doc.setTextColor(0, 0, 0);
          doc.setFont("Karla-Regular", "regular");
          doc.text(48, 150, "1.", {
            align: "right"
          });
          doc.text(55, 150, "Unless otherwise specified, data comes from the American Immigration Council analysis of microdata from the 1-year", {
            align: "left"
          });
          doc.text(55, 160, "sample of the 2023 American Community Survey (ACS), downloaded from the Integrated Public Use Microdata Series (IPUMS)", {
            align: "left"
          });
          // doc.text(
          //   55,
          //   170,
          //   "Use Microdata Series (IPUMS),",
          //    { align: "left" }
          // );
          doc.setTextColor(51, 102, 204);
          doc.textWithLink("https://www.ipums.org/.", 55, 170, {
            url: "https://www.ipums.org/"
          });
        }
        doc.setTextColor(0, 0, 0);
        doc.text(48, 190, "2.", {
          align: "right"
        });
        doc.text(55, 190, "Except where otherwise noted, an immigrant refers to anyone born outside the country to non-U.S. citizen parents who", {
          align: "left"
        });
        doc.text(55, 200, "is resident in the United States. This includes naturalized citizens, green card holders, individuals holding temporary");
        doc.text(55, 210, "(nonimmigrant) status, refugees, asylees, and undocumented immigrants, among others.");

        // ['C_CBO', 'D_ITEP', 'E_STEM', 'F_NAFSA', 'G_UNDOC1', 'H_UNDOC2', 'I_DACA1', 'J_DACA2', 'K_DACA3', 'L_REFUGEE']

        for (var i = 0; i < endnoteArray.length; i++) {
          if (endnoteArray[i] == "X_EXP") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Immigrant households refer to those with an immigrant as head of the household unit.", {
              align: "left"
            });
            en = en + 20;
          }
          if (endnoteArray[i] == "D_CBO") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Congressional Budget Office. 2022. “The Distribution of Household Income and Federal Taxes, 2019.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www.cbo.gov/publication/58353.", 55, en + 10, {
              url: "https://www.cbo.gov/publication/58353"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "E_ITEP") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "Institute on Taxation and Economic Policy (ITEP). 2024. “Who Pays? A Distributional Analysis of the Tax Systems in", {
              align: "left"
            });
            doc.text(55, en + 10, "All 50 States (7th edition).“", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://itep.org/whopays-7th-edition/.", 155, en + 10, {
              url: "https://itep.org/whopays-7th-edition/"
            });
            en = en + 30;
          }
          if (endnoteArray[i] == "F_STEM") {
            var x = i + 1;
            var enumber = x.toString() + ".";
            doc.setTextColor(0, 0, 0);
            doc.text(48, en, enumber, {
              align: "right"
            });
            doc.text(55, en, "U.S. Census Bureau. 2018. “STEM, STEM-related, and Non-STEM Occupation Code List 2018.”", {
              align: "left"
            });
            doc.setTextColor(51, 102, 204);
            doc.textWithLink("https://www2.census.gov/programs-surveys/demo/guidance/industry-occupation/", 55, en + 10, {
              url: "https://www2.census.gov/programs-surveys/demo/guidance/industry-occupation/2018-census-stem-related-and-non-stem-occupation-code-list.xlsx"
            });
            doc.textWithLink("2018-census-stem-related-and-non-stem-occupation-code-list.xlsx", 55, en + 20, {
              url: "https://www2.census.gov/programs-surveys/demo/guidance/industry-occupation/2018-census-stem-related-and-non-stem-occupation-code-list.xlsx"
            });
            en = en + 40;
          }
        }

        // let countiesText = doc.splitTextToSize(countiesList, 530);
        // doc.text(55, en + 10, countiesText, { align: "left" });
      }
      if (originCountriesTable == 1) {
        if (n + 165 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        originCountries(n);
        n = n + 165;
      }
      if (entrepreneurshipTable == 1) {
        if (n + 220 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        entrepreneurship(n);
        n = n + 200;
      }
      if (taxesTable == 1) {
        if (n + 300 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        taxesSpending(n);
        n = n + 300;
        CBO = 1;
        ITEP = 1;
      }
      if (workforceTable == 1) {
        if (n + 160 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        workforce(n);
        n = n + 160;
      }
      if (educationTable == 1) {
        if (n + 210 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        education(n);
        n = n + 235;
      }
      if (industryTable == 1) {
        if (n + 165 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        industry(n);
        n = n + 160;
      }
      if (stemTable == 1) {
        if (n + 155 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        stem(n);
        STEM = 1;
        n = n + 155;
      }
      if (healthcareTable == 1) {
        if (n + 175 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        healthcare(n);
        n = n + 175;
      }
      if (housingTable == 1) {
        if (n + 220 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        housing(n);
        n = n + 220;
      }
      if (naturalizationTable == 1) {
        if (n + 195 >= 770) {
          p = p + 1;
          n = 75;
          newPage(p);
        }
        naturalization(n);
        n = n + 195;
      }
      endnote();
      var download_button = document.getElementById("downloadButton");
      var file_name = "AIC_Map_the_Impact-" + name + ".pdf";
      download_button.addEventListener("click", function () {
        doc.save(file_name);
      });
    }, 100);
  }
}

},{"./_config":21,"./_misc":22}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mti_copy_link = mti_copy_link;
exports.mti_show_copy_link_text = mti_show_copy_link_text;
function mti_show_copy_link_text() {
  var copyLinkButtons = document.querySelectorAll("[data-copy-link]");
  var copyLinkTextElements = document.querySelectorAll(["data-copy-link-text"]);
  copyLinkButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var section = button.getAttribute("data-copy-link");
      var linkTextElement = document.querySelector("[data-copy-link-text='" + section + "']");
      if (linkTextElement) {
        linkTextElement.style.display = "block"; // Display the element

        // Set timeout to hide the element after 'duration' milliseconds
        setTimeout(function () {
          linkTextElement.style.display = "none"; // Hide the element after duration
        }, 2000);
      } else {
        console.error("Element with id '" + elementId + "' not found.");
      }
    });
  });
}
function mti_copy_link() {
  var copyElements = document.querySelectorAll("[data-copy-link]");
  if (copyElements) {
    var copyTextToClipboard = function copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function () {
        console.log("Async: Copying to clipboard was successful!");
      }, function (err) {
        console.error("Async: Could not copy text: ", err);
      });
    };
    var fallbackCopyTextToClipboard = function fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }
      document.body.removeChild(textArea);
    };
    var stateSlug = document.getElementById("page-slug").innerText;
    copyElements.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        // Get the text field
        var sectionID = el.getAttribute("data-section-id");
        var url = window.location.hostname + "/locations/" + stateSlug + "#" + sectionID;

        // Copy the text inside the text field
        copyTextToClipboard(url);
      });
    });
  }
}

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aic_state_svg = aic_state_svg;
function aic_state_svg() {
  var stateMap = d3.json(AIC_GLOBAL_VARS.url + "/static/data/map-the-impact/gz_2010_us_040_00_20m.min.json");

  // Load state SVG data
  Promise.all([stateMap]).then(function (stateMap) {
    nae_create_state_map(stateMap);
  })["catch"](function (error) {
    console.log(error);
  });

  // Function to create state maps
  function nae_create_state_map(specState) {
    console.log(specState);
    var margin = {
      top: 10,
      right: 10,
      bottom: 20,
      left: 10
    };
    var marginMap = {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10
      },
      widthMap = 500 - margin.left - margin.right,
      heightMap = 300 - margin.top - margin.bottom;
    var projection = d3.geoMercator().scale(widthMap + 100).translate([widthMap / 2, heightMap / 2]);
    var pathState = d3.geoPath().projection(projection);
    var svgState = d3.selectAll("#state-svg").attr("width", widthMap).attr("height", heightMap);
    var gMap = svgState.append("g");

    //console.log(specState[0].features);

    gMap.selectAll(".stateOutline").data(specState[0].features).enter().append("path").attr("d", pathState).attr("id", function (d) {
      return "id" + d.properties.NAME.replace(/\s/g, "");
    }).attr("class", "stateOutline").attr("fill", "#3366cc").style("stroke", "#ffffff");
    var translationMap = {
      "Estados Unidos": "United States of America",
      Alabama: "Alabama",
      Alaska: "Alaska",
      Arizona: "Arizona",
      Arkansas: "Arkansas",
      California: "California",
      Colorado: "Colorado",
      Connecticut: "Connecticut",
      Delaware: "Delaware",
      Florida: "Florida",
      Georgia: "Georgia",
      Hawai: "Hawaii",
      Idaho: "Idaho",
      Illinois: "Illinois",
      Indiana: "Indiana",
      Iowa: "Iowa",
      Kansas: "Kansas",
      Kentucky: "Kentucky",
      Luisiana: "Louisiana",
      Maine: "Maine",
      Maryland: "Maryland",
      Massachusetts: "Massachusetts",
      Michigan: "Michigan",
      Minnesota: "Minnesota",
      Misisipí: "Mississippi",
      Misuri: "Missouri",
      Montana: "Montana",
      Nebraska: "Nebraska",
      Nevada: "Nevada",
      "Nuevo Hampshire": "New Hampshire",
      "Nueva Jersey": "New Jersey",
      "Nuevo México": "New Mexico",
      "Nueva York": "New York",
      "Carolina del Norte": "North Carolina",
      "Dakota del Norte": "North Dakota",
      Ohio: "Ohio",
      Oklahoma: "Oklahoma",
      Oregón: "Oregon",
      Pensilvania: "Pennsylvania",
      "Rhode Island": "Rhode Island",
      "Carolina del Sur": "South Carolina",
      "Dakota del Sur": "South Dakota",
      Tennesse: "Tennessee",
      Texas: "Texas",
      Utah: "Utah",
      Vermont: "Vermont",
      Virginia: "Virginia",
      Washington: "Washington",
      "Virginia Occidental": "West Virginia",
      Wisconsin: "Wisconsin",
      Wyoming: "Wyoming",
      "Distrito de Columbia": "District of Columbia"
    };
    function translateToEnglish(spanishName) {
      return translationMap[spanishName] || spanishName;
    }
    var slug;
    if (window.location.href.indexOf("/es/") != 0) {
      slug = translateToEnglish(document.getElementById("page-term-name").textContent);
    } else {
      slug = document.getElementById("page-term-name").textContent;
    }
    console.log(slug);
    var stateID = "#id" + slug.replace(/\s/g, "");
    if (stateID == "#idUnitedStatesofAmerica" || stateID == "#idEstadosUnidos") {
      //console.log(specState);
      //Code for entire U.S. map
      var bounds = pathState.bounds(specState[0].features[0]),
        dx = bounds[1][0] - bounds[0][0],
        dy = bounds[1][1] - bounds[0][1],
        x = (bounds[0][0] + bounds[1][0]) / 2.2,
        y = (bounds[0][1] + bounds[1][1]) / 1.5,
        scale = 0.17 / Math.max(dx / widthMap, dy / heightMap),
        translate = [widthMap / 2 - scale * x, heightMap / 2 - scale * y];
      gMap.transition().duration(10).attr("d", pathState).attr("transform", "translate(" + translate + ")scale(" + scale + ")");
      gMap.selectAll(".stateOutline").attr("fill", function (d) {
        if (d.properties.NAME == "Puerto Rico" || d.properties.NAME == "Alaska" || d.properties.NAME == "Hawaii") {
          return "#fff";
        } else {
          return "#3366cc";
        }
      });
      // END code for entire U.S. map
    } else if (stateID == "#idAlaska") {
      var bounds = pathState.bounds(specState[0].features.filter(function (d) {
          return d.properties.NAME == slug;
        })[0]),
        dx = bounds[1][0] - bounds[0][0],
        dy = bounds[1][1] - bounds[0][1],
        x = (bounds[0][0] + bounds[1][0]) / 2,
        y = (bounds[0][1] + bounds[1][1]) / 2,
        scale = 3.3 / Math.max(dx / widthMap, dy / heightMap),
        translate = [1.7 * widthMap, 1.7 * heightMap];
      gMap.transition().duration(10).attr("d", pathState).attr("transform", "translate(" + translate + ")scale(" + scale + ")");
      gMap.selectAll(".stateOutline").attr("fill", "none");
      gMap.select(stateID).attr("fill", "#3366cc");
    } else {
      var bounds = pathState.bounds(specState[0].features.filter(function (d) {
          return d.properties.NAME == slug;
        })[0]),
        dx = bounds[1][0] - bounds[0][0],
        dy = bounds[1][1] - bounds[0][1],
        x = (bounds[0][0] + bounds[1][0]) / 2,
        y = (bounds[0][1] + bounds[1][1]) / 2,
        scale = 0.95 / Math.max(dx / widthMap, dy / heightMap),
        translate = [widthMap / 2 - scale * x, heightMap / 2 - scale * y];
      gMap.transition().duration(10).attr("d", pathState).attr("transform", "translate(" + translate + ")scale(" + scale + ")");
      gMap.selectAll(".stateOutline").attr("fill", "none");
      gMap.select(stateID).attr("fill", "#3366cc");
    }
  }
}

},{}],27:[function(require,module,exports){
"use strict";

var _defaultI18n = require("@wordpress/i18n/build/default-i18n.js");
var _numerals = require("./_numerals.js");
var _misc = require("./_misc.js");
var _social = require("./_social.js");
var _state_svg = require("./_state_svg.js");
var _config = require("./_config.js");
var _pdf = require("./_pdf");
(0, _numerals.aic_configure_numeralJs)();
(0, _misc.aic_toggle_dropdowns)();

// Load state SVG data
(0, _state_svg.aic_state_svg)();
if (window.location.href.indexOf("city") > -1) {
  var stateData = _config.metro_area_data;
  // console.log("Metro Area loading");
} else {
  // Set up state data and map SVG data
  var stateData = _config.state_data;
}
Promise.all([stateData]).then(function (stateData) {
  aic_load_state_content(stateData[0]);
  (0, _misc.aic_hide_datapoints_no_data)();
  (0, _misc.aic_hide_undoc_line_if_no_data)();
  (0, _misc.aic_hide_underemployed_no_foreign_born)();
  (0, _misc.aic_hide_pie_chart_labels)();
  (0, _misc.aic_dont_round_tps_holders)();
})["catch"](function (error) {
  console.log(error);
});
// Cornerstone function that loads all the data onto the page
function aic_load_state_content(el) {
  // Get slug from DOM
  var slug = document.getElementById("page-term-name").textContent.toLowerCase().replaceAll(" ", "-");
  if (slug == "united-states-of-america") {
    slug = "national";
  }

  // Setup empty object for current locale data
  var currentLocaleData = {};

  // Call functions
  aic_find_load_current_locale_json();
  aic_load_locale_data_to_page();
  aic_load_donut_charts_to_page();
  aic_load_bar_charts_to_page();
  aic_compare_educational_stats_highlight();
  aic_add_labels_industry_countriesOrigin_pie_charts();
  aic_hide_table_no_data();
  (0, _misc.aic_change_letter_spacing)();

  // Function to loop through JSON URL, find current locale, and load data in currentLocaleData object
  function aic_find_load_current_locale_json() {
    var currentTranslation = "english";
    if (window.location.href.indexOf("/es/") != -1) {
      currentTranslation = "spanish";
    }
    // console.log(currentTranslation);
    // Loop through stateData JSON object
    for (var index = 0; index < el.length; index++) {
      var locale = el[index]["Account Name"].toLowerCase();

      // console.log(locale);

      locale = locale.replaceAll(" ", "-");

      // If the locale in the JSON object mathces the slug on the page
      if (locale == slug) {
        currentLocaleData["localeName"] = el[index]["Account Name"];
        // console.log(currentLocaleData["localeName"]);

        (0, _misc.aic_populate_county_names)(el[index]["County Names"]);
        (0, _misc.aic_populate_msa_long_name)(el[index]["CBSA Formal"]);

        //Year
        currentLocaleData["dataYear"] = el[index]["Year"];

        //Introduction Paragraph
        currentLocaleData["introduction"] = el[index]["Introduction"];

        //Overview Datapoints
        currentLocaleData["immSharePopulation"] = numeral(el[index]["Immigrant Share of Population"]).format("0.0%");

        // let immResidents = Math.floor(el[index]["Immigrant Residents"]);

        // console.log(immResidents);
        // immResidents = Math.round(immResidents / 100) * 100;

        // console.log(immResidents);

        currentLocaleData["source"] = el[index]["Source"];
        currentLocaleData["immResidents"] = el[index]["Immigrant Residents"];
        currentLocaleData["immSharePop"] = el[index]["Immigrant Share of Population"];
        currentLocaleData["numObservations"] = el[index]["Number of Observatons"];

        //Demographics Datapoints
        currentLocaleData["demo_share_oneImmigrantParent"] = el[index]["U.S.-born Residents, At Least One Immigrant Parent, %"];
        currentLocaleData["demo_number_oneImmigrantParent"] = el[index]["U.S.-born Residents, At Least One Immigrant Parent"];
        currentLocaleData["demo_number_immigrantWomen"] = el[index]["Foreign-Born, Women"];
        currentLocaleData["demo_number_immigrantMen"] = el[index]["Foreign-Born, Men"];
        currentLocaleData["demo_number_immigrantChildren"] = el[index]["Foreign-Born, Children"];
        currentLocaleData["demoForeignBorn015"] = el[index]["Foreign-Born, Ages 0-15"];
        currentLocaleData["demoForeignBorn1664"] = el[index]["Foreign-Born, Ages 16-64"];
        currentLocaleData["demoForeignBorn65"] = el[index]["Foreign-Born, Ages 65+"];
        currentLocaleData["demoNativeBorn015"] = el[index]["Native-Born, Ages 0-15"];
        currentLocaleData["demoNativeBorn1664"] = el[index]["Native-Born, Ages 16-64"];
        currentLocaleData["demoNativeBorn65"] = el[index]["Native-Born, Ages 65+"];
        currentLocaleData["demo_share_immProficientEnglish"] = el[index]["Foreign-Born, Share Proficient in English"];

        // Top Countries of Origin
        currentLocaleData["topCountriesOrigin_1_datapoint"] = el[index]["#1 Country of Origin, Value"];
        currentLocaleData["topCountriesOrigin_1_label"] = el[index]["#1 Country of Origin"];
        currentLocaleData["topCountriesOrigin_2_datapoint"] = el[index]["#2 Country of Origin, Value"];
        currentLocaleData["topCountriesOrigin_2_label"] = el[index]["#2 Country of Origin"];
        currentLocaleData["topCountriesOrigin_3_datapoint"] = el[index]["#3 Country of Origin, Value"];
        currentLocaleData["topCountriesOrigin_3_label"] = el[index]["#3 Country of Origin"];
        currentLocaleData["topCountriesOrigin_4_datapoint"] = el[index]["#4 Country of Origin, Value"];
        currentLocaleData["topCountriesOrigin_4_label"] = el[index]["#4 Country of Origin"];
        currentLocaleData["topCountriesOrigin_5_datapoint"] = el[index]["#5 Country of Origin, Value"];
        currentLocaleData["topCountriesOrigin_5_label"] = el[index]["#5 Country of Origin"];

        //Entreprenurship Datapoints
        currentLocaleData["immEntrepreneurs"] = el[index]["Immigrant Entrepreneurs"];
        currentLocaleData["busIncomeImmEntrepreneurs"] = el[index]["Business Income of Immigrant Entrepreneurs"];
        currentLocaleData["shareEntrepreneursImm"] = el[index]["Entrepreneur, Foreign-Born Share"];
        currentLocaleData["entrepreneurship-fortune500"] = el[index]["Fortune 500 Companies"];

        //Taxes & Spending Power Datapoints
        currentLocaleData["immHouseholdIncome"] = el[index]["Immigrant Household Income"];
        currentLocaleData["immTaxesPaid"] = el[index]["Immigrant Taxes Paid"];
        currentLocaleData["stateLocalTaxes"] = el[index]["State & Local Taxes"];
        currentLocaleData["federalTaxes"] = el[index]["Federal Taxes"];
        currentLocaleData["immSpendingPower"] = el[index]["Immigrant Spending Power"];
        currentLocaleData["medicare"] = el[index]["Foreign-born, Contributions to Medicare"];
        currentLocaleData["socialSecurity"] = el[index]["Foreign-born, Contributions to Social Security"];

        //Workforce Datapoints
        currentLocaleData["workforceForeignLessHighSchool"] = el[index]["Foreign-Born, Less Than High School"].replace("*", "");
        currentLocaleData["workforceForeignHighSchoolSomeCollege"] = el[index]["Foreign-Born, High School & Some College"].replace("*", "");
        currentLocaleData["workforceForeignBachelors"] = el[index]["Foreign-Born, Bachelor's Degree"].replace("*", "");
        currentLocaleData["workforceForeignGraduate"] = el[index]["Foreign-Born, Graduate Degree"].replace("*", "");
        currentLocaleData["workforceNativeLessHighSchool"] = el[index]["Native-Born, Less Than High School"].replace("*", "");
        currentLocaleData["workforceNativeHighSchoolSomeCollege"] = el[index]["Native-Born, High School & Some College"].replace("*", "");
        currentLocaleData["workforceNativeBachelors"] = el[index]["Native-Born, Bachelor's Degree"].replace("*", "");
        currentLocaleData["workforceNativeGraduate"] = el[index]["Native-Born, Graduate Degree"].replace("*", "");
        currentLocaleData["workforceNativeGraduate"] = el[index]["Native-Born, Graduate Degree"].replace("*", "");
        currentLocaleData["workforce_foreignShare"] = el[index]["Labor Force, Foreign-Born Share"].replace("*", "");
        currentLocaleData["workforce_foreign"] = el[index]["Labor Force, Foreign-Born"].replace("*", "");
        currentLocaleData["workforceForeignUnderemployed"] = el[index]["Foreign-Born, Underemployed"].replace("*", "");
        currentLocaleData["workforceNativeUnderemployed"] = el[index]["US-Born, Underemployed"].replace("*", "");

        //Top Industries
        currentLocaleData["topIndustries_1_datapoint"] = el[index]["#1 Industry, Value"];
        currentLocaleData["topIndustries_1_label"] = el[index]["#1 Industry"];
        currentLocaleData["topIndustries_2_datapoint"] = el[index]["#2 Industry, Value"];
        currentLocaleData["topIndustries_2_label"] = el[index]["#2 Industry"];
        currentLocaleData["topIndustries_3_datapoint"] = el[index]["#3 Industry, Value"];
        currentLocaleData["topIndustries_3_label"] = el[index]["#3 Industry"];
        currentLocaleData["topIndustries_4_datapoint"] = el[index]["#4 Industry, Value"];
        currentLocaleData["topIndustries_4_label"] = el[index]["#4 Industry"];
        currentLocaleData["topIndustries_5_datapoint"] = el[index]["#5 Industry, Value"];
        currentLocaleData["topIndustries_5_label"] = el[index]["#5 Industry"];

        //Top Occupations
        currentLocaleData["topOccupations_1_datapoint"] = el[index]["#1 Occupation, Value"];
        currentLocaleData["topOccupations_1_label"] = el[index]["#1 Occupation"];
        currentLocaleData["topOccupations_2_datapoint"] = el[index]["#2 Occupation, Value"];
        currentLocaleData["topOccupations_2_label"] = el[index]["#2 Occupation"];
        currentLocaleData["topOccupations_3_datapoint"] = el[index]["#3 Occupation, Value"];
        currentLocaleData["topOccupations_3_label"] = el[index]["#3 Occupation"];
        currentLocaleData["topOccupations_4_datapoint"] = el[index]["#4 Occupation, Value"];
        currentLocaleData["topOccupations_4_label"] = el[index]["#4 Occupation"];
        currentLocaleData["topOccupations_5_datapoint"] = el[index]["#5 Occupation, Value"];
        currentLocaleData["topOccupations_5_label"] = el[index]["#5 Occupation"];

        //STEM Datapoints
        currentLocaleData["stemWorkersImm"] = el[index]["STEM workers who are immigrants"];

        //Healthcare Datapoints
        currentLocaleData["nursesForeign"] = el[index]["Nurses who are foreign-born"];
        currentLocaleData["aidesForeign"] = el[index]["Health aides who are foreign-born"];

        //Housing Datapoints
        currentLocaleData["immHomeowners"] = el[index]["Immigrant homeowners"];
        currentLocaleData["shareHomebuyersForeign"] = el[index]["Share of recent homebuyers who were foreign-born"];
        currentLocaleData["housingWealthImmHouseholds"] = el[index]["Housing wealth held by immigrant households"];
        currentLocaleData["amountPaidImmHouseholdsRent"] = el[index]["Amount paid by immigrant-led households in rent"];

        //International Students Datapoints
        currentLocaleData["studentsCollegeIntl"] = el[index]["Students at [state] colleges and universities who are international"];
        currentLocaleData["econContributionsIntlStudents"] = el[index]["Economic contribution of international students"];
        currentLocaleData["jobSupportedIntlStudents"] = el[index]["Jobs supported by international students"];

        //Voting Power Datapoints
        currentLocaleData["immEligibleVote"] = el[index]["Immigrants eligible to vote"];
        currentLocaleData["immNaturalized"] = el[index]["Foreign-Born, Naturalized"];
        currentLocaleData["immNaturalizationEligible"] = el[index]["Foreign-Born, Eligible to Naturalize"];
        currentLocaleData["immNaturalizedShare"] = el[index]["Foreign-Born, Naturalized Share"];

        //Undocumented Immigrants Datapoints
        currentLocaleData["undocumentedImm"] = el[index]["Undocumented Immigrants"];
        currentLocaleData["shareUndocumentedWorkingAge"] = el[index]["Share of undocumented immigrants, working age"];
        currentLocaleData["immEntrepreneursUndocumentedImm"] = el[index]["Immigrant entrepreneurs, Undocumented Immigrants"];
        currentLocaleData["immHouseholdIncomeUndocumentedImm"] = el[index]["Immigrant Household Income, Undocumented Immigrants"];
        currentLocaleData["taxesPaidUndocumentedImm"] = el[index]["Taxes Paid, Undocumented Immigrants"];
        currentLocaleData["stateLocalTaxesPaidUndocumentedImm"] = el[index]["State & Local Taxes, Undocumented Immigrants"];
        currentLocaleData["federalTaxesPaidUndocumentedImm"] = el[index]["Federal Taxes, Undocumented Immigrants"];
        currentLocaleData["immSpendingPowerUndocumentedImmg"] = el[index]["Immigrant Spending Power, Undocumented Immigrants"];
        currentLocaleData["undoc_foreignBornShareUndoc"] = el[index]["Foreign-Born, Share Undocumented"];
        currentLocaleData["undoc_totalPopShareUndocumented"] = el[index]["Total Pop, Share Undocumented"];
        currentLocaleData["undoc_laborForceShareUndocumented"] = el[index]["Labor Force, Share Undocumented"];
        currentLocaleData["undoc_citizensLivingWithOneFamMemberShare"] = el[index]["U.S. Citizens Living With >= 1 Undoc Fam Member, Share"];
        currentLocaleData["undoc_citizensChildrenLivingWithOneUndocFamMember"] = el[index]["U.S. Citizen Children Living With >= 1 Undoc Fam Member"];
        currentLocaleData["undoc_citizensChildrenLivingWithOneUndocFamMemberShare"] = el[index]["U.S. Citizen Children Living With >= 1 Undoc Fam Member, Share"];
        currentLocaleData["undoc_citizensLivingWithOneFamMember"] = el[index]["U.S. Citizens Living With >= 1 Undoc Fam Member"];
        currentLocaleData["undoc_citizensChildrenLivingWithOneUndocFamMember"] = el[index]["U.S. Citizen Children Living With >= 1 Undoc Fam Member"];
        currentLocaleData["undoc_citizensChildrenLivingWithOneUndocParentShare"] = el[index]["U.S. Citizen Children Living With >= 1 Undoc Parent, Share"];
        currentLocaleData["undoc_citizensChildrenLivingWithOneUndocParent"] = el[index]["U.S. Citizen Children Living With >= 1 Undoc Parent"];
        currentLocaleData["undoc_topIndustries_1_datapoint"] = el[index]["#1 Industry, Pct Undoc"];
        currentLocaleData["undoc_topIndustries_1_label"] = el[index]["Undoc #1 Industry"];
        currentLocaleData["undoc_topIndustries_2_datapoint"] = el[index]["#2 Industry, Pct Undoc"];
        currentLocaleData["undoc_topIndustries_2_label"] = el[index]["Undoc #2 Industry"];
        currentLocaleData["undoc_topIndustries_3_datapoint"] = el[index]["#3 Industry, Pct Undoc"];
        currentLocaleData["undoc_topIndustries_3_label"] = el[index]["Undoc #3 Industry"];
        currentLocaleData["undoc_topIndustries_4_datapoint"] = el[index]["#4 Industry, Pct Undoc"];
        currentLocaleData["undoc_topIndustries_4_label"] = el[index]["Undoc #4 Industry"];
        currentLocaleData["undoc_topIndustries_5_datapoint"] = el[index]["#5 Industry, Pct Undoc"];
        currentLocaleData["undoc_topIndustries_5_label"] = el[index]["Undoc #5 Industry"];

        // DACA Datapoints
        currentLocaleData["numDacaEligibleResidents"] = el[index]["Number of DACA Eligible Residents"];
        currentLocaleData["shareDACALaborForceEmployed"] = el[index]["Share of DACA Eligible Population in Labor Force that is Employed"];
        currentLocaleData["immEntrepreneursDACA"] = el[index]["Immigrant Entrepreneurs, DACA-Eligible"];
        currentLocaleData["immHouseholdIncomeDACA"] = el[index]["Immigrant Household Income, DACA-Eligible"];
        currentLocaleData["taxesPaidDACA"] = el[index]["Taxes Paid, DACA-Eligible"];
        currentLocaleData["stateLocalTaxesDACA"] = el[index]["State & Local Taxes, DACA-Eligible"];
        currentLocaleData["federalTaxesDACA"] = el[index]["Federal Taxes, DACA-Eligible"];
        currentLocaleData["immSpendingPowerDACA"] = el[index]["Immigrant Spending Power, DACA-Eligible"];
        currentLocaleData["dacaActiveRecipients"] = el[index]["Number of Active DACA Recipients"];
        currentLocaleData["dacaResidentsAllButEdu"] = el[index]["DACA, # of Additional Residents Who Would Satisfy All But Edu Rec"];
        currentLocaleData["dacaNumPeopleDacaGranted"] = el[index]["Number of People with DACA Granted"];
        // currentLocaleData["dacaResEligibleGrowOlder"] =
        //     aic_round_to_nearest_hundred(
        //         el[index][
        //             "DACA, # of Additional Residents Who Would Become Eligible as They Grow Older"
        //         ]
        //     );

        // TPS Datapoints
        currentLocaleData["tps-numHolders"] = el[index]["Number of TPS Holders"];
        currentLocaleData["tps-shareWorkingAge"] = el[index]["Share of TPS Holders, Working Age"];
        currentLocaleData["tps-shareLaborForceEmployed"] = el[index]["Share of TPS Holders in Labor Force, Employed"];
        currentLocaleData["tps-householdIncome"] = el[index]["TPS Holders' Household Income"];
        currentLocaleData["tps-taxesPaid"] = el[index]["Taxes Paid, TPS Holders"];
        currentLocaleData["tps-stateLocalTaxes"] = el[index]["State & Local Taxes, TPS Holders"];
        currentLocaleData["tps-federalTaxes"] = el[index]["Federal Taxes, TPS Holders"];
        currentLocaleData["tps-totalSpendingPower"] = el[index]["TPS Holders' Total Spending Power"];

        // Refugees Datapoints
        currentLocaleData["refugees-number"] = el[index]["Number of Refugees"];
        currentLocaleData["refugees-shareLaborForceEmployed"] = el[index]["Share of Refugees in Labor Force, Employed"];
        currentLocaleData["refugees-immEntrepreneurs"] = el[index]["Immigrant Entrepreneurs, Refugees"];
        currentLocaleData["refugees-businessIncomeEntrepeneurs"] = el[index]["Business Income of Refugee Entrepreneurs"];
        currentLocaleData["refugees-householdIncome"] = el[index]["Refugees' Household Income"];
        currentLocaleData["refugees-taxesPaid"] = el[index]["Taxes Paid, Refugees"];
        currentLocaleData["refugees-stateLocalTaxes"] = el[index]["State & Local Taxes, Refugees"];
        currentLocaleData["refugees-federalTaxes"] = el[index]["Federal Taxes, Refugees"];
        currentLocaleData["refugees-totalSpendingPower"] = el[index]["Refugees' Total Spending Power"];
        currentLocaleData["refugees-naturalized"] = el[index]["Refugee, Pct Naturalized"];
        currentLocaleData["refugees-resettled"] = el[index]["Recent Refugees Resettled"];
        currentLocaleData["refugees_countryOrigin_1_datapoint"] = el[index]["Recent Refugee - #1 Country of Origin, Value"];
        currentLocaleData["refugees_countryOrigin_1_label"] = el[index]["Recent Refugee - #1 Country of Origin"];
        currentLocaleData["refugees_countryOrigin_2_datapoint"] = el[index]["Recent Refugee - #2 Country of Origin, Value"];
        currentLocaleData["refugees_countryOrigin_2_label"] = el[index]["Recent Refugee - #2 Country of Origin"];
        currentLocaleData["refugees_countryOrigin_3_datapoint"] = el[index]["Recent Refugee - #3 Country of Origin, Value"];
        currentLocaleData["refugees_countryOrigin_3_label"] = el[index]["Recent Refugee - #3 Country of Origin"];
        currentLocaleData["refugees_countryOrigin_4_datapoint"] = el[index]["Recent Refugee - #4 Country of Origin, Value"];
        currentLocaleData["refugees_countryOrigin_4_label"] = el[index]["Recent Refugee - #4 Country of Origin"];
        currentLocaleData["refugees_countryOrigin_5_datapoint"] = el[index]["Recent Refugee - #5 Country of Origin, Value"];
        currentLocaleData["refugees_countryOrigin_5_label"] = el[index]["Recent Refugee - #5 Country of Origin"];

        // console.log(currentLocaleData);

        break;
      }
    }
  }

  // Compare a couple of Demographics datapoints
  aic_compare_stats_highlight("demoForeignBorn1664", "demoNativeBorn1664");

  // Function to load
  function aic_hide_table_no_data() {
    var tables = document.querySelectorAll(".locale__table");
    tables.forEach(function (table) {
      var first_cell_data = table.children[0].children[0].children[1].innerHTML;
      if (first_cell_data == "$0.0" || first_cell_data == "-") {
        table.style.display = "none";
      }
    });
  }

  // Function to load current locale integer and dollar data onto page
  function aic_load_locale_data_to_page() {
    var dataPointElements = document.querySelectorAll("[data-mti-datapoint]");
    dataPointElements.forEach(function (el) {
      for (var key in currentLocaleData) {
        // console.log(currentLocaleData[key]);
        if (el.attributes["data-mti-datapoint"].value == key) {
          if (el.attributes["data-mti-datapoint"].value == "introduction" || el.attributes["data-mti-datapoint"].value == "dataYear" || el.attributes["data-mti-datapoint"].value == "source") {
            el.innerHTML = currentLocaleData[key];
          } else {
            if (typeof currentLocaleData[key] == "number") {
              currentLocaleData[key] = currentLocaleData[key].toString();
            }
            if (currentLocaleData[key] != undefined) {
              if (currentLocaleData[key].includes("$")) {
                el.setAttribute("data-raw-value", currentLocaleData[key]);
                el.innerHTML = numeral(currentLocaleData[key]).format("$0.0a");
                el.setAttribute("aria-label", numeral(currentLocaleData[key]).format("$0.0a"));
              } else if (currentLocaleData[key].includes("%")) {
                el.setAttribute("data-raw-value", currentLocaleData[key]);
                el.innerHTML = numeral(currentLocaleData[key]).format("0.0%");
                el.setAttribute("aria-label", numeral(currentLocaleData[key]).format("0.0%"));
              } else {
                el.setAttribute("data-raw-value", currentLocaleData[key]);
                if (currentLocaleData[key] == "") {
                  el.setAttribute("aria-label", currentLocaleData[key]);
                  el.innerHTML = currentLocaleData[key];
                } else if (el.attributes["data-mti-datapoint"].value == "entrepreneurship-fortune500" || el.attributes["data-mti-datapoint"].value == "refugees-resettled" || el.attributes["data-mti-datapoint"].value == "dacaNumPeopleDacaGranted" || el.attributes["data-mti-datapoint"].value == "dacaActiveRecipients" || el.attributes["data-mti-datapoint"].value == "studentsCollegeIntl" || el.attributes["data-mti-datapoint"].value == "jobSupportedIntlStudents") {
                  el.innerHTML = numeral(currentLocaleData[key]).format("0,0");
                  el.setAttribute("data-raw-value", numeral(currentLocaleData[key]).format("0,0"));
                  el.setAttribute("aria-label", numeral(currentLocaleData[key]).format("0,0"));
                } else {
                  el.innerHTML = (0, _misc.aic_round_to_nearest_hundred)(currentLocaleData[key]);
                  el.setAttribute("aria-label", (0, _misc.aic_round_to_nearest_hundred)(currentLocaleData[key]));
                }
              }
            }
          }
        }
      }
    });
  }

  // Function to load donut charts to page
  function aic_load_donut_charts_to_page() {
    aic_create_donut_chart("#stateDonut", currentLocaleData["immSharePopulation"], mtiTranslations.immSharePopulation);
    aic_create_donut_chart("#demo_share_oneImmigrantParent", currentLocaleData["demo_share_oneImmigrantParent"], mtiTranslations.demoShareOneImmigrantParent);
    aic_create_donut_chart("#topCountriesOrigin_1", currentLocaleData["topCountriesOrigin_1_datapoint"], currentLocaleData["topCountriesOrigin_1_label"], "blue");
    aic_create_donut_chart("#topCountriesOrigin_2", currentLocaleData["topCountriesOrigin_2_datapoint"], currentLocaleData["topCountriesOrigin_2_label"], "blue");
    aic_create_donut_chart("#topCountriesOrigin_3", currentLocaleData["topCountriesOrigin_3_datapoint"], currentLocaleData["topCountriesOrigin_3_label"], "blue");
    aic_create_donut_chart("#topCountriesOrigin_4", currentLocaleData["topCountriesOrigin_4_datapoint"], currentLocaleData["topCountriesOrigin_4_label"], "blue");
    aic_create_donut_chart("#topCountriesOrigin_5", currentLocaleData["topCountriesOrigin_5_datapoint"], currentLocaleData["topCountriesOrigin_5_label"], "blue");
    aic_create_donut_chart("#shareEntrepreneursImm", currentLocaleData["shareEntrepreneursImm"], mtiTranslations.shareEntrepreneursImm);
    aic_create_donut_chart("#workforce_foreignShare", currentLocaleData["workforce_foreignShare"], currentLocaleData["Share of workers in the labor force who are immigrants"], "blue");
    aic_create_double_donute_chart("#topIndustries_1", currentLocaleData["topIndustries_1_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_double_donute_chart("#topIndustries_2", currentLocaleData["topIndustries_2_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_double_donute_chart("#topIndustries_3", currentLocaleData["topIndustries_3_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_double_donute_chart("#topIndustries_4", currentLocaleData["topIndustries_4_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_double_donute_chart("#topIndustries_5", currentLocaleData["topIndustries_5_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_donut_chart("#shareStem", currentLocaleData["stemWorkersImm"], mtiTranslations.immSharePopulation, "blue");
    aic_create_donut_chart("#immNaturalizedShare", currentLocaleData["immNaturalizedShare"], mtiTranslations.immNaturalizedShare, "blue");
    aic_create_donut_chart("#shareUndocumentedWorkingAge", currentLocaleData["shareUndocumentedWorkingAge"], mtiTranslations.shareUndocumentedWorkingAge, "blue");
    aic_create_donut_chart("#undoc_citizensLivingWithOneFamMemberShare", currentLocaleData["undoc_citizensLivingWithOneFamMemberShare"], mtiTranslations.undocCitizensLivingWithOneFamMemberShare, "blue");
    aic_create_donut_chart("#undoc_citizensChildrenLivingWithOneUndocFamMemberShare", currentLocaleData["undoc_citizensChildrenLivingWithOneUndocFamMemberShare"], mtiTranslations.undocCitizensChildrenLivingWithOneUndocFamMemberShare, "blue");
    aic_create_donut_chart("#undoc_citizensChildrenLivingWithOneUndocParent", currentLocaleData["undoc_citizensChildrenLivingWithOneUndocParent"], mtiTranslations.undoc_citizensChildrenLivingWithOneUndocParent, "blue");
    aic_create_donut_chart("#undoc_citizensChildrenLivingWithOneUndocParentShare", currentLocaleData["undoc_citizensChildrenLivingWithOneUndocParentShare"], mtiTranslations.undoc_citizensChildrenLivingWithOneUndocParentShare, "blue");
    aic_create_double_donute_chart("#undoc_topIndustries_1", currentLocaleData["undoc_topIndustries_1_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_double_donute_chart("#undoc_topIndustries_2", currentLocaleData["undoc_topIndustries_2_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_double_donute_chart("#undoc_topIndustries_3", currentLocaleData["undoc_topIndustries_3_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_double_donute_chart("#undoc_topIndustries_4", currentLocaleData["undoc_topIndustries_4_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_double_donute_chart("#undoc_topIndustries_5", currentLocaleData["undoc_topIndustries_5_datapoint"], currentLocaleData["immSharePopulation"]);
    aic_create_donut_chart("#shareDACALaborForceEmployed", currentLocaleData["shareDACALaborForceEmployed"], mtiTranslations.shareDACALaborForceEmployed, "blue");
    aic_create_donut_chart("#tps-shareWorkingAge", currentLocaleData["tps-shareWorkingAge"], mtiTranslations.tpsShareWorkingAge, "blue");
    aic_create_donut_chart("#tps-shareLaborForceEmployed", currentLocaleData["tps-shareLaborForceEmployed"], mtiTranslations.tpsShareLaborForceEmployed, "blue");
    aic_create_donut_chart("#refugees-shareLaborForceEmployed", currentLocaleData["refugees-shareLaborForceEmployed"], mtiTranslations.refugeesShareLaborForceEmployed, "blue");
    aic_create_donut_chart("#refugees-naturalized", currentLocaleData["refugees-naturalized"], mtiTranslations.refugeesNaturalized, "blue");
    aic_create_donut_chart("#refugees_countryOrigin_1", currentLocaleData["refugees_countryOrigin_1_datapoint"], currentLocaleData["refugees_countryOrigin_1_label"], "blue");
    aic_create_donut_chart("#refugees_countryOrigin_2", currentLocaleData["refugees_countryOrigin_2_datapoint"], currentLocaleData["refugees_countryOrigin_2_label"], "blue");
    aic_create_donut_chart("#refugees_countryOrigin_3", currentLocaleData["refugees_countryOrigin_3_datapoint"], currentLocaleData["refugees_countryOrigin_3_label"], "blue");
    aic_create_donut_chart("#refugees_countryOrigin_4", currentLocaleData["refugees_countryOrigin_4_datapoint"], currentLocaleData["refugees_countryOrigin_4_label"], "blue");
    aic_create_donut_chart("#refugees_countryOrigin_5", currentLocaleData["refugees_countryOrigin_5_datapoint"], currentLocaleData["refugees_countryOrigin_5_label"], "blue");
  }

  // Function to load bar charts to page
  function aic_load_bar_charts_to_page() {
    aic_create_bar_chart("#demo_share_immProficientEnglish", currentLocaleData["demo_share_immProficientEnglish"], "Share of Foreign-Born that are proficient in English", "#000000", "#4d4d4d", "");
    aic_create_bar_chart("#topOccupations_1", currentLocaleData["topOccupations_1_datapoint"], currentLocaleData["topOccupations_1_label"], "#000000", "#4d4d4d", "1");
    aic_create_bar_chart("#topOccupations_2", currentLocaleData["topOccupations_2_datapoint"], currentLocaleData["topOccupations_2_label"], "#3366cc", "#79a3da", "2");
    aic_create_bar_chart("#topOccupations_3", currentLocaleData["topOccupations_3_datapoint"], currentLocaleData["topOccupations_3_label"], "#bce6ed", "#d0edf3", "3");
    aic_create_bar_chart("#topOccupations_4", currentLocaleData["topOccupations_4_datapoint"], currentLocaleData["topOccupations_4_label"], "#999999", "#b2b2b2", "4");
    aic_create_bar_chart("#topOccupations_5", currentLocaleData["topOccupations_5_datapoint"], currentLocaleData["topOccupations_5_label"], "#e2e8e8", "#f1f4f4", "5");
    aic_create_bar_chart_stacked("#nursesForeign", currentLocaleData["nursesForeign"], mtiTranslations.nursesForeign);
    aic_create_bar_chart_stacked("#aidesForeign", currentLocaleData["aidesForeign"], mtiTranslations.aidesForeign);
    aic_create_bar_chart("#undoc_foreignBornShareUndoc", currentLocaleData["undoc_foreignBornShareUndoc"], mtiTranslations.undocForeignBornShareUndoc, "#000000", "#4d4d4d", "");
    aic_create_bar_chart("#undoc_totalPopShareUndocumented", currentLocaleData["undoc_totalPopShareUndocumented"], mtiTranslations.undocTotalPopShareUndocumented, "#3366cc", "#79a3da", "");
    aic_create_bar_chart("#undoc_laborForceShareUndocumented", currentLocaleData["undoc_laborForceShareUndocumented"], mtiTranslations.undocLaborForceShareUndocumented, "#bce6ed", "#d0edf3", "");
  }

  // Function to compare two datapoints and highlight the first datapoint if it is higher
  function aic_compare_stats_highlight(id1, id2) {
    var datapoint1 = parseFloat(currentLocaleData[id1].replace("%", ""));
    var datapoint2 = parseFloat(currentLocaleData[id2].replace("%", ""));
    var element1 = document.querySelector('[data-mti-datapoint="' + id1 + '"]');
    var element2 = document.querySelector('[data-mti-datapoint="' + id2 + '"]');
    if (datapoint1 > datapoint2) {
      element1.classList.add("text-color-blue");
    }
  }

  // Function to compare Educational Attainment stats and highlight accordingly -- based on logic provided by Nan & Robin
  function aic_compare_educational_stats_highlight() {
    var foreign_lessThanHighSchool = parseFloat(currentLocaleData["workforceForeignLessHighSchool"].replace("%", ""));
    var foreign_highSchoolSomeCollege = parseFloat(currentLocaleData["workforceForeignHighSchoolSomeCollege"].replace("%", ""));
    var foreign_bachelors = parseFloat(currentLocaleData["workforceForeignBachelors"].replace("%", ""));
    var foreign_graduate = parseFloat(currentLocaleData["workforceForeignGraduate"].replace("%", ""));
    var native_lessThanHighSchool = parseFloat(currentLocaleData["workforceNativeLessHighSchool"].replace("%", ""));
    var native_highSchoolSomeCollege = parseFloat(currentLocaleData["workforceNativeHighSchoolSomeCollege"].replace("%", ""));
    var native_bachelors = parseFloat(currentLocaleData["workforceNativeBachelors"].replace("%", ""));
    var native_graduate = parseFloat(currentLocaleData["workforceNativeGraduate"].replace("%", ""));
    if (native_lessThanHighSchool > foreign_lessThanHighSchool || native_graduate > foreign_graduate) {
      return true;
    } else {
      aic_compare_stats_highlight("workforceForeignLessHighSchool", "workforceNativeLessHighSchool");
      aic_compare_stats_highlight("workforceNativeHighSchoolSomeCollege", "workforceForeignHighSchoolSomeCollege");
      aic_compare_stats_highlight("workforceNativeBachelors", "workforceForeignBachelors");
      aic_compare_stats_highlight("workforceForeignGraduate", "workforceNativeGraduate");
    }
  }

  // Function to load Top Industry & Occupation labels to pie charts
  function aic_add_labels_industry_countriesOrigin_pie_charts() {
    var pie_chart_labels = document.querySelectorAll("[data-mti-pie-label]");
    pie_chart_labels.forEach(function (label) {
      var label_name = label.attributes["data-mti-pie-label"].value;
      label.setAttribute("data-mti-datapoint", label_name + "_label");
      label.innerHTML = currentLocaleData[label_name + "_label"];
      label.setAttribute("data-raw-value", label.innerText);
    });
  }
  aic_hide_subsections_no_data();
  function aic_hide_subsections_no_data() {
    var sections = document.querySelectorAll("[data-subsection]");
    var sections_array = [];
    sections.forEach(function (section) {
      sections_array.push(section.id);
    });
    sections_array.forEach(function (id) {
      var section_items = Array.from(document.querySelectorAll('[data-subsection-category="' + id + '"]'));
      if (section_items.every(_misc.aic_is_element_blank) == true) {
        // console.log(document.getElementById(id));
        document.getElementById(id).style.display = "none";
      }
    });
  }
  aic_hide_sections_no_data();
  function aic_hide_sections_no_data() {
    var sections = document.querySelectorAll("[data-anchor]");
    var sections_array = [];
    sections.forEach(function (section) {
      sections_array.push(section.id);
    });
    sections_array.forEach(function (id) {
      var section_items = Array.from(document.querySelectorAll('[data-mti-datapoint-category="' + id + '"]'));
      if (section_items.every(_misc.aic_is_element_blank) == true) {
        // console.log(document.getElementById(id));
        document.getElementById(id).style.display = "none";

        // Hide subnav link
        document.querySelector('a[href="#' + id + '"]').parentElement.style.display = "none";
      }

      // section_items.every((item) => {
      //     if (
      //         item.innerHTML == "0.0%" ||
      //         item.innerHTML == "-" ||
      //         item.innerHTML == ""
      //         // (item.nodeName == "svg" && item.innerHTML == "") ||
      //         // (item.nodeName == "P" && item.innerHTML == "")
      //     ) {
      //         document.getElementById(
      //             item.attributes["data-mti-datapoint-category"].value
      //         ).style.display = "none";
      //         console.log(item.nodeName);
      //     }
      // });
    });
  }
  function aic_create_bar_chart_stacked(selector, datapoint, label) {
    if (datapoint == "" || datapoint == undefined || datapoint == "-" || datapoint == "0.0%") {
      document.querySelector(selector).style.display = "none";
    } else {
      datapoint = numeral(datapoint).format("0.0%");
      var svgStackBar = d3.select(selector);
      var gStackBar = svgStackBar.append("g").attr("data-value", datapoint).attr("transform", "translate(" + 10 + "," + 200 + ")");
      var diamond = d3.symbol().type(d3.symbolDiamond).size(240);
      var stackBar = [[datapoint.replace("%", ""), 100 - datapoint.replace("%", "")]];

      // console.log(stackBar);

      var xStackBar = d3.scaleLinear().domain([0, 100]).range([0, 800]);
      var yStackBar = d3.scaleBand().range([0, 170]).domain(stackBar.map(function (d) {
        return d[0];
      })).padding(0.7);
      svgStackBar.selectAll(".rectBarGrey").data(stackBar).enter().append("rect").attr("x", function (d) {
        return xStackBar(d[0]);
      }).attr("y", function (d) {
        return yStackBar(d[0]) - 40;
      }).attr("width", function (d) {
        return xStackBar(d[1]);
      }).attr("height", yStackBar.bandwidth()).attr("class", "rectBarGrey").attr("fill", "grey");
      svgStackBar.selectAll(".rectStackBar").data(stackBar).enter().append("rect").attr("x", xStackBar(0) + 10).attr("y", function (d) {
        return yStackBar(d[0]) - 40;
      }).attr("width", function (d) {
        return xStackBar(d[0]);
      }).attr("height", yStackBar.bandwidth()).attr("class", "rectStackBar").attr("fill", "#3366cc");
      gStackBar.selectAll("g").data(stackBar).enter().append("path").attr("d", diamond).attr("fill", "#3366cc").attr("transform", function (d) {
        return "translate(" + xStackBar(0) + "," + (yStackBar(d[0]) - 226) + ")";
      });
      svgStackBar.selectAll(".mStackDiamond").data(stackBar).enter().append("path").attr("d", diamond).attr("fill", "grey").attr("class", "mStackDiamond").attr("transform", function (d) {
        return "translate(" + (xStackBar(d[0]) + 10) + "," + (yStackBar(d[0]) - 26) + ")";
      });
      svgStackBar.selectAll(".eStackDiamond").data(stackBar).enter().append("path").attr("d", diamond).attr("fill", "#9B9EA0").attr("class", "eStackDiamond").attr("transform", function (d) {
        return "translate(" + xStackBar(100) + "," + (yStackBar(d[0]) - 26) + ")";
      });
      svgStackBar.append("text").attr("x", xStackBar(0) + 10).attr("y", 15).attr("class", "occTitle").attr("fill", "#000000").style("text-anchor", "left").style("font-family", "Karla, sans-serif")
      // .attr("transform", function(d){return "translate("+(xBar(0)-420)+","+(yBar(d[0])-230)+")"})
      .style("font-size", "20px").attr("data-raw-value", label).text(label);
      var dataMtiDatapoint = selector.substring(1);
      svgStackBar.selectAll(".shareTitle").data(stackBar).enter().append("text").attr("x", function (d) {
        return xStackBar(d[0]) + 35;
      }).attr("y", function (d) {
        return yStackBar(d[0]) - 20;
      }).attr("class", "shareTitle").attr("fill", "#ffffff").style("text-anchor", "middle").style("font-family", "Karla, sans-serif").style("letter-spacing", "-1px")
      // .attr("transform", function(d){return "translate("+(xBar(d[1]))+","+(yBar(d[0]))+")"})
      .style("font-size", "20px").attr("data-mti-datapoint", dataMtiDatapoint).attr("data-raw-value", function (d) {
        return d[0] + "%";
      }).text(function (d) {
        return d[0] + "%";
      });
    }
  }
  function aic_create_bar_chart(selector, datapoint, label, barColor, diamondColor, number) {
    if (document.querySelector(selector) == null) {
      return;
    } else {
      if (datapoint == undefined || datapoint.length == 0 || datapoint == "0.0%" || datapoint == "" || datapoint == "-") {
        document.querySelector(selector).style.display = "none";
      } else {
        datapoint = numeral(datapoint).format("0.0%");
        // If mobile device, change viewbox height
        if (screen.width < 600 && document.querySelector(selector) != null) {
          document.querySelector(selector).attributes.viewBox.value = "0 0 1000 80";
        }
        var matrixBar = [[label, datapoint.replace("%", "")]];
        var marginBar = {
            top: 50,
            right: 50,
            bottom: 50,
            left: 50
          },
          widthBar = 1000 - marginBar.left - marginBar.right,
          heightBar = 500 - marginBar.top - marginBar.bottom;
        var svgBar = d3.select(selector);
        var gBar = svgBar.append("g").attr("transform", "translate(" + widthBar / 2 + "," + 80 + ")");

        //Global variables for the bar chart
        var diamond = d3.symbol().type(d3.symbolDiamond).size(240);
        var xBar = d3.scaleLinear().domain([0, 100]).range([0, widthBar]);
        var yBar = d3.scaleBand().range([0, heightBar]).domain(matrixBar.map(function (d) {
          return d[0];
        })).padding(0.6);

        //Bars
        svgBar.selectAll("rect").data(matrixBar).enter().append("rect").attr("x", xBar(0) + 10).attr("y", function () {
          if (screen.width < 600) {
            return 50;
          } else {
            return 30;
          }
        }).attr("width", function (d) {
          return xBar(d[1]);
        }).attr("height", function () {
          if (screen.width < 600) {
            return 50;
          } else {
            return 28;
          }
        }).attr("class", "rectBar").attr("fill", barColor);
        gBar.selectAll("rect").data(matrixBar).enter().append("path").attr("d", diamond).attr("fill", barColor).attr("transform", function (d) {
          if (screen.width < 600) {
            return "translate(" + (xBar(0) - 440) + "," + (yBar(d[0]) - 166) + ")";
          } else {
            return "translate(" + (xBar(0) - 440) + "," + (yBar(d[0]) - 186) + ")";
          }
        });
        var dataMtiDatapointLabel = selector.substring(1) + "_label";
        svgBar.selectAll("text").data(matrixBar).enter().append("text").attr("x", 0).attr("y", function () {
          if (screen.width < 600) {
            return 30;
          } else {
            return 20;
          }
        }).attr("data-mti-datapoint", dataMtiDatapointLabel).attr("class", "occTitle").attr("fill", "#000000").attr("data-raw-value", function (d) {
          return d[0];
        }).style("text-anchor", "left").style("font-family", "Karla, sans-serif").style("font-size", function () {
          if (screen.width < 600) {
            return "40px";
          } else {
            return "20px";
          }
        }).html(function (d) {
          if (number == "" || number == undefined) {
            return d[0];
          } else {
            return '<tspan class="fw-bold">#' + number + "</tspan> " + d[0];
          }
        });
        var dataMtiDatapoint = selector.substring(1);
        svgBar.selectAll(".shareTitle").data(matrixBar).enter().append("text").attr("data-mti-datapoint", dataMtiDatapoint).attr("data-raw-value", function (d) {
          return d[1] + "%";
        }).attr("x", function (d) {
          if (screen.width < 600) {
            return xBar(d[1]) + 75;
          } else {
            return xBar(d[1]) + 60;
          }
        }).attr("y", function () {
          if (screen.width < 600) {
            return 75;
          } else {
            return 50;
          }
        }).attr("class", "shareTitle").attr("fill", "#000000").style("text-anchor", "middle").style("font-family", "Karla, sans-serif").style("letter-spacing", "-1px").style("font-size", function () {
          if (screen.width < 600) {
            return "40px";
          } else {
            return "20px";
          }
        }).text(function (d) {
          return d[1] + "%";
        });
        svgBar.selectAll(".eDiamond").data(matrixBar).enter().append("path").attr("d", diamond).attr("fill", diamondColor).attr("class", "eDiamond").attr("transform", function (d) {
          if (screen.width < 600) {
            return "translate(" + (xBar(d[1]) + 10) + "," + 64 + ")";
          } else {
            return "translate(" + (xBar(d[1]) + 10) + "," + 44 + ")";
          }
        });
      }
    }
  }
  function aic_create_double_donute_chart(selector, datapointInnerRing, datapointOuterRing) {
    if (datapointInnerRing == "0.0%" || datapointInnerRing === "" || datapointInnerRing == undefined || datapointInnerRing == "-") {
      return;
    } else {
      datapointOuterRing = numeral(datapointOuterRing).format("0.0%");
      datapointInnerRing = numeral(datapointInnerRing).format("0.0%");
      // console.log(datapointInnerRing);
      var margin = {
          top: 10,
          right: 10,
          bottom: 20,
          left: 10
        },
        width = 500 - margin.left - margin.right,
        height = 500 - margin.top - margin.bottom;
      var svgRings = d3.select(selector);
      var gRings = svgRings.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
      var gRings2 = svgRings.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
      var radius = Math.min(width, height) / 2;
      if (typeof d3.arc === "function") {
        var path = d3.arc().outerRadius(radius - 10).innerRadius(175);

        //Need to create a separate "path" for the inner ring

        var pathRingI = d3.arc().outerRadius(170).innerRadius(120);

        //other values

        var shareValue;
        var nonShare;
        var stemValue;
        var nonStem;
        var donutData;

        //setting global values for InnerRing
        var valRingI;
        var nonvalRingI;

        //Remove any percentage signs from datapoints
        datapointOuterRing = datapointOuterRing.replace("%", "");
        datapointInnerRing = datapointInnerRing.replace("%", "");

        //Outer ring
        shareValue = datapointOuterRing;
        nonShare = 100 - datapointOuterRing;

        //inner Ring for Double Ring
        valRingI = datapointInnerRing;
        nonvalRingI = 100 - datapointInnerRing;
        var pieRingOuter = d3.pie().sort(null)([shareValue, nonShare]);
        var pieRingInner = d3.pie().sort(null)([valRingI, nonvalRingI]);
        var arcRingO = gRings.selectAll(".arcRing").data(pieRingOuter).enter().append("g").attr("class", "arcRing");
        var arcRingI = gRings.selectAll(".arcRing2").data(pieRingInner).enter().append("g").attr("class", "arcRing2");
        arcRingO.append("path").attr("d", path).attr("fill", function (d) {
          if (d.index == 0) {
            return "#000000";
          } else {
            return "#E8EDED";
          }
        });
        arcRingI.append("path").attr("d", pathRingI).attr("fill", function (d) {
          if (d.index == 0) {
            return "#3366cc";
          } else {
            return "#E8EDED";
          }
        });
        var dataMtiDatapoint = selector.substring(1);
        svgRings.append("text").attr("x", width / 2 + 10).attr("y", height / 2 + 20).attr("class", "shareText").attr("data-raw-value", valRingI + "%").attr("data-mti-datapoint", dataMtiDatapoint + "_datapoint").style("fill", "#3366cc").style("font-weight", "500").style("letter-spacing", "-1px").style("font-size", "72px").style("text-anchor", "middle").style("font-family", "Karla,sans-serif").text(valRingI + "%");
      }
    }
  }
  function aic_create_donut_chart(selector, datapoint, label, color) {
    // console.log(selector, datapoint);
    if (datapoint === "" || datapoint == "%" || datapoint == "0.0%" || datapoint == "-") {
      if (document.querySelector(selector) != null) {
        // console.log("This one is being removed" + selector, datapoint);
        document.querySelector(selector).parentNode.parentNode.parentNode.style.display = "none";
      }
    } else {
      if (typeof datapoint == "number") {
        datapoint = datapoint.toString();
      }
      datapoint = numeral(datapoint).format("0.0%");
      // Set variables
      var margin = {
          top: 10,
          right: 10,
          bottom: 20,
          left: 10
        },
        width = 500 - margin.left - margin.right,
        height = 500 - margin.top - margin.bottom;
      var svg = d3.select(selector);
      svg.attr("aria-label", "Temperature on Monday: 72 degrees").attr("role", "img");
      var g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
      var radius = Math.min(width, height) / 2;
      var textColor = "#000000";
      if (color == "blue") {
        textColor = "#3366cc";
      }
      if (color == "black") {
        textColor = "#000000";
      }
      if (typeof d3.arc === "function") {
        var path = d3.arc().outerRadius(radius - 10).innerRadius(175);
        var circleData;
        circleData = datapoint.replace("%", "");
        if (circleData != undefined) {
          var circle = d3.pie().sort(null)([circleData, 100 - circleData]);
          var arc = g.selectAll(".arc").data(circle).enter().append("g").attr("class", "arc");
          arc.append("path").attr("d", path).attr("fill", function (d) {
            if (d.index == 0) {
              return "#3366cc";
            } else {
              return "#e2e7e6";
            }
          });
        }
      }
      var dataMtiDatapoint = selector.substring(1);
      if (typeof datapoint === "string" && datapoint == "0.0%" || typeof datapoint === "string" && datapoint == "") {
        svg.selectAll(".shareText").data(circle).enter().append("text").attr("x", width / 2 + 10).attr("y", height / 2 + 20).attr("class", "shareText").style("fill", textColor).style("font-weight", "500").style("letter-spacing", "-1px").style("font-size", "40px").style("text-anchor", "middle").style("font-family", "Karla,sans-serif").attr("data-mti-datapoint", dataMtiDatapoint).text("-");
      } else {
        svg.append("text").attr("x", width / 2 + 10).attr("y", height / 2 + 20).attr("class", "shareText").style("fill", textColor).style("font-size", "80px").style("text-anchor", "middle").style("font-family", "Karla,sans-serif").style("letter-spacing", "-1px").style("font-weight", "500").attr("data-mti-datapoint", dataMtiDatapoint).attr("data-raw-value", circleData + "%").text(circleData + "%");
      }
    }
  }
}
(0, _misc.nae_load_state_section_subnav)();
(0, _social.mti_show_copy_link_text)();
(0, _social.mti_copy_link)();
if (window.location.href.indexOf("/es/") != -1) {
  (0, _pdf.mti_generate_pdf_es)();
} else if (window.location.href.indexOf("/city/") != -1) {
  (0, _pdf.mti_generate_pdf_msa)();
} else {
  (0, _pdf.mti_generate_pdf_en)();
}

},{"./_config.js":21,"./_misc.js":22,"./_numerals.js":23,"./_pdf":24,"./_social.js":25,"./_state_svg.js":26,"@wordpress/i18n/build/default-i18n.js":18}]},{},[27]);
